import React from 'react';
import Units from '../../components/util/units';
//import PropTypes from 'prop-types';
//import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { notification } from 'antd';

import Button from '@material-ui/core/Button';
import jszip from 'jszip';

import IconButton from '@material-ui/core/IconButton';
import SearchIcon from "@material-ui/icons/Search";
import Tab from '../../components/Tab/tab';
//import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import MenuList from '@material-ui/core/Menu';

import geo from '../../components/util/geo';

import saveAs from 'file-saver';
import Config from '../../constants/appConfig';
import MaterialIcon from '../../components/MaterialIcon';
import SvgIcon from '@material-ui/core/SvgIcon';

import L from 'leaflet';
import 'leaflet-draw';

import Checkbox from '@material-ui/core/Checkbox';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import SPW from "string-pixel-width";

import tools from '../../components/util/tools';
import { getSuggestedMergeSize } from '../../utils/mergeDistance';
import sortByName from '../../utils/sortByName';
import { useParams } from "react-router";

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";

import ListFilter from '../../components/ImportFile/wizard';
//import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import EditProperty from '../client/property/Edit';
import Dialog from '@material-ui/core/Dialog';

import TurfOverlap from '@turf/boolean-overlap';
import TurfContains from '@turf/boolean-contains';
import * as turf from '@turf/turf';
import { ListItemIcon } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import RoomIcon from '@material-ui/icons/Room';

import pinWaypoint from '../../assets/images/marker/waypoint/pin.png';
import markerIconGreen from '../../assets/images/marker/waypoint/marker-icon-green.png';
import HangarIcon from '../../assets/images/marker/waypoint/hangar.png';
import iconA from '../../assets/images/marker/a.svg';
import iconB from '../../assets/images/marker/b.svg';

class polygon {
    constructor() {
        this.id = null;
        this.id_region = null;
        this.guid = '';
        this.name = '';
        this.area = 0;
        this.radius = 0;
        this.point = '';
        this.points = '';
        this.svg = '';
        this.x = '';
        this.old = null;
        this.type = '';
        this.ab = null;
        this.visible = false;
        this.has_overlap = false;
        this.custom_color = '';
    }
}

// Native controls keep the long list lightweight. Material UI's ListItem adds
// several wrapper components and event handlers for every area.
const AreaPolygonRow = React.memo(({ area, from, level, orderNumber, hasSelection, color, name, visible, svg, hasOverlap, map, onVisible }) => {
    const isSelected = !!orderNumber;

    return (
        <div
            className={'area-polygon-row' + (isSelected ? ' area-polygon-row-selected' : '')}
            data-area-guid={area.guid}
            ref={node => {
                if (onVisible) onVisible(area, node);
            }}
        >
            <span className={'area-polygon-indent' + (level > 0 ? ' area-polygon-indent-child' : '')}></span>

            <button
                type="button"
                className="area-polygon-main"
                onClick={() => map.handleListItemClick(area.guid, from)}
                title={name}
            >
                {(orderNumber || svg) &&
                    <span className={'area-polygon-preview' + (svg ? ' area-polygon-preview-svg' : '')}>
                        {orderNumber
                            ? <span className="area-polygon-order">{String(orderNumber)}</span>
                            : null
                        }
                        {svg
                            ? <svg viewBox="-1 0 12 12" aria-hidden="true">
                                <path
                                    stroke={hasOverlap ? '#1565c0' : (isSelected ? map.color_selected : color)}
                                    strokeWidth=".5"
                                    fill={hasOverlap ? '#1565c0' : (isSelected ? map.color_selected : color)}
                                    fillOpacity={hasOverlap ? "0.35" : "0.2"}
                                    d={svg}
                                />
                            </svg>
                            : null
                        }
                    </span>
                }
                <span className="area-polygon-name">{map.limitChar(name, 300)}</span>
            </button>

            <button
                type="button"
                className="area-polygon-action"
                title={name}
                onClick={event => map.handleVisibilityClickBusy(event, area, 'poly')}
            >
                {visible
                    ? <i className="material-icons area-polygon-action-icon area-polygon-visible">visibility</i>
                    : <i className="material-icons area-polygon-action-icon">visibility_off</i>
                }
            </button>

            <button
                type="button"
                className={'area-polygon-action' + (hasSelection && !isSelected ? ' area-polygon-action-disabled' : '')}
                onClick={event => map.setState({ anchorEl: event.currentTarget, areaPup: area, type_menu: 'polygon' })}
                title={name}
                disabled={hasSelection && !isSelected}
            >
                <span className="area-polygon-more">...</span>
            </button>
        </div>
    );
});

class EditDraw extends React.Component {
    tabID = [
        'polygons',
        'areas_client'
    ];
    mapRenderPreferenceStorageKey = 'job-draw-map-render-preference';
    state = {
        anchorEl: null,
        clients: [],
        planes: [],
        selectedSendPlanes: [],
        [this.tabID[1]]: [],
        fazenda_client: [],
        fazenda_clientPup: [],
        id_propertyPup: 0,
        foldersPup: [],
        id_folderPup: 0,
        visibleAll: 1,
        areaPup: null,
        id_clientPup: 0,
        id_client: 0,
        showForm: false,
        id_property: null,
        tab: '0',
        filtro: '',
        listSearch: [],
        search_text: '',
        search_token: '',
        name: '',
        local: this.props.local,
        [this.tabID[0]]: [],
        sel_poly: [],
        sel_merge: false,
        sel_t: false,
        sel_x: false,
        create: false,
        edit: false,
        delete: false,
        nameP: '',
        valid_nameP: true,
        merge: false,
        split: false,
        showTrim: false,
        type: 2,
        goto: false,
        edit_name: false,
        lat: {
            value: '',
            error: false,
            input: ''
        },
        lng: {
            value: '',
            error: false,
            input: ''
        },
        new_error: true,
        gap_size: 10,
        trim_size: 50,


        //progress: false,
        showImport: false,
        itensImport: [],
        namesC: [],
        showWaypointTypes: false,
        create_waypoint: false,
        waypointType: '',
        waypointName: '',

        ruler_a: false,
        manualAbOpen: false,
        manualAbAngle: 0,
        manualAbGuid: null,
        label: true,
        label_text: '',
        home: Config.place,
        disable: false,
        typeUser: [],

        selector: false,
        cPoly: true,
        sPoly: true,

        anchorMN: null,
        anchorPL: null,
        anchorAPO: null,
        typeTool: 'create',
        nameR: '',
        trim_size: 50,//metros
        type_trim: 'in',
        sel_trim: 'poly',
        sel_oper: 'new',

        polygons: [],
        folders: [],
        type_menu: null,
        folders_properties: [],
        coordMode: 'dms',

        showColorPicker: false,
        colorEditingGuid: '',
        colorDraft: '',
        colorTargetType: 'area',
        colorTargetGuids: [],
        colorPreviousColors: {},

        loadingClientData: false,
        loadingAreaSummaries: false,
        savingImportedAreas: false,
        downloading: false,
        downloadProgress: null,
        downloadStatus: '',
        mapRenderPreference: this.getStoredMapRenderPreference(),
        listRenderLimit: 400,
        visibilityLoadingKey: '',

        runways: [],
        sel_runways: [],
        openModules: false,
        showOverlaps: null,
    };
    trim_line = [];

    tabItens = [
        { label: this.props.res.SEM_VINCULO, value: '0' },//this.props.res.LOCALATUAL
        { label: this.props.res.CLIENTE, value: '1' },
    ]
    clickItem = false;
    downloadInProgress = false;
    past_merge = false;
    ruler_p = { first: { lat: null, lng: null }, second: { lat: null, lng: null } };
    upType = 'P';
    lastType = 2;

    markClick = false;
    featureGroupP = null;
    featureGroupCluster = null;
    featureGroupM = null;
    featureGroupPoly = null;
    lazyPolygonRenderer = null;
    drawControl = null;
    drawCreateToolbar = null;
    drawEditToolbar = null;
    drawDeleteToolbar = null;
    r = null;
    i = 0;
    polyindex = 0;
    text_polygon = 'new poly ';
    polyClick = false;
    sel_save = [];

    manualAbPrevious = null;
    selectedAbLayers = new Map();
    importWorker = null;
    importBatchSize = 75;
    importSaveBatchSize = 50;
    importClusterZoom = 12;
    importingGuids = new Set();
    isImporting = false;
    clusterSyncFrame = null;
    lazyViewportFrame = null;
    lazyViewportToken = 0;
    lazyGeometryCache = new Map();
    lazyGeometryRequests = new Map();
    lazyRenderedGuids = new Set();
    lazyRenderedLayers = new Map();
    lazyRenderFrame = null;
    // Large polygons are expensive to parse and add to Leaflet. Keep each
    // animation-frame batch small so a completed pan stays interactive.
    lazyGeometryRenderBatchSize = 6;
    lazyPreviewPending = false;
    summaryPageSize = 200;
    summaryPagers = {
        polygons: { id: 0, offset: 0, hasMore: false, loading: false, version: 0, timer: null, pagesSinceMapRefresh: 0, pendingSummaries: [] },
        areas_client: { id: 0, offset: 0, hasMore: false, loading: false, version: 0, timer: null, pagesSinceMapRefresh: 0, pendingSummaries: [] }
    };
    selectionIndexItems = null;
    selectionIndex = null;
    listPreviewRefreshFrame = null;
    areaListIsActive = false;
    listPreviewKeys = new Set();
    areaListScrollNode = null;
    listGeometryObserver = null;
    listPolygonNodes = new Map();
    listGeometryQueue = new Set();
    listGeometryFrame = null;
    filterTimer = null;
    filterInputNode = null;
    filterInputValue = '';
    polygonNameCache = new WeakMap();
    selectablePolygonsCache = null;
    polygonFolderIndexCache = null;
    propertyPolygonIndexCache = null;
    filteredPropertiesCache = null;
    mapCenterLatNode = null;
    mapCenterLngNode = null;

    itens_import = [];

    color_default = '#2F80ED';
    color_selected = '#E67E22';
    color_x = '#ff002b';
    color_edit = '#3388ff';
    color_t = '#EAB711';
    minTooltipZoom = 13;
    lightLazyGeometryZoom = 14;
    lightLazyGeometryRenderLimit = 350;
    mediumLazyGeometryZoom = 13;
    mediumLazyGeometryRenderLimit = 700;
    heavyLazyGeometryZoom = 11;
    heavyLazyGeometryRenderLimit = 1400;
    lazyGeometryRequestLimit = 250;
    canvasDisplayZonePadding = 25;

    recalculateOverlap = false;
    overlapPreferenceStorageKey = null;
    overlapPreferenceChanged = false;

    getStoredMapRenderPreference() {
        try {
            const preference = window.localStorage.getItem(this.mapRenderPreferenceStorageKey);
            if (preference === 'heavy' || preference === 'medium' || preference === 'light') return preference;

            // Preserve the preference selected before the level names changed.
            return preference === 'convenience' ? 'medium' : 'light';
        } catch (e) {
            return 'light';
        }
    }

    getLazyGeometryZoom = () => {
        if (this.state.mapRenderPreference === 'heavy') return this.heavyLazyGeometryZoom;
        if (this.state.mapRenderPreference === 'medium') return this.mediumLazyGeometryZoom;
        return this.lightLazyGeometryZoom;
    };

    getLazyGeometryRenderLimit = () => {
        if (this.state.mapRenderPreference === 'heavy') return this.heavyLazyGeometryRenderLimit;
        if (this.state.mapRenderPreference === 'medium') return this.mediumLazyGeometryRenderLimit;
        return this.lightLazyGeometryRenderLimit;
    };

    setMapRenderPreference = (preference) => {
        if (preference !== 'light' && preference !== 'medium' && preference !== 'heavy') return;

        try {
            window.localStorage.setItem(this.mapRenderPreferenceStorageKey, preference);
        } catch (e) { }

        this.setState({ mapRenderPreference: preference, anchorAPO: null }, () => {
            this.requestLazyViewportRefresh();
        });
    };

    isClusterMode = () => {
        return this.mymap && this.mymap.getZoom() < this.minTooltipZoom;
    };

    getPolygonIndexByGuid = () => {
        const polygonIndex = new Map();
        const addPolygons = polygons => {
            for (let i = 0; i < polygons.length; i++) {
                const polygon = polygons[i];
                if (polygon && polygon.guid) polygonIndex.set(polygon.guid, polygon);
            }
        };

        addPolygons(this.state.polygons);
        addPolygons(this.state.areas_client);
        return polygonIndex;
    };

    isPolygonVisibleByGuid = (guid, polygonIndex) => {
        if (!guid) return true;
        if (this.importingGuids.has(guid)) return true;

        const poly = (polygonIndex || this.getPolygonIndexByGuid()).get(guid);

        return poly ? !!poly.visible : true;
    };

    isManagedPolygonLayer = (layer, polygonIndex) => {
        if (!layer) return false;
        const guid = layer._leaflet_id;
        if (!guid) return false;
        if (this.importingGuids.has(guid)) return true;
        return (polygonIndex || this.getPolygonIndexByGuid()).has(guid);
    };

    getCanvasDisplayZone = () => {
        if (!this.mymap) return null;
        const bounds = this.mymap.getBounds();
        if (!bounds || !bounds.isValid || !bounds.isValid()) return null;

        const zone = bounds.pad(this.canvasDisplayZonePadding);
        return (zone && zone.isValid && zone.isValid()) ? zone : bounds;
    };

    isLayerFarFromCanvasZone = (layer, canvasZone) => {
        if (!this.mymap || !layer) return false;

        const zone = canvasZone || this.getCanvasDisplayZone();
        if (!zone) return false;

        const center = this.getLayerCenter(layer);
        if (!center) return false;

        return !zone.contains(center);
    };

    shouldClusterLayer = (layer, polygonIndex, canvasZone) => {
        if (!this.isManagedPolygonLayer(layer, polygonIndex)) return false;
        if (!this.isPolygonVisibleByGuid(layer._leaflet_id, polygonIndex)) return false;
        if (this.isClusterMode()) return true;
        return this.isLayerFarFromCanvasZone(layer, canvasZone);
    };

    shouldShowPolygonTooltip = (layer, polygonIndex, canvasZone, shouldCluster) => {
        if (!this.mymap || this.mymap.getZoom() < this.minTooltipZoom) return false;
        if (!layer) return true;
        const isClustered = typeof shouldCluster === 'boolean'
            ? shouldCluster
            : this.shouldClusterLayer(layer, polygonIndex, canvasZone);
        if (isClustered) return false;

        const guid = layer._leaflet_id;
        return this.isPolygonVisibleByGuid(guid, polygonIndex);
    };

    setLayerTooltipVisibility = (layer, visible) => {
        if (!this.mymap || !layer || !layer.getTooltip) return;
        if (layer._lazyHoverTooltip) return;

        const tooltip = layer.getTooltip();
        if (!tooltip) return;

        if (visible) {
            if (layer.openTooltip) {
                layer.openTooltip();
            }
        } else {
            if (layer.closeTooltip) {
                layer.closeTooltip();
            }
            if (this.mymap.hasLayer(tooltip)) {
                try {
                    this.mymap.removeLayer(tooltip);
                } catch (e) { };
            }
        }
    };

    updatePolygonTooltipsVisibility = (polygonIndex, canvasZone, clusterStates) => {
        if (!this.featureGroupP || !this.mymap) return;

        const candidates = [];
        this.featureGroupP.eachLayer((layer) => {
            if (!layer || layer._lazyHoverTooltip) return;
            const shouldCluster = clusterStates && clusterStates.has(layer)
                ? clusterStates.get(layer)
                : undefined;
            const visible = this.shouldShowPolygonTooltip(layer, polygonIndex, canvasZone, shouldCluster);
            if (!visible) {
                this.setLayerTooltipVisibility(layer, false);
                return;
            }

            const center = this.getLayerCenter(layer);
            const tooltip = layer.getTooltip && layer.getTooltip();
            if (!center || !tooltip) {
                this.setLayerTooltipVisibility(layer, visible);
                return;
            }

            candidates.push({ layer, center, tooltip });
        });

        // Permanent Leaflet tooltips do not avoid one another. Use a small
        // spatial index to find only labels close to the current one, then
        // check their real bounds. This avoids the coarse-grid behaviour that
        // was hiding labels which were near each other but not overlapping.
        const boxesByCell = new Map();
        const visibleLabels = new Set();
        const cellWidth = 64;
        const cellHeight = 28;
        const labelHeight = 20;
        const labelPadding = 3;
        const zoom = this.mymap.getZoom();

        for (let i = 0; i < candidates.length; i++) {
            const candidate = candidates[i];
            const projected = this.mymap.project(candidate.center, zoom);
            const content = candidate.tooltip.getContent ? candidate.tooltip.getContent() : '';
            const label = typeof content === 'string' ? content : '';
            let labelWidth = candidate.layer._tooltipLabelWidth;
            if (candidate.layer._tooltipLabelWidthText !== label || !labelWidth) {
                labelWidth = 40;
                try {
                    labelWidth = Math.min(260, Math.max(40, SPW(label, { font: 'Arial', size: 16 }) + 16));
                } catch (e) { }
                candidate.layer._tooltipLabelWidthText = label;
                candidate.layer._tooltipLabelWidth = labelWidth;
            }

            const box = {
                left: projected.x - labelWidth / 2 - labelPadding,
                right: projected.x + labelWidth / 2 + labelPadding,
                top: projected.y - labelHeight / 2 - labelPadding,
                bottom: projected.y + labelHeight / 2 + labelPadding
            };
            const minX = Math.floor(box.left / cellWidth);
            const maxX = Math.floor(box.right / cellWidth);
            const minY = Math.floor(box.top / cellHeight);
            const maxY = Math.floor(box.bottom / cellHeight);
            const cells = [];
            let hasCollision = false;
            const checkedBoxes = new Set();

            for (let x = minX; x <= maxX; x++) {
                for (let y = minY; y <= maxY; y++) {
                    const key = x + '_' + y;
                    cells.push(key);
                    const nearbyBoxes = boxesByCell.get(key);
                    if (!nearbyBoxes) continue;
                    for (let boxIndex = 0; boxIndex < nearbyBoxes.length; boxIndex++) {
                        const nearbyBox = nearbyBoxes[boxIndex];
                        if (checkedBoxes.has(nearbyBox)) continue;
                        checkedBoxes.add(nearbyBox);
                        if (box.left < nearbyBox.right && box.right > nearbyBox.left &&
                            box.top < nearbyBox.bottom && box.bottom > nearbyBox.top) {
                            hasCollision = true;
                            break;
                        }
                    }
                    if (hasCollision) break;
                }
                if (hasCollision) break;
            }

            if (hasCollision) continue;
            for (let cellIndex = 0; cellIndex < cells.length; cellIndex++) {
                const key = cells[cellIndex];
                const cellBoxes = boxesByCell.get(key);
                if (cellBoxes) cellBoxes.push(box);
                else boxesByCell.set(key, [box]);
            }
            visibleLabels.add(candidate.layer._leaflet_id);
        }

        for (let i = 0; i < candidates.length; i++) {
            const layer = candidates[i].layer;
            this.setLayerTooltipVisibility(layer, visibleLabels.has(layer._leaflet_id));
        }
    };

    getLayerCenter = (layer) => {
        if (!layer) return null;
        if (layer.getLatLng && typeof layer.getLatLng === 'function') return layer.getLatLng();
        if (layer.getBounds && typeof layer.getBounds === 'function') {
            const bounds = layer.getBounds();
            if (bounds && bounds.isValid && bounds.isValid()) return bounds.getCenter();
        }
        if (layer.getLatLngs && layer.getLatLngs()[0]) {
            const temp = L.polygon(layer.getLatLngs()[0]);
            if (temp.getBounds && temp.getBounds().isValid()) return temp.getBounds().getCenter();
        }
        return null;
    };

    togglePolygonLayerElement = (layer, visible, polygonIndex) => {
        if (!layer || !this.isManagedPolygonLayer(layer, polygonIndex)) return;
        if (layer.options && layer.options.renderer === this.lazyPolygonRenderer) return;
        const el = layer.getElement ? layer.getElement() : null;
        if (el) {
            el.style.display = visible ? '' : 'none';
            if (this.state.sel_poly.includes(layer._leaflet_id)) this.syncSelectedAb(true);
        }
    };

    clearPolygonClusters = () => {
        if (!this.featureGroupCluster) return;
        this.featureGroupCluster.clearLayers();
    };

    buildPolygonClusters = (polygonIndex, canvasZone, clusterStates) => {
        if (!this.mymap || !this.featureGroupP || !this.featureGroupCluster) return;

        const gridSize = 80;
        const zoom = this.mymap.getZoom();
        const clusters = {};

        this.featureGroupP.eachLayer((layer) => {
            const shouldCluster = clusterStates && clusterStates.has(layer)
                ? clusterStates.get(layer)
                : this.shouldClusterLayer(layer, polygonIndex, canvasZone);
            if (!shouldCluster) return;

            const center = this.getLayerCenter(layer);
            if (!center) return;

            const point = this.mymap.project(center, zoom);
            const cellX = Math.floor(point.x / gridSize);
            const cellY = Math.floor(point.y / gridSize);
            const key = cellX + '_' + cellY;

            if (!clusters[key]) {
                clusters[key] = {
                    count: 0,
                    latSum: 0,
                    lngSum: 0,
                    guids: [],
                    bounds: L.latLngBounds([])
                };
            }

            clusters[key].count += 1;
            clusters[key].latSum += center.lat;
            clusters[key].lngSum += center.lng;
            clusters[key].guids.push(layer._leaflet_id);
            clusters[key].bounds.extend(center);
            if (layer.getBounds && typeof layer.getBounds === 'function') {
                const layerBounds = layer.getBounds();
                if (layerBounds && layerBounds.isValid && layerBounds.isValid()) {
                    clusters[key].bounds.extend(layerBounds);
                }
            }
        });

        Object.keys(clusters).forEach((key) => {
            const cluster = clusters[key];
            if (cluster.count <= 0) return;

            const center = L.latLng(cluster.latSum / cluster.count, cluster.lngSum / cluster.count);
            const iconSize = cluster.count >= 100 ? 50 : 44;
            const radius = iconSize / 2 - 2;

            const icon = L.divIcon({
                className: '',
                html: '<svg width="' + iconSize + '" height="' + iconSize + '" viewBox="0 0 ' + iconSize + ' ' + iconSize + '">' +
                    '<circle cx="' + (iconSize / 2) + '" cy="' + (iconSize / 2) + '" r="' + radius + '" fill="#2f6f88" stroke="#ffffff" stroke-width="2" />' +
                    '<text x="50%" y="50%" text-anchor="middle" dominant-baseline="middle" font-family="Arial" font-size="' + (cluster.count >= 100 ? 14 : 16) + '" fill="#ffffff" font-weight="700">' + cluster.count + '</text>' +
                    '</svg>',
                iconSize: [iconSize, iconSize],
                iconAnchor: [iconSize / 2, iconSize / 2]
            });

            const marker = L.marker(center, { icon: icon });
            marker.areaGuids = cluster.guids;
            marker.on('click', () => {
                if (cluster.count === 1) {
                    this.mymap.setView(center, this.minTooltipZoom + 1);
                } else if (cluster.bounds && cluster.bounds.isValid && cluster.bounds.isValid()) {
                    this.mymap.fitBounds(cluster.bounds.pad(0.15));
                }
            });
            marker.addTo(this.featureGroupCluster);
        });
    };

    syncPolygonClusters = () => {
        if (!this.mymap || !this.featureGroupP) return;

        if (this.hasLazyAreaMetadata()) {
            this.requestLazyViewportRefresh();
            return;
        }

        if (this.clusterSyncFrame !== null) {
            window.cancelAnimationFrame(this.clusterSyncFrame);
            this.clusterSyncFrame = null;
        }

        const polygonIndex = this.getPolygonIndexByGuid();
        const canvasZone = this.isClusterMode() ? null : this.getCanvasDisplayZone();
        const clusterStates = new Map();

        this.featureGroupP.eachLayer((layer) => {
            if (!layer) return;
            const shouldCluster = this.shouldClusterLayer(layer, polygonIndex, canvasZone);
            clusterStates.set(layer, shouldCluster);
            this.togglePolygonLayerElement(layer, !shouldCluster, polygonIndex);
        });

        this.clearPolygonClusters();
        this.buildPolygonClusters(polygonIndex, canvasZone, clusterStates);
        this.updatePolygonTooltipsVisibility(polygonIndex, canvasZone, clusterStates);
    };

    requestPolygonClusterSync = () => {
        if (this.hasLazyAreaMetadata()) {
            this.requestLazyViewportRefresh();
            return;
        }

        if (this.clusterSyncFrame !== null) return;

        this.clusterSyncFrame = window.requestAnimationFrame(() => {
            this.clusterSyncFrame = null;
            this.syncPolygonClusters();
        });
    };

    getMapAreaCenter = (area) => {
        if (!area) return null;

        const hasStoredCenter = area.center_lat !== null && area.center_lat !== undefined && area.center_lat !== '' &&
            area.center_lng !== null && area.center_lng !== undefined && area.center_lng !== '';
        const lat = Number(area.center_lat);
        const lng = Number(area.center_lng);
        if (hasStoredCenter && Number.isFinite(lat) && Number.isFinite(lng)) return L.latLng(lat, lng);

        if (area.point && Array.isArray(area.point) && area.point.length >= 2) {
            const pointLat = Number(area.point[0]);
            const pointLng = Number(area.point[1]);
            if (Number.isFinite(pointLat) && Number.isFinite(pointLng)) {
                return L.latLng(pointLat, pointLng);
            }
        }

        return null;
    };

    getMapAreaBounds = (area) => {
        if (!area) return null;

        const hasStoredBounds = area.min_lat !== null && area.min_lat !== undefined && area.min_lat !== '' &&
            area.max_lat !== null && area.max_lat !== undefined && area.max_lat !== '' &&
            area.min_lng !== null && area.min_lng !== undefined && area.min_lng !== '' &&
            area.max_lng !== null && area.max_lng !== undefined && area.max_lng !== '';
        const minLat = Number(area.min_lat);
        const maxLat = Number(area.max_lat);
        const minLng = Number(area.min_lng);
        const maxLng = Number(area.max_lng);
        if (!hasStoredBounds || ![minLat, maxLat, minLng, maxLng].every(Number.isFinite)) return null;
        if (minLat > maxLat || minLng > maxLng) return null;

        return L.latLngBounds([minLat, minLng], [maxLat, maxLng]);
    };

    hasLazyAreaMetadata = () => {
        const polygons = this.getCurrentPolygonList ? this.getCurrentPolygonList() : [];
        for (let i = 0; i < polygons.length; i++) {
            const polygon = polygons[i];
            if (polygon && (polygon._lazyViewport || !polygon.points) && this.getMapAreaCenter(polygon)) return true;
        }
        return false;
    };

    isMapAreaInViewport = (area, viewport) => {
        if (!viewport) return false;
        const areaBounds = this.getMapAreaBounds(area);
        if (areaBounds && areaBounds.isValid && areaBounds.isValid()) {
            return viewport.intersects(areaBounds);
        }

        const center = this.getMapAreaCenter(area);
        return !!(center && viewport.contains(center));
    };

    removeLazyRenderedGeometries = (guids) => {
        if (!this.featureGroupP || !this.mymap) return;

        const targets = guids
            ? (guids instanceof Set ? Array.from(guids) : guids)
            : Array.from(this.lazyRenderedGuids);

        for (let i = 0; i < targets.length; i++) {
            const guid = targets[i];
            const rendered = this.lazyRenderedLayers.get(guid);
            this.removeLayer(this.featureGroupP, rendered ? rendered.layer : this.mymap._layers[guid]);
            this.lazyRenderedLayers.delete(guid);
            this.lazyRenderedGuids.delete(guid);
        }
    };

    createLazyClusterMarker = (cluster) => {
        const iconSize = cluster.count >= 100 ? 50 : 44;
        const radius = iconSize / 2 - 2;
        const icon = L.divIcon({
            className: '',
            html: '<svg width="' + iconSize + '" height="' + iconSize + '" viewBox="0 0 ' + iconSize + ' ' + iconSize + '">' +
                '<circle cx="' + (iconSize / 2) + '" cy="' + (iconSize / 2) + '" r="' + radius + '" fill="#2f6f88" stroke="#ffffff" stroke-width="2" />' +
                '<text x="50%" y="50%" text-anchor="middle" dominant-baseline="middle" font-family="Arial" font-size="' + (cluster.count >= 100 ? 14 : 16) + '" fill="#ffffff" font-weight="700">' + cluster.count + '</text>' +
                '</svg>',
            iconSize: [iconSize, iconSize],
            iconAnchor: [iconSize / 2, iconSize / 2]
        });

        const center = L.latLng(cluster.latSum / cluster.count, cluster.lngSum / cluster.count);
        const marker = L.marker(center, { icon: icon });
        marker.areaGuids = cluster.guids;
        marker.on('click', () => {
            const nextZoom = Math.max(this.getLazyGeometryZoom(), this.mymap.getZoom() + 2);
            this.mymap.setView(center, Math.min(nextZoom, 20));
        });
        marker.addTo(this.featureGroupCluster);
    };

    buildLazySummaryClusters = (areas) => {
        if (!this.mymap || !this.featureGroupCluster) return;

        const viewport = this.mymap.getBounds().pad(0.25);
        const gridSize = 80;
        const zoom = this.mymap.getZoom();
        const clusters = {};

        for (let i = 0; i < areas.length; i++) {
            const area = areas[i];
            if (!area || !area.visible || !this.isMapAreaInViewport(area, viewport)) continue;

            const center = this.getMapAreaCenter(area);
            if (!center) continue;

            const point = this.mymap.project(center, zoom);
            const key = Math.floor(point.x / gridSize) + '_' + Math.floor(point.y / gridSize);
            if (!clusters[key]) clusters[key] = { count: 0, latSum: 0, lngSum: 0, guids: [] };

            clusters[key].count += 1;
            clusters[key].latSum += center.lat;
            clusters[key].lngSum += center.lng;
            clusters[key].guids.push(area.guid);
        }

        Object.keys(clusters).forEach((key) => this.createLazyClusterMarker(clusters[key]));
    };

    getLazyGeometryRows = (areas) => {
        const requested = [];

        for (let i = 0; i < areas.length; i++) {
            const area = areas[i];
            // Areas created/imported in this session already carry their full
            // geometry in state. Seed the same cache used by the lazy viewport
            // renderer so it never asks the server for those points again.
            if (this.cacheAreaGeometry(area)) continue;

            const id = Number(area && area.id);
            if (!Number.isInteger(id) || id <= 0 || this.lazyGeometryCache.has(id)) continue;
            if (!this.lazyGeometryRequests.has(id)) requested.push(id);
        }

        for (let start = 0; start < requested.length; start += this.lazyGeometryRequestLimit) {
            const requestedBatch = requested.slice(start, start + this.lazyGeometryRequestLimit);
            const clearBatch = () => {
                for (let i = 0; i < requestedBatch.length; i++) {
                    this.lazyGeometryRequests.delete(requestedBatch[i]);
                }
            };

            const request = fetch(Config.server + '/area/geometries?ids=' + encodeURIComponent(requestedBatch.join(',')), {
                method: 'GET',
                headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
            })
                .then((res) => {
                    if (res.status !== 200) throw res;
                    return res.json();
                })
                .then((rows) => {
                    for (let i = 0; i < rows.length; i++) {
                        const row = rows[i];
                        this.lazyGeometryCache.set(Number(row.id), row);
                    }
                })
                .then(() => {
                    clearBatch();
                }, (error) => {
                    clearBatch();
                    throw error;
                });

            for (let i = 0; i < requestedBatch.length; i++) {
                this.lazyGeometryRequests.set(requestedBatch[i], request);
            }
        }

        const pending = [];
        for (let i = 0; i < areas.length; i++) {
            const request = this.lazyGeometryRequests.get(Number(areas[i] && areas[i].id));
            if (request && pending.indexOf(request) < 0) pending.push(request);
        }

        return Promise.all(pending);
    };

    cacheAreaGeometry = (area) => {
        const id = Number(area && area.id);
        if (!Number.isInteger(id) || id <= 0 || !area.points) return false;

        const cached = this.lazyGeometryCache.get(id);
        if (!cached || cached.points !== area.points) {
            this.lazyGeometryCache.set(id, {
                id: id,
                guid: area.guid,
                points: area.points,
                radius: area.radius,
                point: area.point,
                type: area.type,
                ab: area.ab,
                custom_color: area.custom_color || ''
            });
        }
        return true;
    };

    getLazyPolygonRenderer = () => {
        if (!this.mymap || !L.canvas) return null;

        if (!this.lazyPolygonRenderer) {
            this.lazyPolygonRenderer = L.canvas({ padding: 0.25 });
            this.lazyPolygonRenderer.addTo(this.mymap);
        }

        return this.lazyPolygonRenderer;
    };

    setAreaListScrollNode = (node) => {
        if (this.areaListScrollNode === node) return;

        if (this.listGeometryObserver) {
            this.listGeometryObserver.disconnect();
            this.listGeometryObserver = null;
        }

        this.areaListScrollNode = node;
        if (!node || typeof window.IntersectionObserver === 'undefined') return;

        this.listGeometryObserver = new window.IntersectionObserver((entries) => {
            for (let i = 0; i < entries.length; i++) {
                const entry = entries[i];
                if (!entry.isIntersecting) continue;

                const guid = entry.target && entry.target.dataset ? entry.target.dataset.areaGuid : '';
                const registered = guid ? this.listPolygonNodes.get(guid) : null;
                if (registered && registered.node === entry.target) {
                    this.queueListGeometry(registered.area);
                }
            }
        }, {
            root: node,
            // Load a small buffer above and below the visible rows so their
            // miniature is ready before the user reaches it.
            rootMargin: '160px 0px'
        });

        this.listPolygonNodes.forEach((registered) => {
            if (registered.node) this.listGeometryObserver.observe(registered.node);
        });
    };

    observeListPolygon = (area, node) => {
        if (!area || !area.guid) return;

        const guid = area.guid;
        const previous = this.listPolygonNodes.get(guid);
        if (!node) {
            if (previous && this.listGeometryObserver) this.listGeometryObserver.unobserve(previous.node);
            this.listPolygonNodes.delete(guid);
            return;
        }

        if (previous && previous.node !== node && this.listGeometryObserver) {
            this.listGeometryObserver.unobserve(previous.node);
        }
        this.listPolygonNodes.set(guid, { area, node });
        if (this.listGeometryObserver) this.listGeometryObserver.observe(node);
    };

    queueListGeometry = (area) => {
        if (!area || !area.guid || !area.id) return;
        if (area.points && area.svg) return;

        this.listGeometryQueue.add(area.guid);
        if (this.listGeometryFrame !== null) return;

        this.listGeometryFrame = window.requestAnimationFrame(() => {
            this.listGeometryFrame = null;
            this.loadListVisibleGeometries();
        });
    };

    loadListVisibleGeometries = () => {
        if (!this.listGeometryQueue.size) return;

        const from = this.tabID[Number(this.state.tab)];
        const areas = this.state[from] || [];
        const queuedGuids = this.listGeometryQueue;
        this.listGeometryQueue = new Set();
        const byGuid = new Map();
        for (let i = 0; i < areas.length; i++) {
            const area = areas[i];
            if (area && queuedGuids.has(area.guid)) byGuid.set(area.guid, area);
        }
        const visibleRows = Array.from(byGuid.values());
        if (!visibleRows.length) return;

        this.getLazyGeometryRows(visibleRows)
            .then(() => {
                let previewUpdated = false;
                let refreshMap = false;
                const viewport = this.mymap ? this.mymap.getBounds().pad(0.25) : null;

                for (let i = 0; i < visibleRows.length; i++) {
                    const area = visibleRows[i];
                    const beforePreview = area.svg;
                    this.hydrateLazyArea(area.guid, from);
                    if (!beforePreview && area.svg) previewUpdated = true;
                    if (viewport && area.visible && this.isMapAreaInViewport(area, viewport)) {
                        refreshMap = true;
                    }
                }

                if (previewUpdated) this.requestListPreviewRefresh(from);
                if (refreshMap) this.requestLazyViewportRefresh();
            })
            .catch((error) => {
                if (error && (error.status === 401 || error.status === 403)) this.props.link('/login');
            });
    };

    getListGeometryPreview = (points) => {
        try {
            const coordinates = JSON.parse(points);
            if (!Array.isArray(coordinates) || coordinates.length < 3) return '';

            const maxPoints = 80;
            const step = Math.max(1, Math.ceil(coordinates.length / maxPoints));
            const preview = [];
            for (let i = 0; i < coordinates.length; i += step) preview.push(coordinates[i]);
            if (preview[preview.length - 1] !== coordinates[coordinates.length - 1]) {
                preview.push(coordinates[coordinates.length - 1]);
            }
            return this.generateSVGPath(preview);
        } catch (e) {
            return '';
        }
    };

    requestListPreviewRefresh = (key) => {
        this.listPreviewKeys.add(key);
        if (this.areaListIsActive) this.flushListPreviewRefresh();
    };

    flushListPreviewRefresh = () => {
        if (!this.areaListIsActive || this.listPreviewRefreshFrame !== null || !this.listPreviewKeys.size) return;

        this.listPreviewRefreshFrame = window.requestAnimationFrame(() => {
            this.listPreviewRefreshFrame = null;
            if (!this.areaListIsActive || !this.listPreviewKeys.size) return;

            const nextState = {};
            this.listPreviewKeys.forEach((listKey) => {
                nextState[listKey] = (this.state[listKey] || []).slice();
            });
            this.listPreviewKeys.clear();
            this.setState(nextState);
        });
    };

    cancelListPreviewRefresh = () => {
        if (this.listPreviewRefreshFrame !== null) {
            window.cancelAnimationFrame(this.listPreviewRefreshFrame);
            this.listPreviewRefreshFrame = null;
        }
    };

    renderLazyGeometries = (areas, token) => {
        const tabKey = this.tabID[Number(this.state.tab)];
        const targetGuids = new Set();
        const additions = [];
        const polygonIndex = this.getPolygonIndexByGuid();
        const canvasZone = this.getCanvasDisplayZone();
        const renderer = this.getLazyPolygonRenderer();

        for (let i = 0; i < areas.length; i++) {
            const summary = areas[i];
            const geometry = this.lazyGeometryCache.get(Number(summary && summary.id));
            if (!summary || !geometry || !geometry.points) continue;

            const guid = summary.guid || geometry.guid;
            if (!guid) continue;
            targetGuids.add(guid);

            const rendered = this.lazyRenderedLayers.get(guid);
            // Geometry is immutable while it is cached. A polygon that remains
            // in the padded viewport must stay mounted when the map moves.
            if (rendered && rendered.points === geometry.points && this.featureGroupP.hasLayer(rendered.layer)) {
                continue;
            }

            const polygon = Object.assign({}, geometry, summary, {
                guid,
                points: geometry.points,
                visible: summary.visible,
                custom_color: summary.custom_color || geometry.custom_color || ''
            });
            polygon._lazySummary = summary;
            additions.push(polygon);
        }

        const staleGuids = [];
        this.lazyRenderedGuids.forEach((guid) => {
            if (!targetGuids.has(guid)) staleGuids.push(guid);
        });
        this.removeLazyRenderedGeometries(staleGuids);

        const drawBatch = (start) => {
            if (token !== this.lazyViewportToken || !this.mymap) return;

            const end = Math.min(start + this.lazyGeometryRenderBatchSize, additions.length);
            for (let i = start; i < end; i++) {
                const polygon = additions[i];
                const previous = this.lazyRenderedLayers.get(polygon.guid);
                if (previous) this.removeLazyRenderedGeometries([polygon.guid]);

                if (!polygon.svg) {
                    polygon.svg = this.getListGeometryPreview(polygon.points);
                    if (polygon._lazySummary) polygon._lazySummary.svg = polygon.svg;
                    this.lazyPreviewPending = !!polygon.svg || this.lazyPreviewPending;
                }

                try {
                    const layer = this.drawPolygon(polygon, this.tabID[Number(this.state.tab)], {
                        skipAreaCalculation: true,
                        polygonIndex,
                        canvasZone,
                        renderer
                    });
                    if (layer) {
                        this.lazyRenderedGuids.add(polygon.guid);
                        this.lazyRenderedLayers.set(polygon.guid, { layer, points: polygon.points });
                    }
                } catch (e) {
                    // A malformed legacy geometry must not stop the rest of the viewport.
                }
            }

            if (end < additions.length) {
                this.lazyRenderFrame = window.requestAnimationFrame(() => {
                    this.lazyRenderFrame = null;
                    drawBatch(end);
                });
            } else {
                this.updatePolygonTooltipsVisibility(polygonIndex, canvasZone);
                if (this.lazyPreviewPending || this.listPreviewKeys.size > 0) {
                    this.lazyPreviewPending = false;
                    this.requestListPreviewRefresh(tabKey);
                }
            }
        };

        drawBatch(0);
    };

    refreshLazyViewport = () => {
        if (!this.mymap || !this.hasLazyAreaMetadata()) return;

        const areas = this.getCurrentPolygonList();
        const viewport = this.mymap.getBounds().pad(0.25);
        const visibleAreas = areas.filter(area => area && area.visible && this.isMapAreaInViewport(area, viewport));
        const token = ++this.lazyViewportToken;

        this.cancelListPreviewRefresh();

        if (this.lazyRenderFrame !== null) {
            window.cancelAnimationFrame(this.lazyRenderFrame);
            this.lazyRenderFrame = null;
        }

        this.clearPolygonClusters();

        if (this.mymap.getZoom() < this.getLazyGeometryZoom() || visibleAreas.length > this.getLazyGeometryRenderLimit()) {
            this.removeLazyRenderedGeometries();
            this.buildLazySummaryClusters(visibleAreas);
            return;
        }

        this.getLazyGeometryRows(visibleAreas)
            .then(() => {
                if (token !== this.lazyViewportToken || !this.mymap) return;
                this.renderLazyGeometries(visibleAreas, token);
            })
            .catch((error) => {
                if (error && error.status === 401) this.props.link('/login');
            });
    };

    requestLazyViewportRefresh = () => {
        if (this.lazyViewportFrame !== null) return;

        this.lazyViewportFrame = window.requestAnimationFrame(() => {
            this.lazyViewportFrame = null;
            this.refreshLazyViewport();
        });
    };

    shift = false;
    type_name = '';
    type_action = '';//

    waypointMarker = null;
    waypointIcon = null;
    mapIsDragging = false;

    editLive = {
        active: false,
        guids: [],
        originalTotalM2: 0,
        dragging: false,
        markerHandlers: {}
    };

    editRaf = null;
    editDragInterval = null;
    editDocMouseUpHandler = null;
    editDocTouchEndHandler = null;
    editDocPointerDownHandler = null;
    editDocPointerUpHandler = null;

    componentDidMount() {
        this.update();
        this.loadPastas();
        this.getAreas();
        this.readRunways();
        this.updateListPlanes();
        //this.loadLimit();
        //this.loadUser();
        this.loadClient();
        this.loadCompanyOpenModules();
        this.loadOverlapPreference();
    };

    componentDidUpdate(previousProps, previousState) {
        if (previousState && this.state.merge && this.state.type === '5' && !this.state.split &&
            (this.state.tab !== previousState.tab || this.state.sel_poly.join(',') !== previousState.sel_poly.join(','))) {
            this.openMerge(this.state.type);
        }
        if (this.state.manualAbGuid && this.getManualAbPolygon()?.guid !== this.state.manualAbGuid) {
            this.closeManualAb();
            return;
        }
        this.syncSelectedAb();
    }

    componentWillUnmount() {
        if (this.importWorker) {
            this.importWorker.terminate();
            this.importWorker = null;
        }
        if (this.clusterSyncFrame !== null) {
            window.cancelAnimationFrame(this.clusterSyncFrame);
            this.clusterSyncFrame = null;
        }
        if (this.lazyViewportFrame !== null) {
            window.cancelAnimationFrame(this.lazyViewportFrame);
            this.lazyViewportFrame = null;
        }
        if (this.lazyRenderFrame !== null) {
            window.cancelAnimationFrame(this.lazyRenderFrame);
            this.lazyRenderFrame = null;
        }
        this.lazyViewportToken++;
        this.lazyGeometryCache.clear();
        this.lazyGeometryRequests.clear();
        this.lazyRenderedGuids.clear();
        this.lazyRenderedLayers.clear();
        Object.keys(this.summaryPagers).forEach((key) => {
            const pager = this.summaryPagers[key];
            pager.version++;
            if (pager.timer !== null) window.clearTimeout(pager.timer);
            pager.timer = null;
            pager.pendingSummaries = [];
        });
        if (this.filterTimer !== null) {
            window.clearTimeout(this.filterTimer);
            this.filterTimer = null;
        }
        if (this.listPreviewRefreshFrame !== null) {
            window.cancelAnimationFrame(this.listPreviewRefreshFrame);
            this.listPreviewRefreshFrame = null;
        }
        this.listPreviewKeys.clear();
        if (this.listGeometryObserver) {
            this.listGeometryObserver.disconnect();
            this.listGeometryObserver = null;
        }
        if (this.listGeometryFrame !== null) {
            window.cancelAnimationFrame(this.listGeometryFrame);
            this.listGeometryFrame = null;
        }
        this.listPolygonNodes.clear();
        this.listGeometryQueue.clear();
        this.importingGuids.clear();

        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    };

    update = () => {
        let local_ini = Config.place;
        if (this.state.local) {
            let pos = this.state.local.split(',');
            if (!isNaN(pos[1]) && !isNaN(pos[1])) {
                local_ini = pos;
            }
        }

        this.mymap = L.map('mapid', { zoomControl: false, attributionControl: false, maxZoom: 20 }).setView(local_ini, 14);
        let tileConfig = Object.assign({}, Config.tile_google_config, { maxZoom: 20 });
        L.tileLayer(Config.tile_google, tileConfig).addTo(this.mymap);

        if (this.mymap.doubleClickZoom) {
            this.mymap.doubleClickZoom.disable();
        }

        L.control.scale({ imperial: false }).addTo(this.mymap);

        this.featureGroupP = L.featureGroup();
        this.featureGroupP.addTo(this.mymap);
        this.featureGroupCluster = L.featureGroup();
        this.featureGroupCluster.addTo(this.mymap);
        this.featureGroupM = L.featureGroup();
        this.featureGroupM.addTo(this.mymap);
        this.featureGroupPoly = L.featureGroup();
        this.featureGroupPoly.addTo(this.mymap);
        this.featureGroupP.on('layeradd layerremove', ({ layer }) => {
            if (this.state.sel_poly.includes(layer._leaflet_id)) this.syncSelectedAb(true);
        });

        this.drawControl = new L.Control.Draw({
            draw: {
                polyline: false,
                polygon: false,
                circle: false,
                rectangle: false,
                marker: false,
                circlemarker: false
            },
            edit: false
        });
        this.drawControl.addTo(this.mymap);

        this.syncMapCenterCoordinates();

        navigator.geolocation.getCurrentPosition((position) => {
            const latValue = this.round_coord(position.coords.latitude);
            const lngValue = this.round_coord(position.coords.longitude);

            if (this.state.polygons.length <= 0) {
                if (!this.state.local) {
                    this.validate('lat', geo.toDMS(latValue, 'latitude', 4));
                    this.validate('lng', geo.toDMS(lngValue, 'longitude', 4));
                    window.history.replaceState(null, "Travicar", "/app/draw/" + latValue + ',' + lngValue);
                    if (this.mymap) {
                        this.mymap.setView([latValue, lngValue]);
                        this.syncMapCenterCoordinates();
                    }
                }
            }

            this.setState({ home: [latValue, lngValue] });
        });

        this.mymap.on('draw:created', (e) => {
            this.markClick = false;
            if (this.state.create_waypoint) {
                this.saveWaypoint(e.layer);
            } else if (this.state.selector) {
                this.completeSelector(e.layer.toGeoJSON());
            } else if (this.state.create || this.state.create_circle) {
                const guid = tools.newGuid();
                const name = this.state.nameP ? this.state.nameP : this.nextIndex(this.state.polygons);
                e.layer.on("click", (evt) => {
                    if (evt) {
                        L.DomEvent.stopPropagation(evt);
                    }
                    this.handleClickP(guid, this.tabID[Number(this.state.tab)]);
                });
                e.layer._leaflet_id = guid;
                e.layer.setStyle({ color: this.color_default });

                let tempPoly = new polygon();
                tempPoly.guid = guid;
                tempPoly.name = name;
                tempPoly.type = 'N';
                tempPoly.visible = true;
                let latlng = [];
                if (e.layer._mRadius) {
                    tempPoly.radius = e.layer._mRadius;
                    tempPoly.point = [e.layer._latlng.lat, e.layer._latlng.lng];
                    latlng = geo.cicleToPolygon([e.layer._latlng.lng, e.layer._latlng.lat], e.layer._mRadius);
                } else {
                    for (let c = 0; c < e.layer._latlngs[0].length; c++) {
                        const element = e.layer._latlngs[0][c];
                        latlng = latlng.concat([[element.lat, element.lng]]);
                    }
                }
                if (e.layer._mRadius) {
                    tempPoly.area = e.layer._mRadius * e.layer._mRadius * Math.PI;
                } else {
                    tempPoly.area = L.GeometryUtil.geodesicArea(e.layer.getLatLngs()[0]);
                }
                tempPoly.points = JSON.stringify(latlng);
                tempPoly.svg = this.generateSVGPath(latlng);
                tempPoly.folder = 'm';
                this.updateArea(tempPoly);
                this.setState({ polygons: this.state.polygons.concat(tempPoly) });
                //this.savePolygons(this.state.polygons.concat(tempPoly));
                // Each time a feaute is created, it's added to the over arching feature group
                this.featureGroupP.addLayer(e.layer);

                e.layer.bindTooltip(name,
                    { permanent: true, direction: "center", className: 'tool-tip-L tool-tip-size16-L' }
                );
                this.setLayerTooltipVisibility(e.layer, false);

                this.setState({ create: false, create_circle: false }, () => {
                    this.recalculateOverlaps();
                    this.syncPolygonClusters();
                });
            } else {
                e.layer._leaflet_id = 'spliLine';
                this.featureGroupP.addLayer(e.layer);
                this.setState({ merge: true, type: '6' });
                this.editSplit();
                this.syncPolygonClusters();
            }
        });

        this.mymap.on('draw:canceled', () => {
            this.setState({ create: false, create_circle: false, create_waypoint: false, showWaypointTypes: false, waypointType: '', waypointName: '' });
            this.markClick = false;
            this.regua(false);
        });

        this.mymap.on('draw:edited', (e) => {
            this.setState({ create: false });
            let tempPolygons = this.state[this.tabID[Number(this.state.tab)]];
            let layers = e.layers;
            layers.eachLayer((feature) => {
                for (let j = 0; j < tempPolygons.length; j++) {
                    if (tempPolygons[j].guid === feature._leaflet_id) {
                        let latlng = [];
                        if (feature._mRadius) {
                            tempPolygons[j].radius = feature._mRadius;
                            tempPolygons[j].point = [feature._latlng.lat, feature._latlng.lng];
                            latlng = geo.cicleToPolygon([feature._latlng.lng, feature._latlng.lat], feature._mRadius);
                        } else {
                            for (let c = 0; c < feature._latlngs[0].length; c++) {
                                const element = feature._latlngs[0][c];
                                latlng = latlng.concat([[element.lat, element.lng]]);
                            }
                        }
                        tempPolygons[j].points = JSON.stringify(latlng);
                        tempPolygons[j].svg = this.generateSVGPath(latlng);
                        if (feature._mRadius) {
                            tempPolygons[j].area = feature._mRadius * feature._mRadius * Math.PI;
                        } else {
                            tempPolygons[j].area = L.GeometryUtil.geodesicArea(feature.getLatLngs()[0]);
                        }
                        this.updateArea(tempPolygons[j]);
                        break;
                    }
                }
            });
            //this.savePolygons(tempPolygons);
            this.recalculateOverlaps();
            this.syncPolygonClusters();
        });

        this.mymap.on('draw:deleted', (e) => {
            let tempPolygons = this.state[this.tabID[Number(this.state.tab)]];
            let layers = e.layers;
            if (layers) {
                let ids = [];
                layers.eachLayer((feature) => {
                    for (let j = 0; j < tempPolygons.length; j++) {
                        const element = tempPolygons[j];
                        if (element.guid === feature._leaflet_id) {
                            tempPolygons.splice(tempPolygons.indexOf(element), 1);
                            ids.push(element.id);
                            //verifica se existe duplicado
                            let tempPX = tempPolygons.filter(item => { return item.guid.includes(element.guid); });
                            for (let k = 0; k < tempPX.length; k++) {
                                tempPolygons.splice(tempPolygons.indexOf(tempPX[k]), 1);
                                ids.push(tempPX[k].id);
                            }
                            break;
                        }
                    }

                });
                if (ids.length > 0) {
                    this.deleteArea(ids, () => {
                        this.recalculateOverlaps();
                        this.syncPolygonClusters();
                    });
                } else {
                    this.recalculateOverlaps();
                    this.syncPolygonClusters();
                }
            } else {
                this.recalculateOverlaps();
                this.syncPolygonClusters();
            }
        });

        this.mymap.on('dragstart', () => {
            this.mapIsDragging = true;
            this.cancelListPreviewRefresh();
        });

        this.mymap.on('dragend', () => {
            this.mapIsDragging = false;
        });

        this.mymap.on('click', (e) => {
            if (this.state.selector) {
                this.markClick = false;
            } else {
                this.polyClick = false;
                this.handleClickP(null, this.tabID[Number(this.state.tab)]);
                this.clearRunwaySelection();
                if (this.state.create_circle) {
                    this.setState({ create_circle: false });
                    this.markClick = false;
                }
            }

            if (this.closeWaypointPopup) {
                this.closeWaypointPopup();
            }
        });

        this.mymap.on('dblclick', (e) => {
            if (!e || !e.latlng) return;
            if (this.mapIsDragging) return;

            if (this.state &&
                (this.state.selector || this.state.create || this.state.create_circle || this.state.create_waypoint || this.state.ruler_a || this.state.merge)) {
                return;
            }

            if (!this.waypointMarker) {
                this.createWaypointMarker(e.latlng);
            } else {
                this.moveWaypointMarker(e.latlng);
            }
        });

        this.mymap.on('mouseup', e => {
            if (this.state.ruler_a && !this.mymap.dragging._enabled) {
                this.mymap.dragging.enable();
                if (this.ruler_p.second.lat === null) {
                    this.drawCreateToolbar.addVertex(e.latlng);
                }
            }
        });

        this.mymap.on('moveend', () => {
            this.syncMapCenterCoordinates();
            this.requestPolygonClusterSync();
        });

        this.mymap.on('zoomend', () => {
            if (this.mymap.getZoom() < this.minTooltipZoom) {
                tools.cssShow('editable', false);
            } else {
                tools.cssShow('editable', true);
            }
            this.syncMapCenterCoordinates();
            this.requestPolygonClusterSync();
        });

        this.mymap.on('draw:drawvertex', (e) => {
            if (this.drawCreateToolbar.type === 'polyline' && this.state.ruler_a) {
                let layerIds = Object.keys(e.layers._layers);
                if (layerIds.length > 1) {
                    let v2 = e.layers._layers[layerIds[1]];
                    this.ruler_p.second.lat = v2._latlng.lat;
                    this.ruler_p.second.lng = v2._latlng.lng;
                    requestAnimationFrame(() => this.completeRuler());
                } else if (layerIds.length === 1) {
                    let v1 = e.layers._layers[layerIds[0]];
                    this.ruler_p.first.lat = v1._latlng.lat;
                    this.ruler_p.first.lng = v1._latlng.lng;
                }
            }
        });

        this.drawEditToolbar = new L["EditToolbar"].Edit(this.mymap, {
            featureGroup: this.featureGroupP
        });

        this.drawDeleteToolbar = new L["EditToolbar"].Delete(this.mymap, {
            featureGroup: this.featureGroupP
        });

        L.drawLocal.draw.handlers.polygon.tooltip.start = '';
        L.drawLocal.draw.handlers.polygon.tooltip.cont = '';
        L.drawLocal.draw.handlers.polygon.tooltip.end = '';

        L.drawLocal.edit.handlers.edit.tooltip.text = '';
        L.drawLocal.edit.handlers.edit.tooltip.subtext = '';

        L.drawLocal.edit.handlers.remove.tooltip.text = '';

        L.drawLocal.draw.handlers.polyline.tooltip.start = '';
        L.drawLocal.draw.handlers.polyline.tooltip.cont = '';

        L.drawLocal.draw.handlers.circle.tooltip.start = this.props.res.CLICK_CIRCULO;
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        }, () => {
            if (name === 'search_text') {
                let text = this.state.search_text.trim().toLowerCase();
                if (text.length > 2) {
                    this.searchLocation('search');
                } else {
                    this.setState({ listSearch: [] });
                }
            }
        });
    };

    handleChangeCoordinates = name => event => {
        this.validate(name, event.target.value);
    };

    validate = (name, value) => {
        //regex: /\d{1,2}º\d\d'(\d\d|\d\d\.\d{1,4}) (N|S)/
        //geo.toCoordinate(this.state.lat_input);
        //geo.toDMS(this.state.lat, 'latitude', 4);
        let update = this.state[name];
        if (name === 'lat' || name === 'latL') {
            update.input = value;
            if (/\d{1,2}(°|º)\d{1,2}'(\d{1,2}|\d{1,2}\.\d{1,4})( |")(N|S)/.test(value)) {
                update.value = geo.toCoordinate(geo.toFixDMS(value));
                update.error = false;
            } else {
                update.error = true;
            }
        } else if (name === 'lng' || name === 'lngL') {
            update.input = value;
            //TODO:fix res
            if ((/\d{1,2}(°|º)\d{1,2}'(\d{1,2}|\d{1,2}\.\d{1,4})( |")(W|E)/.test(value))
                || (/\d{1,2}(°|º)\d{1,2}'(\d{1,2}|\d{1,2}\.\d{1,4})( |")(O|L)/.test(value))) {
                update.value = geo.toCoordinate(geo.toFixDMS(value));
                update.error = false;
            } else {
                update.error = true;
            }
        }

        this.setState(update);
    }

    formatRegua = (valor) => {
        let text = '';
        if (valor < 1000) {
            text = Math.round(valor) + ' m';
        } else {
            text = (Math.round(valor / 10) / 100) + ' km';
        }

        return text;
    };

    round_coord = (coord) => {
        return Math.round(coord * 10000000) / 10000000;
    };

    setLayerColor = (guid, color) => {
        if (!this.mymap || !this.mymap._layers) return;
        const layer = this.mymap._layers[guid];
        if (layer && layer.setStyle) {
            layer.setStyle({ color: color, fillColor: color, fillOpacity: 0.2 });
        }
    };

    getPolygonColor = (item) => {
        if (!item) return this.color_default;
        return item.custom_color ? item.custom_color : this.color_default;
    };

    getItemBaseColor = (item) => {
        if (!item) return this.color_default;
        if (item.type === 'X' || item.type === 'XL') return this.color_x;
        if (item.type === 'T') return this.color_t;
        return this.getPolygonColor(item);
    };

    getPolygonSelectionIndex = (items) => {
        const previousItems = this.selectionIndexItems;
        const canExtend = this.selectionIndex && previousItems && items.length >= previousItems.length &&
            (previousItems.length === 0 || previousItems[previousItems.length - 1] === items[previousItems.length - 1]);

        if (!canExtend) {
            this.selectionIndex = { byGuid: new Map(), byX: new Map() };
        }

        const index = this.selectionIndex;
        const start = canExtend ? previousItems.length : 0;
        for (let i = start; i < items.length; i++) {
            const item = items[i];
            if (!item || !item.guid) continue;

            index.byGuid.set(item.guid, item);
            if (item.x) {
                if (!index.byX.has(item.x)) index.byX.set(item.x, []);
                index.byX.get(item.x).push(item);
            }
        }

        this.selectionIndexItems = items;
        return index;
    };

    handleClickP = (guid, from, callback) => {
        if (this.state.ruler_a && this.ruler_p.type === 'ab') return;
        if (!this.state.showTrim && !this.state.create && !this.state.edit && !this.state.delete && !this.state.selector && !this.state.split) {
            if (guid) this.hydrateLazyArea(guid, from);
            const items = this.state[from] || [];
            const polygonIndex = this.getPolygonSelectionIndex(items);
            const byGuid = polygonIndex.byGuid;
            const byX = polygonIndex.byX;

            if (guid) {
                this.polyClick = true;
                const selectedSet = new Set(this.state.sel_poly || []);
                //remove selecao
                if (selectedSet.has(guid)) {
                    const removeSet = new Set([guid]);
                    const linked = byX.get(guid) || [];
                    for (let i = 0; i < linked.length; i++) {
                        removeSet.add(linked[i].guid);
                    }
                    removeSet.forEach((itemGuid) => selectedSet.delete(itemGuid));
                    removeSet.forEach((itemGuid) => {
                        const item = byGuid.get(itemGuid);
                        this.setLayerColor(itemGuid, this.getItemBaseColor(item));
                    });
                } else {
                    const toSelect = [];
                    if (this.shift && this.state.sel_poly.length > 0) {
                        const orderedItems = sortByName(items);
                        let lastGuid = this.state.sel_poly[this.state.sel_poly.length - 1];
                        let indexLast = orderedItems.findIndex(x => x.guid === lastGuid);
                        let indexNow = orderedItems.findIndex(x => x.guid === guid);
                        if (indexLast >= 0 && indexNow >= 0) {
                            if (indexNow > indexLast) {
                                let c = indexNow;
                                indexNow = indexLast;
                                indexLast = c;
                            }
                            for (let i = indexNow; i <= indexLast; i++) {
                                toSelect.push(orderedItems[i].guid);
                            }
                        } else {
                            toSelect.push(guid);
                        }
                    } else {
                        toSelect.push(guid);
                    }

                    for (let i = 0; i < toSelect.length; i++) {
                        const sGuid = toSelect[i];
                        selectedSet.add(sGuid);
                        this.setLayerColor(sGuid, this.color_selected);

                        const linked = byX.get(sGuid) || [];
                        for (let j = 0; j < linked.length; j++) {
                            if (linked[j].guid !== sGuid) {
                                selectedSet.add(linked[j].guid);
                                this.setLayerColor(linked[j].guid, this.color_selected);
                            }
                        }
                    }
                }

                const array = Array.from(selectedSet);
                let area_text = 0;
                let sel_merge = false;
                for (let i = 0; i < array.length; i++) {
                    const element = array[i];
                    const areaItem = byGuid.get(element);
                    if (!areaItem) continue;

                    if (areaItem.old) {
                        sel_merge = true;
                    }

                    if (areaItem.type !== 'X') {
                        let area = 0;
                        if (areaItem.area) {
                            area = areaItem.area;
                        } else {
                            let layerP = this.mymap._layers[areaItem.guid];
                            if (layerP) {
                                area = L.GeometryUtil.geodesicArea(layerP.getLatLngs()[0]);
                            }
                        }
                        area_text += area;
                    }
                }

                const updateState = {
                    sel_poly: array,
                    sel_merge: sel_merge,
                    sel_x: false,
                    sel_t: false,
                    label_text: ''
                };

                if (array.length === 1) {
                    const only = byGuid.get(array[0]);
                    updateState.sel_x = !!(only && only.type === 'X');
                    updateState.sel_t = !!(only && !updateState.sel_x && only.type === 'T');
                }

                if (area_text > 0 && array.length > 0) {
                    if (this.state.edit_name) {
                        this.updateName(array);
                    }

                    const unit = Units.getAreaUnit(this.props.res);
                    const areaValue = Units.convertArea(area_text, 'm2', this.props.res);

                    let text = Units.formatValue(areaValue, this.props.res) + ' ' + unit;
                    updateState.label_text = text;
                }

                this.setState(updateState, () => {
                    if (this.past_merge) {
                        this.showItem();
                    }
                    if (callback) {
                        callback();
                    }
                });
                if (array.length === 0) {
                    this.showName(false);
                }
            } else if (this.polyClick === false) {
                const prevSel = this.state.sel_poly || [];
                if (prevSel.length > 0) {
                    for (let i = 0; i < prevSel.length; i++) {
                        const selGuid = prevSel[i];
                        const item = byGuid.get(selGuid);
                        this.setLayerColor(selGuid, this.getItemBaseColor(item));
                    }
                    this.setState({ sel_poly: [], sel_merge: false, sel_x: false, sel_t: false, label_text: '' });
                    this.showName(false);
                }
            } else {
                this.polyClick = false;
            }
        }
        this.shift = false;
    };

    zoomInL = () => {
        this.mymap.zoomIn();
    };

    zoomOutL = () => {
        this.mymap.zoomOut();
    };

    criaPoly = () => {
        this.resetClick();

        if (!this.markClick) {
            this.setState({ create: true, nameP: this.nextIndex(this.state.polygons), tab: '0' }, () => {
                this.resetPolygons(true);
            });
            this.drawCreateToolbar = new L.Draw.Polygon(this.mymap, { allowIntersection: false, showArea: true, metric: ['ha'] });
            this.drawCreateToolbar.enable();

        }
        this.markClick = true;
    };

    saveCreate = () => {
        if (!this.state.valid_nameP) {
            this.drawCreateToolbar.completeShape();
        }
    };

    deleteLastCreate = () => {
        this.drawCreateToolbar.deleteLastVertex();
    };

    cancelCreate = () => {
        this.markClick = false;
        this.setState({ create: false });
        this.drawCreateToolbar.disable();
    };

    criaCirculo = () => {
        this.resetClick();

        if (!this.markClick) {
            this.setState({ create_circle: true, nameP: this.nextIndex(this.state.polygons), tab: '0' }, () => {
                this.resetPolygons(true);
            });
            this.drawCreateToolbar = new L.Draw.Circle(this.mymap, { showArea: true, metric: ['ha'] });
            this.drawCreateToolbar.enable();

        }
        this.markClick = true;
    };

    cancelCreateCirculo = () => {
        this.markClick = false;
        this.setState({ create_circle: false });
        this.drawCreateToolbar.disable();
    };

    editPoly = () => {
        const guidsSelecionados = this.state.sel_poly ? this.state.sel_poly.slice() : [];

        this.resetClick();

        this.setState({ edit: true }, () => {
            if (this.drawEditToolbar) {
                this.drawEditToolbar.enable();
            }
            this.state[this.tabID[Number(this.state.tab)]].forEach(item => {
                if (this.mymap._layers[item.guid]) {
                    this.mymap._layers[item.guid].editing.disable();
                }
            });
            guidsSelecionados.forEach(item => {
                if (this.mymap._layers[item]) {
                    this.mymap._layers[item].editing.enable();
                    this.mymap._layers[item].setStyle({ color: this.color_edit });
                }
            });
            setTimeout(() => {
                this.startLiveEdit(guidsSelecionados);
            }, 0);
        });
    };

    saveEdit = () => {
        this.setState({ edit: false }, () => {
            this.stopLiveEdit(false);
        });
        if (this.drawEditToolbar) {
            this.drawEditToolbar.save();
            this.drawEditToolbar.disable();
        }
        const list = this.state[this.tabID[Number(this.state.tab)]];
        for (let i = 0; i < list.length; i++) {
            const element = list[i];
            const layer = this.mymap._layers[element.guid];
            if (!layer || !layer.setStyle) continue;

            if (element.x && element.guid.includes(element.x)) {
                layer.setStyle({ color: this.color_x, weight: 2, opacity: 1, fillColor: this.color_x, fillOpacity: 0.2 });
            } else if (element.type === 'T') {
                layer.setStyle({ color: this.color_t, weight: 2, opacity: 1, fillColor: this.color_t, fillOpacity: 0.2 });
            } else {
                layer.setStyle({ color: this.getPolygonColor(element), weight: 4, opacity: 0.5, fillColor: this.getPolygonColor(element), fillOpacity: 0.2 });
            }
        }

        const selected = this.state.sel_poly ? this.state.sel_poly.slice() : [];
        for (let i = 0; i < selected.length; i++) {
            const guid = selected[i];
            const layerSel = this.mymap._layers[guid];
            if (layerSel && layerSel.setStyle) {
                layerSel.setStyle({ color: this.color_selected, fillColor: this.color_selected, fillOpacity: 0.2 });
            }
        }
    };

    cancelEdit = () => {
        this.setState({ edit: false }, () => {
            this.stopLiveEdit(true);
        });
        if (this.drawEditToolbar) {
            this.drawEditToolbar.revertLayers();
            this.drawEditToolbar.disable();
        }
        const list = this.state[this.tabID[Number(this.state.tab)]];
        for (let i = 0; i < list.length; i++) {
            const element = list[i];
            const layer = this.mymap._layers[element.guid];
            if (!layer || !layer.setStyle) continue;

            if (element.x && element.guid.includes(element.x)) {
                layer.setStyle({ color: this.color_x, weight: 2, opacity: 1, fillColor: this.color_x, fillOpacity: 0.2 });
            } else if (element.type === 'T') {
                layer.setStyle({ color: this.color_t, weight: 2, opacity: 1, fillColor: this.color_t, fillOpacity: 0.2 });
            } else {
                layer.setStyle({ color: this.getPolygonColor(element), weight: 4, opacity: 0.5, fillColor: this.getPolygonColor(element), fillOpacity: 0.2 });
            }
        }
        const selected = this.state.sel_poly ? this.state.sel_poly.slice() : [];
        for (let i = 0; i < selected.length; i++) {
            const guid = selected[i];
            const layerSel = this.mymap._layers[guid];
            if (layerSel && layerSel.setStyle) {
                layerSel.setStyle({ color: this.color_selected, fillColor: this.color_selected, fillOpacity: 0.2 });
            }
        }
    };

    deletePoly = () => {
        this.resetClick();
        this.sel_save = this.state.sel_poly;
        for (let i = 0; i < this.state.sel_poly.length; i++) {
            const element = this.state.sel_poly[i];
            this.removeLayer(this.featureGroupP, this.mymap._layers[element]);
        }
        this.setState({ delete: true, sel_poly: [] });
        this.drawDeleteToolbar.enable();
    };

    saveDelete = () => {
        this.setState({ delete: false, label_text: '' });
        let polygons = this.state[this.tabID[Number(this.state.tab)]];
        let ids = [];
        this.sel_save.forEach(feature => {
            let tempPolygons = polygons.filter(item => { return item.guid.includes(feature); });
            for (let j = 0; j < tempPolygons.length; j++) {
                polygons.splice(polygons.indexOf(tempPolygons[j]), 1);
                ids.push(tempPolygons[j].id);
            }
            //this.savePolygons(polygons);
        });
        if (ids.length > 0) {
            this.deleteArea(ids, () => {
                this.drawDeleteToolbar.save();
                this.drawDeleteToolbar.disable();
                this.recalculateOverlaps();
                this.syncPolygonClusters();
            });
        } else {
            this.drawDeleteToolbar.save();
            this.drawDeleteToolbar.disable();
            this.recalculateOverlaps();
            this.syncPolygonClusters();
        }
    };

    cancelDelete = () => {
        this.setState({ delete: false, label_text: '' });
        if (this.state[this.tabID[Number(this.state.tab)]].length > this.sel_save.length) {
            this.drawDeleteToolbar.revertLayers()
        }
        this.drawDeleteToolbar.disable();

        this.sel_save.forEach(feature => {
            let tempPolygons = this.state[this.tabID[Number(this.state.tab)]].filter(item => { return feature.includes(item.guid); });
            for (let j = 0; j < tempPolygons.length; j++) {
                setTimeout(() => {
                    this.drawPolygon(tempPolygons[j], this.tabID[Number(this.state.tab)]);
                }, 20 * j);
            }
        });
    };

    resetClick = () => {
        if (this.state.manualAbGuid) this.closeManualAb();
        if (this.state.create) {
            this.cancelCreate();
        }
        if (this.state.create_circle) {
            this.cancelCreateCirculo();
        }
        if (this.state.ruler_a) {
            this.cancelRuler();
        }
        if (this.state.edit) {
            this.cancelEdit();
        }
        if (this.state.delete) {
            this.cancelDelete();
        }
        if (this.state.create_waypoint) {
            this.cancelCreateWaypoint();
        }
    };

    handlePropertyListItemClick = (divId, item, id_property) => {
        //this.selected_id_property = id_property;
        const div = document.getElementById(divId);
        for (let i = 0; i < this.state.fazenda_client.length; i++) {
            const element = this.state.fazenda_client[i];
            if (element.id !== id_property) {
                this.changeDiv(div, item);
            }

        }
        this.changeDiv(div, item);
    };

    changeDiv = (div, item, close) => {
        let panel = div ? div.nextElementSibling : null;
        const nextActive = !(item.active || close);

        item.active = nextActive;

        if (panel) {
            if (!nextActive) {
                panel.style.maxHeight = panel.scrollHeight + "px";
                setTimeout(() => {
                    panel.style.maxHeight = '0px';
                }, 20);
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
                setTimeout(() => {
                    panel.style.maxHeight = 'fit-content';
                }, 200);
            }
        }

        if (this.state.tab === '0') {
            this.setState({ folders: [...this.state.folders] });
        } else {
            this.setState({ folders_properties: [...this.state.folders_properties] });
        }
    }

    handleListItemClick = (guid, from) => {
        if (this.state.manualAbGuid) this.closeManualAb();
        if (this.clickItem) {
            this.clickItem = false;
        } else {
            const item = (this.state[from] || []).find(area => area.guid === guid);
            if (item && !item.points && this.hasLazyAreaMetadata()) {
                const center = this.getMapAreaCenter(item);
                if (center && this.mymap) {
                    this.mymap.setView(center, Math.max(this.getLazyGeometryZoom(), this.mymap.getZoom()));
                }

                this.getLazyGeometryRows([item]).then(() => {
                    this.hydrateLazyArea(item.guid, from);
                    this.requestLazyViewportRefresh();
                    this.handleClickP(guid, from);
                }).catch(() => {
                    this.handleClickP(guid, from);
                });
                return;
            }

            this.handleClickP(guid, from);
        }
    };

    showMenu = () => {
        let dF = document.getElementById('divFloat');
        if (!dF.className.includes('div-listFloatP')) {
            dF.classList.toggle("div-listFloatP");
        } else {
            dF.classList.remove("div-listFloatP");
        }
    };

    showItem = () => {
        this.showName(true, this.state.sel_poly);
        if (this.state.sel_poly.length === 1) {
            let item = this.state[this.tabID[Number(this.state.tab)]].filter(item => { return item.guid === this.state.sel_poly[0]; });
            if (item.length > 0)
                this.setState({ nameP: item[0].name });
        }
    };

    saveItem = () => {
        let names = this.state.namesC;
        //let polygons = this.state.polygons;
        for (let i = 0; i < names.length; i++) {
            let itens = this.state[this.tabID[Number(this.state.tab)]].filter(item => { return names[i].guid === item.guid });
            itens.forEach((element, key) => {
                element.name = names[i].name;
                const poly = this.mymap && this.mymap._layers ? this.mymap._layers[element.guid] : null;
                if (poly && poly.setTooltipContent) {
                    poly.setTooltipContent(element.name);
                }
                this.updateArea(element);
            });
        }
        if (names.length > 0) {
            const from = this.tabID[Number(this.state.tab)];
            this.setState({ [from]: this.state[from].slice() });
        }
        this.showName(false);
        if (this.past_merge) {
            this.past_merge = false;
        }
    };

    cancelItem = () => {
        this.showName(false);
        if (this.past_merge) {
            this.setState({ sel_poly: [] });
            this.past_merge = false;
            this.desfazer();
        }
    };

    nextIndex = (listP, prefix = this.text_polygon) => {
        let lastI = 1;
        let retorno = prefix + lastI;
        for (let i = 0; i < listP.length; i++) {
            if (listP[i].name === retorno) {
                i = -1;
                lastI++;
            }
            retorno = prefix + lastI;
        }
        return retorno;
    };

    getNewName = (name, list) => {
        let new_name = name;
        let temp_name = list.filter(item => (item.name.includes(name)));
        let run = (n) => {
            return temp_name.find(item => (item.name === n));
        }
        for (let i = 1; run(new_name); i++) {
            new_name = `${name} (${i})`;
        }
        return new_name;
    }

    fileMap = async (tFeatures, destination) => {
        if (this.isImporting) return;
        this.isImporting = true;
        this.showPro(true);

        try {
            // Permite que o overlay seja pintado antes de iniciar o trabalho pesado.
            await this.waitForNextFrame();

            const importAb = this.getImportLineAb(tFeatures);
            const preparedFeatures = await this.prepareImportFeatures(tFeatures);
            const importDestination = preparedFeatures.some(item => (item.properties._importFolderPath || []).length > 0)
                ? await this.prepareImportFolders(preparedFeatures, destination) : destination;
            const imported = await this.prepareImportedPolygonsInBatches(preparedFeatures, importDestination, importAb);

            if (imported.bounds && imported.bounds.isValid()) {
                // Never zoom closer than the cluster level during import. This
                // keeps the entire file visible as summary markers (and can
                // zoom farther out when its extent requires it).
                this.mymap.fitBounds(imported.bounds.pad(0.08), {
                    maxZoom: this.importClusterZoom,
                    animate: false
                });
            }

            // Keep the complete import in React state before persistence starts.
            // Besides the map layers, this makes the side list and its actions
            // immediately available while the server requests run.
            await this.addImportedPolygonsToState(imported.polygons);
            this.requestLazyViewportRefresh();

            // Rendering uses the existing full-screen progress indicator. Once
            // it is done, leave the map usable and show the compact map loader
            // while the import is persisted in the background.
            this.showPro(false);
            await new Promise(resolve => this.setState({ savingImportedAreas: true }, resolve));
            await this.waitForNextFrame();

            const saved = await this.saveImportedPolygons(imported.polygons);
            const savedPolygons = saved.successful;

            if (savedPolygons.length > 0) {
                savedPolygons.forEach(item => this.importingGuids.delete(item.guid));
                this.requestLazyViewportRefresh();
            }

            for (let i = 0; i < saved.failed.length; i++) {
                this.importingGuids.delete(saved.failed[i].poly.guid);
                this.removeLayer(this.featureGroupP, this.mymap._layers[saved.failed[i].poly.guid]);
            }

            if (saved.failed.length > 0) {
                await this.removeImportedPolygonsFromState(saved.failed.map(item => item.poly.guid));
                this.requestLazyViewportRefresh();
            }

            if (saved.failed.length > 0) {
                this.notifyImportSaveError(saved.failed[0].error);
            }

            if (savedPolygons.length > 0 && destination && destination.id_client) {
                this.activateImportedClientDestination(destination, savedPolygons.map(item => item.guid));
            }
        } catch (error) {
            console.error('Erro ao importar áreas', error);
            notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.ERRO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
        } finally {
            this.isImporting = false;
            this.setState({ savingImportedAreas: false });
            this.showPro(false);
        }
    };

    prepareImportFolders = async (features, destination = {}) => {
        if (!(Number(destination.id_client) > 0 && Number(destination.id_property) > 0)) {
            return destination;
        }
        const propertyId = Number(destination.id_property) || null;
        const rootId = Number(destination.id_folder_area) || null;
        const headers = { 'Authorization': localStorage.getItem('access-token-jwt') };
        const listUrl = propertyId && destination.id_client
            ? '/folder_area/client/' + destination.id_client : '/folder_area';
        const response = await fetch(Config.server + listUrl, { method: 'GET', headers });
        if (response.status !== 200) throw response;
        const folders = await response.json();
        const folderIds = Object.create(null);

        for (const feature of features) {
            const path = feature.properties._importFolderPath || [];
            let parentId = rootId;
            for (let index = 0; index < path.length; index++) {
                const key = JSON.stringify(path.slice(0, index + 1));
                if (!folderIds[key]) {
                    const folderParentId = parentId;
                    let folder = folders.find(item => item.name === path[index] &&
                        (Number(item.id_property) || null) === propertyId &&
                        (Number(item.id_folder_area) || null) === folderParentId);
                    if (!folder) {
                        const body = new URLSearchParams();
                        body.append('name', path[index]);
                        body.append('color', '#ffffff');
                        if (propertyId) body.append('id_property', propertyId);
                        if (parentId) body.append('id_folder_area', parentId);
                        const created = await fetch(Config.server + '/folder_area', { method: 'POST', headers, body });
                        if (created.status !== 200) throw created;
                        const id = Number(await created.json());
                        if (!id) throw new Error(this.props.res.IMPORT_FOLDER_ERROR);
                        folder = { id, name: path[index], id_property: propertyId, id_folder_area: parentId, color: '#ffffff' };
                        folders.push(folder);
                    }
                    folderIds[key] = folder.id;
                }
                parentId = folderIds[key];
            }
        }

        // Make new folders available to the list before imported areas are rendered.
        const field = propertyId ? 'folders_properties' : 'folders';
        const visibleFolders = folders.filter(folder => propertyId
            ? Boolean(folder.id_property) && (destination.id_client || Number(folder.id_property) === propertyId)
            : !folder.id_property);
        await new Promise(resolve => this.setState({ [field]: this.estruturaPastas(visibleFolders) }, resolve));
        return { ...destination, folderIds };
    };

    waitForNextFrame = () => new Promise(resolve => {
        window.requestAnimationFrame(resolve);
    });

    prepareImportFeatures = (features) => {
        if (typeof Worker === 'undefined') {
            return Promise.resolve(this.prepareImportFeaturesOnMainThread(features));
        }

        return new Promise((resolve, reject) => {
            const workerPath = (process.env.PUBLIC_URL || '') + '/import-map-worker.js';
            let worker;

            try {
                worker = new Worker(workerPath);
            } catch (error) {
                resolve(this.prepareImportFeaturesOnMainThread(features));
                return;
            }

            this.importWorker = worker;
            worker.onmessage = (event) => {
                if (this.importWorker === worker) {
                    this.importWorker = null;
                }
                worker.terminate();

                if (event.data && event.data.error) {
                    reject(new Error(event.data.error));
                    return;
                }

                resolve((event.data && event.data.features) || []);
            };
            worker.onerror = () => {
                if (this.importWorker === worker) {
                    this.importWorker = null;
                }
                worker.terminate();
                resolve(this.prepareImportFeaturesOnMainThread(features));
            };
            worker.postMessage({
                type: 'prepare',
                features: Array.isArray(features) ? features : [],
                tolerance: 0.000002
            });
        });
    };

    handleFilterChange = (event) => {
        this.filterInputValue = event.target.value;
        if (this.filterTimer !== null) {
            window.clearTimeout(this.filterTimer);
        }

        // Updating the list for every keystroke is expensive with thousands of
        // areas. Keep the native input responsive and only filter after a brief
        // pause in typing.
        this.filterTimer = window.setTimeout(() => {
            this.filterTimer = null;
            this.setState({ filtro: this.filterInputValue });
        }, 160);
    };

    prepareImportFeaturesOnMainThread = (features) => {
        const prepared = [];
        const addCoordinates = (properties, coordinates) => {
            if (!Array.isArray(coordinates) || coordinates.length < 3) return;

            try {
                const copy = coordinates.map(point => Array.isArray(point) ? point.slice() : point);
                const simplified = geo.simplify(copy, 0.000002);
                const points = this.geojsonToLeafletArray(simplified.geometry.coordinates[0]);

                if (points.length >= 4) {
                    prepared.push({
                        properties: properties || {},
                        points: points,
                        bounds: this.getImportMapBounds(points)
                    });
                }
            } catch (error) { }
        };

        const addPolygon = (properties, rings) => {
            if (!Array.isArray(rings)) return;
            rings.forEach((ring, ringIndex) => {
                const type = ringIndex > 0 ? 'X' : (rings.length > 1 ? 'N' : (properties.type || 'N'));
                addCoordinates({ ...properties, type }, ring);
            });
        };

        for (let i = 0; i < features.length; i++) {
            const feature = features[i];
            const geometry = feature && feature.geometry;
            const properties = feature && feature.properties ? feature.properties : {};
            if (!geometry) continue;

            if (geometry.type === 'Polygon') {
                addPolygon(properties, geometry.coordinates);
            } else if (geometry.type === 'MultiPolygon') {
                for (let j = 0; j < geometry.coordinates.length; j++) {
                    addPolygon(properties, geometry.coordinates[j]);
                }
            } else if (geometry.type === 'GeometryCollection') {
                const geometries = geometry.geometries || [];
                for (let j = 0; j < geometries.length; j++) {
                    const item = geometries[j];
                    if (item && item.type === 'Polygon') {
                        addPolygon(properties, item.coordinates);
                    } else if (item && item.type === 'LineString') {
                        addCoordinates(properties, item.coordinates);
                    }
                }
            } else if (geometry.type === 'LineString') {
                const coordinates = geometry.coordinates || [];
                const first = coordinates[0];
                const last = coordinates[coordinates.length - 1];
                if (first && last && first[0] === last[0] && first[1] === last[1]) {
                    addCoordinates(properties, coordinates);
                }
            }
        }

        return prepared;
    };

    getImportMapBounds = (points) => {
        if (!Array.isArray(points) || points.length === 0) return null;

        let minLat = Infinity;
        let maxLat = -Infinity;
        let minLng = Infinity;
        let maxLng = -Infinity;

        for (let i = 0; i < points.length; i++) {
            const point = points[i];
            const lat = Number(point && point[0]);
            const lng = Number(point && point[1]);
            if (!Number.isFinite(lat) || !Number.isFinite(lng)) continue;

            minLat = Math.min(minLat, lat);
            maxLat = Math.max(maxLat, lat);
            minLng = Math.min(minLng, lng);
            maxLng = Math.max(maxLng, lng);
        }

        if (![minLat, maxLat, minLng, maxLng].every(Number.isFinite)) return null;

        return {
            center_lat: (minLat + maxLat) / 2,
            center_lng: (minLng + maxLng) / 2,
            min_lat: minLat,
            max_lat: maxLat,
            min_lng: minLng,
            max_lng: maxLng
        };
    };

    getMapBoundsFromStoredPoints = (rawPoints) => {
        let points = rawPoints;
        try {
            if (typeof points === 'string') points = JSON.parse(points);
        } catch (e) {
            return null;
        }
        if (!Array.isArray(points)) return null;

        let minLat = Infinity;
        let maxLat = -Infinity;
        let minLng = Infinity;
        let maxLng = -Infinity;

        const visit = (value) => {
            if (!Array.isArray(value)) return;

            if (value.length >= 2 && !Array.isArray(value[0]) && !Array.isArray(value[1])) {
                const lat = Number(value[0]);
                const lng = Number(value[1]);
                if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

                minLat = Math.min(minLat, lat);
                maxLat = Math.max(maxLat, lat);
                minLng = Math.min(minLng, lng);
                maxLng = Math.max(maxLng, lng);
                return;
            }

            for (let i = 0; i < value.length; i++) visit(value[i]);
        };

        visit(points);
        if (![minLat, maxLat, minLng, maxLng].every(Number.isFinite)) return null;

        return {
            center_lat: (minLat + maxLat) / 2,
            center_lng: (minLng + maxLng) / 2,
            min_lat: minLat,
            max_lat: maxLat,
            min_lng: minLng,
            max_lng: maxLng
        };
    };

    getUniqueImportName = (name, usedNames) => {
        const baseName = String(name || '').trim() || this.text_polygon + '1';
        let candidate = baseName;
        let suffix = 1;

        while (usedNames.has(candidate)) {
            candidate = baseName + ' (' + suffix + ')';
            suffix++;
        }

        usedNames.add(candidate);
        return candidate;
    };

    getImportLineAb = (features) => {
        const fromGeometry = geometry => {
            if (!geometry) return null;
            if (geometry.type === 'LineString') {
                const points = geometry.coordinates;
                if (!Array.isArray(points) || points.length !== 2 ||
                    !points.every(point => Array.isArray(point) && point.length >= 2)) return null;
                const ab = this.parseAreaAb(points.map(point => [point[1], point[0]]), 'N');
                return ab && (ab[0][0] !== ab[1][0] || ab[0][1] !== ab[1][1]) ? ab : null;
            }

            const geometries = geometry.type === 'GeometryCollection'
                ? geometry.geometries || []
                : (geometry.type === 'MultiLineString' ? (geometry.coordinates || []).map(coordinates => ({
                    type: 'LineString', coordinates
                })) : []);
            for (let i = 0; i < geometries.length; i++) {
                const ab = fromGeometry(geometries[i]);
                if (ab) return ab;
            }
            return null;
        };

        for (let i = 0; i < features.length; i++) {
            const ab = fromGeometry(features[i] && features[i].geometry);
            if (ab) return ab;
        }
        return null;
    };

    prepareImportedPolygonsInBatches = (preparedFeatures, destination, importAb = null) => new Promise(resolve => {
        const existingPolygons = this.state.polygons.concat(this.state.areas_client);
        const usedGuids = new Set(existingPolygons.map(item => item.guid).filter(Boolean));
        const usedNames = new Set(existingPolygons.map(item => String(item.name || '').trim()).filter(Boolean));
        const savedColors = this.getAreaColorsStorage();
        const importedPolygons = [];
        const importedBounds = L.latLngBounds([]);
        const importAngle = importAb ? (turf.bearing(
            turf.point([importAb[0][1], importAb[0][0]]),
            turf.point([importAb[1][1], importAb[1][0]])
        ) + 360) % 360 : null;
        let defaultNameIndex = 1;
        let index = 0;

        const nextDefaultName = () => {
            let name = this.text_polygon + defaultNameIndex;
            while (usedNames.has(name)) {
                defaultNameIndex++;
                name = this.text_polygon + defaultNameIndex;
            }
            defaultNameIndex++;
            return name;
        };

        const drawBatch = () => {
            const end = Math.min(index + this.importBatchSize, preparedFeatures.length);

            for (; index < end; index++) {
                const prepared = preparedFeatures[index];
                try {
                    const properties = prepared.properties || {};
                    const points = prepared.points || [];
                    if (points.length < 4) continue;

                    let guid = properties.guid && !usedGuids.has(properties.guid) ? properties.guid : tools.newGuid();
                    while (usedGuids.has(guid)) {
                        guid = tools.newGuid();
                    }
                    usedGuids.add(guid);

                    const initialName = properties.name ? properties.name : (properties.recibo ? properties.recibo : nextDefaultName());
                    const tempPoly = new polygon();
                    tempPoly.guid = guid;
                    tempPoly.name = this.getUniqueImportName(initialName, usedNames);
                    tempPoly.type = !properties.type ? 'N' : properties.type;
                    tempPoly.ab = this.parseAreaAb(properties.ab, tempPoly.type);
                    tempPoly.x = properties.type === 'X' ? guid.split('_xcl')[0] : '';
                    tempPoly.custom_color = savedColors[guid] || properties.custom_color || '';
                    tempPoly.visible = true;
                    tempPoly.points = JSON.stringify(points);
                    tempPoly.svg = '';
                    // Imported areas remain as summaries until the map reaches
                    // the geometry zoom. Their points are retained for saving
                    // and for the lazy renderer, but are not drawn now.
                    tempPoly._lazyViewport = true;

                    const bounds = prepared.bounds || this.getImportMapBounds(points);
                    if (bounds) {
                        tempPoly.center_lat = bounds.center_lat;
                        tempPoly.center_lng = bounds.center_lng;
                        tempPoly.min_lat = bounds.min_lat;
                        tempPoly.max_lat = bounds.max_lat;
                        tempPoly.min_lng = bounds.min_lng;
                        tempPoly.max_lng = bounds.max_lng;
                        importedBounds.extend([bounds.min_lat, bounds.min_lng]);
                        importedBounds.extend([bounds.max_lat, bounds.max_lng]);
                    }

                    if (importAngle !== null && tempPoly.type === 'N') {
                        tempPoly.ab = this.centerManualAb(tempPoly, importAngle, 0);
                    }

                    if (destination) {
                        tempPoly.id_client = destination.id_client;
                        tempPoly.id_property = destination.id_property;
                        tempPoly.id_folder_area = (destination.folderIds && destination.folderIds[JSON.stringify(properties._importFolderPath || [])])
                            || destination.id_folder_area;
                    }

                    this.importingGuids.add(tempPoly.guid);
                    importedPolygons.push(tempPoly);
                } catch (error) {
                    console.warn('Área ignorada durante a importação', error);
                }
            }

            if (index < preparedFeatures.length) {
                this.waitForNextFrame().then(drawBatch);
            } else {
                resolve({ polygons: importedPolygons, bounds: importedBounds });
            }
        };

        this.waitForNextFrame().then(drawBatch);
    });

    saveImportedPolygonBatch = async (polygons) => {
        const areas = new Array(polygons.length);

        for (let i = 0; i < polygons.length; i++) {
            const poly = polygons[i];
            const points = JSON.parse(poly.points);
            for (let pointIndex = 0; pointIndex < points.length; pointIndex++) {
                points[pointIndex] = [
                    tools.round(points[pointIndex][0], 7),
                    tools.round(points[pointIndex][1], 7)
                ];
            }

            // Keep the client copy identical to the points sent to the server,
            // so it can immediately populate the lazy geometry cache.
            poly.points = JSON.stringify(points);
            areas[i] = {
                id_region: poly.id_region,
                id_property: poly.id_property,
                id_folder_area: poly.id_folder_area,
                guid: poly.guid,
                points: poly.points,
                type: poly.type,
                ab: this.parseAreaAb(poly.ab, poly.type),
                name: poly.name,
                custom_color: poly.custom_color || ''
            };
        }

        const response = await fetch(Config.server + '/areas/import', {
            method: 'PUT',
            body: JSON.stringify({ areas: areas }),
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt'),
                'Content-Type': 'application/json'
            }
        });

        if (response.status !== 200) throw response;
        const result = await response.json();
        const importedAreas = Array.isArray(result && result.areas) ? result.areas : [];
        const idsByGuid = new Map();
        for (let i = 0; i < importedAreas.length; i++) {
            const imported = importedAreas[i];
            const id = Number(imported && imported.id);
            if (imported && imported.guid && Number.isInteger(id) && id > 0) {
                idsByGuid.set(imported.guid, id);
            }
        }

        for (let i = 0; i < polygons.length; i++) {
            const poly = polygons[i];
            const id = idsByGuid.get(poly.guid);
            if (!id) throw new Error('The imported area did not receive an id');
            poly.id = id;
            this.cacheAreaGeometry(poly);
        }

        return polygons;
    };

    saveImportedPolygons = async (polygons) => {
        const successful = [];
        const failed = [];
        for (let start = 0; start < polygons.length; start += this.importSaveBatchSize) {
            const batch = polygons.slice(start, start + this.importSaveBatchSize);
            try {
                const saved = await this.saveImportedPolygonBatch(batch);
                successful.push.apply(successful, saved);
            } catch (error) {
                for (let i = 0; i < batch.length; i++) {
                    failed.push({ poly: batch[i], error: error });
                }
            }
        }

        return { successful: successful, failed: failed };
    };

    addImportedPolygonsToState = (polygons) => new Promise(resolve => {
        const localPolygons = polygons.filter(item => !item.id_client);
        const clientPolygons = polygons.filter(item => !!item.id_client);

        this.setState(previousState => ({
            polygons: previousState.polygons.concat(localPolygons),
            areas_client: previousState.areas_client.concat(clientPolygons)
        }), resolve);
    });

    removeImportedPolygonsFromState = (guids) => new Promise(resolve => {
        const removed = new Set(guids || []);
        if (removed.size === 0) {
            resolve();
            return;
        }

        this.setState(previousState => ({
            polygons: previousState.polygons.filter(item => !removed.has(item.guid)),
            areas_client: previousState.areas_client.filter(item => !removed.has(item.guid)),
            sel_poly: previousState.sel_poly.filter(guid => !removed.has(guid))
        }), resolve);
    });

    notifyImportSaveError = (error) => {
        if (error && (error.status === 401 || error.status === 403)) {
            this.props.link('/login');
            return;
        }

        notification.open({
            message: error && error.status === 405 ? this.props.res.PERMISSAO : this.props.res.ERRO,
            description: error && error.status === 405 ? this.props.res.PERMISSAO_MSG : this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
        });
    };

    geojsonToLeafletArray = (poly) => {
        let array = [];
        for (let i = 0; i < poly.length; i++) {
            const element = poly[i];
            if (element) {
                array.push([element[1], element[0]]);
            } else {

            }
        }
        return array
    };

    showGoto = () => {
        if (this.state.goto) {
            this.setState({ goto: false });
        } else {
            const centerLat = this.mymap.getCenter().lat;
            const centerLng = this.mymap.getCenter().lng;

            let lat = {
                error: false,
                input: this.formatCoordText(centerLat, 'latitude'),
                value: centerLat
            };

            let lng = {
                error: false,
                input: this.formatCoordText(centerLng, 'longitude'),
                value: centerLng
            };

            this.setState({ goto: true, lat: lat, lng: lng });

            window.history.replaceState(null, "Travicar", "/app/draw/" + this.round_coord(centerLat) + ',' + this.round_coord(centerLng));
        }
    };

    goto = (type, lat, lng) => {
        this.setState({ goto: false });
        if (!type) {
            this.mymap.setView([this.state.lat.value, this.state.lng.value]);
        } else if (type === 'poly') {
            let bounds = this.featureGroupP.getBounds();
            bounds.isValid() && this.mymap.fitBounds(bounds);
        } else if (type === 'home') {
            if (this.state.home !== Config.place) {
                this.mymap.setView(this.state.home);
            }
        } else if (type === 'sel_poly') {
            if (this.state.sel_poly.length > 0) {
                const from = this.tabID[Number(this.state.tab)];
                const polygons = this.state[from] || [];
                const polygonsByGuid = new Map();
                for (let i = 0; i < polygons.length; i++) {
                    polygonsByGuid.set(polygons[i].guid, polygons[i]);
                }

                // Summary rows already contain the area bounding box, so the
                // selected extent can be calculated without waiting for (or
                // depending on) a rendered Leaflet geometry.
                let bounds = L.latLngBounds([]);
                for (let i = 0; i < this.state.sel_poly.length; i++) {
                    const guid = this.state.sel_poly[i];
                    const polygon = polygonsByGuid.get(guid);
                    const minLat = polygon ? Number(polygon.min_lat) : NaN;
                    const maxLat = polygon ? Number(polygon.max_lat) : NaN;
                    const minLng = polygon ? Number(polygon.min_lng) : NaN;
                    const maxLng = polygon ? Number(polygon.max_lng) : NaN;

                    if (Number.isFinite(minLat) && Number.isFinite(maxLat) &&
                        Number.isFinite(minLng) && Number.isFinite(maxLng)) {
                        bounds.extend([minLat, minLng]);
                        bounds.extend([maxLat, maxLng]);
                    } else {
                        // Locally-created areas and old records may not have a
                        // stored box yet. Keep the rendered geometry as fallback.
                        const layer = this.mymap._layers[guid];
                        if (layer && layer.getBounds) {
                            const layerBounds = layer.getBounds();
                            if (layerBounds && layerBounds.isValid && layerBounds.isValid()) {
                                bounds.extend(layerBounds);
                            }
                        }
                    }
                }
                bounds.isValid() && this.mymap.fitBounds(bounds);
            }
        } else if (type === 'search') {
            this.mymap.setView([lat, lng], 19);
            this.setState({ listSearch: [] });
        }
    };

    getOrigem = (oPoly) => {
        let polys = [];

        let inP = (poly) => {
            //let polyx = this.state.polygons.filter(itemP => { return itemP.guid.includes(oPoly.guid); });
            //if (poly.old === null || polyx.length === 1) {
            polys.push(L.polygon(JSON.parse(poly.points)).toGeoJSON());
            /*} else {
                for (let i = 0; i < poly.old.ob.length; i++) {
                    if (poly.old.ob[i].type !== 'X') {
                        inP(poly.old.ob[i]);
                    }
                }
            }*/
        }

        inP(oPoly);

        return polys;
    };

    searchLocation = (type, guid) => {
        let apiUrl = Config.server + '/search_location';
        let method = 'POST';

        let body = {
            type: type,
            session_token: this.state.search_token
        };
        if (type === 'search') {
            body.text = this.state.search_text;
        } else if (guid) {
            body.guid = guid;
        }

        let options = {
            method: method,
            body: JSON.stringify(body),
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt'),
                'Content-Type': 'application/json'
            }
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    this.setState({ listSearch: result.list });
                },
                (error) => {
                    this.showPro(false);
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        console.log(error);
                        this.props.link('/login');
                    }
                    else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    }

    getMergeAreas = () => {
        const items = this.state[this.tabID[Number(this.state.tab)]] || [];
        const byGuid = this.getPolygonSelectionIndex(items).byGuid;
        const selected = this.state.sel_poly.map(guid => byGuid.get(guid) ||
            (this.trim_poly && this.trim_poly.guid === guid ? this.trim_poly : null)).filter(Boolean);
        const normal = selected.filter(area => area.type === 'N');
        if (normal.length > 0) return normal;
        return selected.every(area => area.type === 'X' || area.type === 'XL') ? selected : [];
    };

    getMergePolygonGeoJson = (area) => {
        const layer = this.mymap._layers[area.guid];
        if (!(area.radius > 0) && layer && typeof layer.toGeoJSON === 'function') {
            const feature = layer.toGeoJSON(12);
            if (feature.geometry && ['Polygon', 'MultiPolygon'].includes(feature.geometry.type)) return feature;
        }
        if (!area.points) return null;
        const points = typeof area.points === 'string' ? JSON.parse(area.points) : area.points;
        return L.polygon(points).toGeoJSON(12);
    };

    openMerge = async (type = this.lastType) => {
        const request = this.mergeSuggestionRequest = (this.mergeSuggestionRequest || 0) + 1;
        const areas = this.getMergeAreas();
        if (areas.length < 2 && !this.state.merge) return;
        const from = this.tabID[Number(this.state.tab)];
        const selectedGuids = areas.map(area => area.guid).join(',');
        type = String(type);
        if (type === '2' || type === '5') this.lastType = type;
        await new Promise(resolve => this.setState({ merge: true, type }, resolve));
        if (request !== this.mergeSuggestionRequest || areas.length < 2 || type !== '5' || this.state.split || !this.state.merge || this.state.type !== '5') return;
        let loading = false;
        try {
            const missing = areas.filter(area => !this.getMergePolygonGeoJson(area));
            if (missing.length > 0) {
                loading = true;
                this.showPro(true);
                await this.getLazyGeometryRows(missing);
                missing.forEach(area => this.hydrateLazyArea(area.guid, from));
            }
            if (request !== this.mergeSuggestionRequest || !this.state.merge || this.state.type !== '5' || this.state.split ||
                from !== this.tabID[Number(this.state.tab)] || selectedGuids !== this.getMergeAreas().map(area => area.guid).join(',')) return;
            const size = getSuggestedMergeSize(areas.map(area => this.getMergePolygonGeoJson(area)));
            if (size === null) throw new Error('merge-geometry-unavailable');
            this.setState({ gap_size: size });
        } catch (error) {
            notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.ERRO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
        } finally {
            if (loading) this.showPro(false);
        }
    };

    junta = () => {
        const areas = this.getMergeAreas();
        this.showPro(true);
        this.setState({ merge: false });
        if (areas.length > 1) {
            let apiUrl = Config.server + '/merge_polygons';
            let method = 'POST';

            const formData = new URLSearchParams();

            let polys = [];
            areas.forEach(oPoly => {
                const geoj = this.getMergePolygonGeoJson(oPoly);
                if (geoj) {
                    polys.push(geo.simplify(geoj.geometry.coordinates[0], 0.000002));
                }
            });
            formData.append('polygons', JSON.stringify(polys));
            //formData.append('origem', JSON.stringify(origem));
            formData.append('polygons_xcl', JSON.stringify([]));
            formData.append('size', this.state.gap_size);
            formData.append('type', this.state.type);

            let options = {
                method: method,
                body: formData,
                headers: {
                    'Authorization': localStorage.getItem('access-token-jwt')
                }
            }

            fetch(apiUrl, options)
                .then((res) => {
                    if (res.status !== 200) throw res;
                    else return res.json();
                })
                .then(
                    (result) => {
                        this.showPro(false);
                        //this.setState({ progress: false });
                        if (result.msgErro) {
                            this.removeFailedMergeTrim();
                            notification.open({
                                message: result.msgErro,
                                icon: <MaterialIcon icon="error" className="text-danger" />
                            });
                        } else if (result.poly) {
                            this.merge(result, areas);
                        } else {
                            this.removeFailedMergeTrim();
                            notification.open({
                                message: this.props.res.ERRO,
                                description: this.props.res.ERRO_MSG,
                                icon: <MaterialIcon icon="error" className="text-danger" />
                            });
                        }
                    },
                    (error) => {
                        this.showPro(false);
                        this.removeFailedMergeTrim();
                        //this.setState({ progress: false });
                        if (error.status === 405) {
                            notification.open({
                                message: this.props.res.PERMISSAO,
                                description: this.props.res.PERMISSAO_MSG,
                                icon: <MaterialIcon icon="error" className="text-danger" />
                            });
                        } else if (error.status === 401 || error.status === 403) {
                            console.log(error);
                            this.props.link('/login');
                        }
                        else {
                            console.log(error);
                            notification.open({
                                message: this.props.res.ERRO,
                                description: this.props.res.ERRO_MSG,
                                icon: <MaterialIcon icon="error" className="text-danger" />
                            });
                        }
                    }
                );
        } else {
            this.showPro(false);
            //this.setState({ progress: false });
        }
    };

    removeLayer = (map, layer) => {
        if (layer) {
            map.removeLayer(layer)
        }
    };

    removeFailedMergeTrim = () => {
        const trim = this.trim_poly;
        if (!trim || !this.state.sel_poly.includes(trim.guid)) return;

        this.removeLayer(this.featureGroupP, this.mymap._layers[trim.guid]);
        this.trim_poly = null;
        this.setState({
            merge: false,
            showTrim: false,
            sel_poly: this.state.sel_poly.filter(guid => guid !== trim.guid)
        });
    };

    merge = (polyFinal, areas = this.getMergeAreas()) => {
        const sourceGuids = new Set(areas.map(area => area.guid));
        const type = areas.every(area => area.type === 'X' || area.type === 'XL') ? 'X' : 'N';
        let simpl = geo.simplify(polyFinal.poly.geometry.coordinates[0], 0.000002);
        let latlngs = this.geojsonToLeafletArray(simpl.geometry.coordinates[0]);

        let guid = tools.newGuid();
        let name = this.nextIndex(this.state.polygons, type === 'X' ? 'xcl' : this.text_polygon);

        let polys = { ob: [] };
        let ids = [];
        sourceGuids.forEach(element => {
            let l = this.mymap._layers[element];
            this.removeLayer(this.featureGroupP, l);

            let temp_poly = this.state.polygons.filter(itemP => { return itemP.guid === element; });
            if (temp_poly.length > 0) {
                polys.ob = polys.ob.concat(temp_poly);

                if (this.state.tab === '0') {
                    ids.push(temp_poly[0].id);
                }
            }
        });
        if (ids.length > 0) {
            this.deleteArea(ids);
        }

        let itens = this.state.polygons.filter(item => { return !sourceGuids.has(item.guid); });

        let tempRumo = new polygon();
        tempRumo.type = type;
        tempRumo.guid = guid;
        tempRumo.name = name;
        tempRumo.points = JSON.stringify(latlngs);
        tempRumo.svg = this.generateSVGPath(latlngs);
        tempRumo.old = polys;
        tempRumo.visible = true;

        this.drawPolygon(tempRumo, this.tabID[0]);

        itens.push(tempRumo);
        this.updateArea(tempRumo);
        this.setState({ sel_poly: [] });
        let select = [guid];

        //area de exclusao 
        let x = polyFinal.x;
        if (x) {
            if (x.type === 'Feature') {
                x = { features: [x] };
            }
            if (Array.isArray(x)) {
                x = { features: x };
            }
            if (x.features) {
                for (let i = 0; i < x.features.length; i++) {
                    if (x.features[i] && x.features[i].geometry.type === 'Polygon') {
                        const element = x.features[i];
                        simpl = geo.simplify(element.geometry.coordinates[0], 0.000002);
                        let latlngs2 = this.geojsonToLeafletArray(simpl.geometry.coordinates[0]);

                        let tempRumoX = new polygon();
                        tempRumoX.guid = tools.newGuid();
                        tempRumoX.name = this.nextIndex(itens, 'xcl');
                        tempRumoX.points = JSON.stringify(latlngs2);
                        tempRumoX.svg = this.generateSVGPath(latlngs2);
                        tempRumoX.x = guid;
                        tempRumoX.type = 'X';
                        tempRumoX.visible = true;
                        setTimeout(() => {
                            this.drawPolygon(tempRumoX, this.tabID[0]);
                        }, 20 * i);
                        this.updateArea(tempRumoX);
                        itens.push(tempRumoX);
                        select.push(tempRumoX.guid);
                    }
                }
            }
        }
        /*
        //area de teste 
        let polys2 = polyFinal.polys;
        if (polys2) {
            for (let i = 0; i < polys2.length; i++) {
                const element = polys2[i];
                simpl = geo.simplify(element.geometry.coordinates[0], 0.000002);
                let latlngs2 = this.geojsonToLeafletArray(simpl.geometry.coordinates[0]);

                let tempRumoX = new polygon();
                tempRumoX.guid = tools.newGuid();
                tempRumoX.name = 'N_' + (i + 1);
                tempRumoX.points = JSON.stringify(latlngs2);
                tempRumoX.x = guid;
                tempRumoX.type = 'N';

                this.drawPolygon(tempRumoX, this.tabID[0]);
                this.updateArea(tempRumoX);
                itens.push(tempRumoX);
                select.push(tempRumoX.guid);
            }
        }*/

        //this.savePolygons(itens);
        this.setState({ polygons: itens, tab: '0', sel_poly: [], namesC: [], valid_nameP: true }, () => {
            this.past_merge = true;
            //let myLayer = this.mymap._layers[guid];
            this.handleClickP(guid, this.tabID[0]);
        });

    };
    //desfazer merge
    desfazer = () => {
        if (this.state.sel_poly.length > 0) {
            let polygons = this.state[this.tabID[Number(this.state.tab)]];
            let poly = polygons.filter(item => {
                return (this.state.sel_poly.includes(item.guid) && item.old)
            });
            let addRemove = [];
            poly.forEach((element) => {
                if (!addRemove.includes(element.guid)) {
                    let remove = [];

                    let idRemove = [];
                    polygons.forEach(item => {
                        if (element.old === item.old || item.x === element.guid) {
                            remove.push(item.guid);
                            if (item.id) {
                                idRemove.push(item.id);
                            }
                        }
                    });
                    if (idRemove.length > 0) {
                        this.deleteArea(idRemove);
                    }

                    addRemove = addRemove.concat(remove);
                    remove.forEach(item => {
                        this.removeLayer(this.featureGroupP, this.mymap._layers[item]);
                    });

                    for (let j = 0; j < element.old.ob.length; j++) {
                        let polyItem = polygons.filter(item => element.old.ob[j].guid === item.guid);
                        if (polyItem.length > 0) {
                            polyItem[j] = element.old.ob[j];
                            this.removeLayer(this.featureGroupP, this.mymap._layers[polyItem[0].guid]);
                        } else {
                            element.old.ob[j].id = null;
                            polygons.push(element.old.ob[j]);
                            this.updateArea(element.old.ob[j]);
                            setTimeout(() => {
                                this.drawPolygon(element.old.ob[j], this.tabID[Number(this.state.tab)]);
                            }, 20 * j);
                        }
                    }

                    polygons = polygons.filter(item => !remove.includes(item.guid));
                }
            });
            this.setState({ sel_merge: false, label_text: '', sel_poly: [], polygons: polygons });
        }
    };

    parseAreaAb = (value, type) => {
        if (type !== 'N' || !value) return null;
        try {
            const ab = typeof value === 'string' ? JSON.parse(value) : value;
            if (!Array.isArray(ab) || ab.length !== 2 || !ab.every(point =>
                Array.isArray(point) && point.length === 2 &&
                point.every(coordinate => typeof coordinate === 'number' && Number.isFinite(coordinate)) &&
                Math.abs(point[0]) <= 90 && Math.abs(point[1]) <= 180)) return null;
            return ab.map(point => point.slice());
        } catch (error) { return null; }
    };

    download = async () => {
        const selectedGuids = Array.isArray(this.state.sel_poly) ? this.state.sel_poly.slice() : [];
        if (selectedGuids.length === 0 || this.downloadInProgress) return;

        const tabKey = this.tabID[Number(this.state.tab)];
        const areas = this.state[tabKey] || [];
        const areasByGuid = new Map(areas.map(area => [area.guid, area]));
        const selectedAreas = selectedGuids.map(guid => areasByGuid.get(guid));
        if (selectedAreas.some(area => !area)) {
            notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.DOWNLOAD_POLYGONS_NOT_FOUND
            });
            return;
        }

        const formatGeometryProgress = (loaded) => {
            const template = this.props.res && this.props.res.DOWNLOAD_GEOMETRIES_PROGRESS;
            if (typeof template !== 'string') return '';
            return template
                .replace('{loaded}', String(loaded))
                .replace('{total}', String(selectedAreas.length));
        };

        this.downloadInProgress = true;
        try {
            this.setState({
                downloading: true,
                downloadProgress: 0,
                downloadStatus: formatGeometryProgress(0)
            });

            const selectedSet = new Set(selectedGuids);
            const updateGeometryProgress = () => {
                const currentAreas = this.state[tabKey] || [];
                let loaded = 0;
                const updatedAreas = currentAreas.map(area => {
                    if (!area || !selectedSet.has(area.guid)) return area;
                    const hydratedArea = this.hydrateLazyArea(area.guid, tabKey) || area;
                    if (hydratedArea.points) loaded += 1;
                    return hydratedArea;
                });

                this.setState({
                    [tabKey]: updatedAreas,
                    downloadProgress: Math.floor((loaded / selectedAreas.length) * 100),
                    downloadStatus: formatGeometryProgress(loaded)
                });
            };

            // Load in endpoint-sized batches. Hydrate the page list after each
            // batch so loaded points stay available for later map/list actions.
            updateGeometryProgress();
            for (let start = 0; start < selectedAreas.length; start += this.lazyGeometryRequestLimit) {
                const batch = selectedAreas.slice(start, start + this.lazyGeometryRequestLimit);
                await this.getLazyGeometryRows(batch);
                updateGeometryProgress();
            }

            const hydratedAreas = selectedAreas.map(area => this.hydrateLazyArea(area.guid, tabKey) || area);
            if (hydratedAreas.some(area => !area.points)) {
                throw new Error('geometry-not-found');
            }

            const polys = [];
            hydratedAreas.forEach(poly => {
                const layer = this.mymap && this.mymap._layers ? this.mymap._layers[poly.guid] : null;
                const hasLayer = !!(layer && typeof layer.toGeoJSON === 'function');
                let item = hasLayer
                    ? layer.toGeoJSON()
                    : L.polygon(JSON.parse(poly.points)).toGeoJSON();

                if (item.type === 'FeatureCollection') {
                    item = item.features[0];
                }

                const type = poly.type === 'T' ? 'T' : (poly.x || poly.type === 'X' ? 'X' : 'N');
                if ((item.geometry && item.geometry.type === 'Point') || (!hasLayer && Number(poly.radius) > 0)) {
                    item = L.polygon(JSON.parse(poly.points)).toGeoJSON();
                    item.properties = {
                        name: poly.name,
                        type,
                        guid: poly.guid,
                        point: poly.point,
                        radius: poly.radius
                    };
                } else {
                    item.properties = {
                        name: poly.name,
                        type,
                        guid: poly.guid
                    };
                }

                const ab = this.parseAreaAb(poly.ab, poly.type);
                if (item.properties.type === 'N' && ab) item.properties.ab = ab;
                polys.push(item);
            });

            this.setState({ downloadProgress: 0, downloadStatus: this.props.res.DOWNLOAD_GENERATING_KMZ || '' });
            const zip = new jszip();
            const fileName = Date.now() + '.kml';
            zip.file(fileName, geo.toKml(fileName, polys));

            let lastProgress = -1;
            const content = await zip.generateAsync(
                { type: 'blob', compression: 'DEFLATE', compressionOptions: { level: 4 } },
                metadata => {
                    const progress = Math.round(metadata.percent || 0);
                    if (progress !== lastProgress) {
                        lastProgress = progress;
                        this.setState({ downloadProgress: progress });
                    }
                }
            );
            saveAs(content, 'areas.kmz');
        } catch (error) {
            if (error && error.status === 401) {
                this.props.link('/login');
            } else {
                notification.open({
                    message: this.props.res.ERRO,
                    description: this.props.res.DOWNLOAD_KMZ_ERROR || this.props.res.ERRO_MSG
                });
            }
        } finally {
            this.downloadInProgress = false;
            this.setState({ downloading: false, downloadProgress: null, downloadStatus: '' });
        }
    };

    changeType = (from, type) => {
        const selected = this.getSelectedZonePolygon();
        let sel = selected ? [selected.guid] : this.state.sel_poly;
        this.setState({ sel_poly: [] });
        sel.forEach((item, i) => {
            let poly = this.state[from].filter(i => { return i.guid === item })[0];
            if (!poly) return;
            poly.type = type || (poly.type === 'N' ? 'X' : 'N');
            if (poly.type !== 'X') poly.x = '';
            let layer = this.mymap._layers[item];
            this.removeLayer(this.featureGroupP, layer);
            setTimeout(() => {
                this.drawPolygon(poly, from);
            }, 20 * i);
            this.updateArea(poly, false);
            // if ((!poly.x || poly.x === poly.guid) && !poly.old) {
            //     if (poly.type !== 'N') {
            //         poly.type = 'N';
            //     } else {
            //         poly.type = 'X';
            //     }
            //     let layer = this.mymap._layers[item];
            //     this.removeLayer(this.featureGroupP, layer);
            //     this.drawPolygon(poly, from);
            //     this.updateArea(poly, false);
            // }
        });
    };

    loadPolygons = (polys, setView) => {
        if (polys) {
            try {
                polys.forEach((element, i) => {
                    if (!element || element._lazyViewport || (!element.points && !(element.radius > 0 && element.point))) return;
                    // FIX Poly with _xcl id, but N type
                    if (element.guid.includes('_xcl')) {
                        element.type = 'X';
                    }
                    this.drawPolygon(element, this.tabID[Number(this.state.tab)]);
                });
                if (polys.length > 0) {
                    if (setView) {
                        this.mymap.fitBounds(this.featureGroupP.getBounds());
                    }
                }
                this.syncPolygonClusters();
            }
            catch (e) { }
        }
    };

    drawPolygon = (poly, from, options = {}) => {
        if (!poly || (!poly.points && !(poly.radius > 0 && poly.point))) return;

        let isSelected = this.state.sel_poly.includes(poly.guid);
        let baseColor = this.getPolygonColor(poly);

        let myStyle = {
            "color": isSelected ? this.color_selected : baseColor,
            "weight": 4,
            "opacity": 0.5,
            "fillColor": isSelected ? this.color_selected : baseColor,
            "fillOpacity": 0.2
        };

        if (poly.type === 'X' || poly.x) {
            myStyle = {
                "color": this.color_x,
                "weight": 2,
                "opacity": 1,
                "fillColor": this.color_x,
                "fillOpacity": 0.2
            };
        } else if (poly.type === 'T') {
            myStyle = {
                "color": this.color_t,
                "weight": 2,
                "opacity": 1,
                "fillColor": this.color_t,
                "fillOpacity": 0.2
            };
        }

        let myLayer = null;
        if (poly.radius > 0) {
            let temp_myStyle = {
                color: myStyle.color,
                weight: myStyle.weight,
                opacity: myStyle.opacity,
                fillColor: myStyle.fillColor,
                fillOpacity: myStyle.fillOpacity,
                radius: poly.radius
            };
            myLayer = L.circle(poly.point, options.renderer
                ? Object.assign({}, temp_myStyle, { renderer: options.renderer })
                : temp_myStyle);
            if (!options.skipAreaCalculation) {
                poly.area = poly.radius * poly.radius * Math.PI;
            }
        } else {
            myLayer = L.polygon(JSON.parse(poly.points), options.renderer
                ? Object.assign({}, myStyle, { renderer: options.renderer })
                : myStyle);
            if (!options.skipAreaCalculation) {
                poly.area = L.GeometryUtil.geodesicArea(myLayer.getLatLngs()[0]);
            }
        }

        let guid = poly.guid;
        let name = this.getPolygonLabel ? this.getPolygonLabel(poly) : poly.name;
        myLayer.on("click", (e) => {
            if (e) {
                L.DomEvent.stopPropagation(e);
            }
            this.handleClickP(guid, from);
        });

        myLayer._leaflet_id = guid;

        myLayer.bindTooltip(name, options.hoverTooltip
            ? { permanent: false, direction: "top", className: 'tool-tip-L tool-tip-size16-L' }
            : { permanent: true, direction: "center", className: 'tool-tip-L tool-tip-size16-L' }
        );
        myLayer._lazyHoverTooltip = !!options.hoverTooltip;

        myLayer.addTo(this.featureGroupP);
        if (this.state.edit && myLayer.editing) {
            if (isSelected) {
                if (myLayer.editing.enable) myLayer.editing.enable();
                myLayer.setStyle({ color: this.color_edit });
            } else if (myLayer.editing.disable) {
                myLayer.editing.disable();
            }
        }
        if (!options.hoverTooltip) {
            // Keep the label closed while a geometry batch is being drawn.
            // syncPolygonClusters/updatePolygonTooltipsVisibility opens only
            // the labels that pass the visibility and overlap rules.
            this.setLayerTooltipVisibility(myLayer, false);
        }
        return myLayer;
    };

    getCurrentPolygonList = () => {
        return this.state.tab === '0' ? this.state.polygons : this.state.areas_client;
    };

    hydrateLazyArea = (guid, from) => {
        const areas = this.state[from] || [];
        const area = areas.find(item => item && item.guid === guid);
        const geometry = area && this.lazyGeometryCache.get(Number(area.id));
        if (!area || !geometry || !geometry.points) return area;

        area.points = geometry.points;
        area.radius = geometry.radius || area.radius;
        area.point = geometry.point || area.point;
        if (!area.svg) area.svg = this.getListGeometryPreview(geometry.points);
        return area;
    };

    getPolygonBaseStyle = (poly) => {
        const polygonColor = this.getPolygonColor(poly);
        let myStyle = {
            color: this.state.sel_poly.includes(poly.guid) ? this.color_selected : polygonColor,
            weight: 4,
            opacity: 0.5,
            fillColor: this.state.sel_poly.includes(poly.guid) ? this.color_selected : polygonColor,
            fillOpacity: 0.2
        };

        if (poly.type === 'X' || poly.x) {
            myStyle = {
                color: this.state.sel_poly.includes(poly.guid) ? this.color_selected : this.color_x,
                weight: 2,
                opacity: 1,
                fillColor: this.state.sel_poly.includes(poly.guid) ? this.color_selected : this.color_x,
                fillOpacity: 0.2
            };
        } else if (poly.type === 'T') {
            myStyle = {
                color: this.state.sel_poly.includes(poly.guid) ? this.color_selected : this.color_t,
                weight: 2,
                opacity: 1,
                fillColor: this.state.sel_poly.includes(poly.guid) ? this.color_selected : this.color_t,
                fillOpacity: 0.2
            };
        }

        return myStyle;
    }

    getPolygonLabel = (poly) => {
        if (!poly) return '';
        return poly.has_overlap ? (poly.name + ' (Sobreposição)') : poly.name;
    };

    buildPolygons = (poly) => {
        if (!poly || !poly.points) return [];

        if (poly._overlapPartsCacheKey === poly.points && Array.isArray(poly._overlapPartsCache)) {
            return poly._overlapPartsCache;
        }

        let coords = null;
        try {
            coords = typeof poly.points === 'string' ? JSON.parse(poly.points) : poly.points;
        } catch (e) {
            coords = null;
        }

        if (!coords || !Array.isArray(coords) || coords.length < 3) {
            poly._overlapPartsCacheKey = poly.points;
            poly._overlapPartsCache = [];
            return [];
        }

        let ring = [];
        for (let i = 0; i < coords.length; i++) {
            const coord = coords[i];
            if (!coord || coord.length < 2) continue;

            const lat = Number(coord[0]);
            const lng = Number(coord[1]);

            if (isNaN(lat) || isNaN(lng)) continue;

            ring.push([lng, lat]);
        }

        if (ring.length < 3) {
            poly._overlapPartsCacheKey = poly.points;
            poly._overlapPartsCache = [];
            return [];
        }

        const first = ring[0];
        const last = ring[ring.length - 1];
        if (first[0] !== last[0] || first[1] !== last[1]) {
            ring.push(first);
        }

        let turfPoly = null;
        try {
            turfPoly = turf.polygon([ring]);
        } catch (e) {
            turfPoly = null;
        }

        if (!turfPoly) {
            poly._overlapPartsCacheKey = poly.points;
            poly._overlapPartsCache = [];
            return [];
        }

        let cleaned = null;
        try {
            cleaned = turf.unkinkPolygon(turfPoly);
        } catch (e) {
            cleaned = { type: 'FeatureCollection', features: [turfPoly] };
        }

        if (!cleaned || !cleaned.features || !cleaned.features.length) {
            poly._overlapPartsCacheKey = poly.points;
            poly._overlapPartsCache = [];
            return [];
        }

        poly._overlapPartsCacheKey = poly.points;
        poly._overlapPartsCache = cleaned.features;

        return cleaned.features;
    };

    applyOverlap = (topGuids) => {
        const currentList = this.getCurrentPolygonList();
        const nextList = [];

        for (let i = 0; i < currentList.length; i++) {
            const poly = currentList[i];
            if (!poly) continue;

            const nextHasOverlap = poly.type === 'X' ? false : !!(topGuids && topGuids[poly.guid]);
            const overlapChanged = poly.has_overlap !== nextHasOverlap;
            const nextLabel = nextHasOverlap ? (poly.name + ' (Sobreposição)') : poly.name;

            poly.has_overlap = nextHasOverlap;
            nextList.push(poly);

            const layer = this.mymap && this.mymap._layers ? this.mymap._layers[poly.guid] : null;
            if (!layer || !layer.setStyle) continue;

            const baseStyle = this.getPolygonBaseStyle(poly);

            layer.setStyle({
                color: baseStyle.color,
                weight: baseStyle.weight,
                opacity: baseStyle.opacity,
                fillColor: baseStyle.fillColor,
                fillOpacity: baseStyle.fillOpacity
            });

            if (!layer.getTooltip || !layer.getTooltip()) {
                layer.bindTooltip(nextLabel, {
                    permanent: true,
                    direction: "center",
                    className: 'tool-tip-L tool-tip-size16-L'
                });
                this.setLayerTooltipVisibility(layer, this.shouldShowPolygonTooltip(layer));
            } else if (overlapChanged || poly._overlapLabel !== nextLabel) {
                if (layer.setTooltipContent) {
                    layer.setTooltipContent(nextLabel);
                } else {
                    layer.unbindTooltip();
                    layer.bindTooltip(nextLabel, {
                        permanent: true,
                        direction: "center",
                        className: 'tool-tip-L tool-tip-size16-L'
                    });
                }
                this.setLayerTooltipVisibility(layer, this.shouldShowPolygonTooltip(layer));
            }

            poly._overlapLabel = nextLabel;

            if (poly.has_overlap && layer.bringToFront) {
                layer.bringToFront();
            }
        }

        if (this.state.tab === '0') {
            this.setState({ polygons: nextList });
        } else {
            this.setState({ areas_client: nextList });
        }
    }

    recalculateOverlaps = () => {
        if (!this.mymap) return;
        if (this.hasLazyAreaMetadata()) {
            if (this.overlapGroup) {
                try {
                    this.overlapGroup.clearLayers();
                } catch (e) { }
            }
            return;
        }
        if (this.recalculateOverlap) return;
        if (this.state.showOverlaps !== true) {
            if (this.overlapGroup) this.overlapGroup.clearLayers();
            this.applyOverlap({});
            return;
        }
        this.recalculateOverlap = true;

        try {
            if (!this.overlapGroup) {
                this.overlapGroup = L.featureGroup().addTo(this.mymap);
            } else {
                try {
                    this.overlapGroup.clearLayers();
                } catch (e) { }
            }

            const polygons = this.getCurrentPolygonList();
            const visiblesOrdered = [];

            for (let i = 0; i < polygons.length; i++) {
                const poly = polygons[i];
                if (!poly || !poly.guid || !poly.points || !poly.visible) continue;
                if (poly.type === 'X') continue;

                visiblesOrdered.push({
                    guid: poly.guid,
                    index: i,
                    poly: poly
                });
            }

            const polyParts = [];
            for (let i = 0; i < visiblesOrdered.length; i++) {
                const item = visiblesOrdered[i];
                const features = this.buildPolygons(item.poly);

                for (let j = 0; j < features.length; j++) {
                    const feature = features[j];
                    if (!feature) continue;

                    let bbox = null;
                    try {
                        bbox = turf.bbox(feature);
                    } catch (e) {
                        bbox = null;
                    }

                    polyParts.push({
                        guid: item.guid,
                        index: item.index,
                        turf: feature,
                        bbox: bbox
                    });
                }
            }

            const topGuids = {};

            for (let i = 0; i < polyParts.length; i++) {
                for (let j = i + 1; j < polyParts.length; j++) {
                    const a = polyParts[i];
                    const b = polyParts[j];

                    if (!a.guid || !b.guid || a.guid === b.guid) continue;
                    if (!a.turf || !b.turf) continue;

                    if (!a.bbox || !b.bbox) continue;
                    if (a.bbox[2] < b.bbox[0]) continue;
                    if (b.bbox[2] < a.bbox[0]) continue;
                    if (a.bbox[3] < b.bbox[1]) continue;
                    if (b.bbox[3] < a.bbox[1]) continue;

                    let intersection = null;
                    try {
                        intersection = turf.intersect(a.turf, b.turf);
                    } catch (e) {
                        intersection = null;
                    }

                    if (!intersection) continue;
                    if (intersection.geometry && intersection.geometry.type === 'Point') continue;

                    const topGuid = a.index > b.index ? a.guid : b.guid;
                    topGuids[topGuid] = true;

                    const overlapOptions = {
                        interactive: false,
                        style: {
                            color: '#1565c0',
                            weight: 0,
                            fillColor: '#1565c0',
                            fillOpacity: 0.75
                        }
                    };

                    if (this.mymap && this.mymap.getPane && this.mymap.getPane('overlapPane')) {
                        overlapOptions.pane = 'overlapPane';
                    }

                    L.geoJSON(intersection, overlapOptions).addTo(this.overlapGroup);
                }
            }

            this.applyOverlap(topGuids);
        } finally {
            this.recalculateOverlap = false;
        }
    };

    limitChar = (string, limit) => {
        let ret = string;
        let size = SPW(string, { font: "Arial", size: 16 });
        if (size > limit) {
            ret = string.slice(0, (string.length * (limit - 3) / size)) + '...';
        }
        return ret;
    };

    getAreaHaText = (item) => {
        if (!item) return '';

        let area = 0;

        if (item.area) {
            area = item.area;
        } else if (this.featureGroupP && this.featureGroupP.getLayer) {
            const layer = this.featureGroupP.getLayer(item.guid);
            if (layer && layer.getLatLngs && layer.getLatLngs()[0]) {
                area = L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]);
            }
        } else if (this.mymap && this.mymap._layers && this.mymap._layers[item.guid]) {
            const layerP = this.mymap._layers[item.guid];
            if (layerP && layerP.getLatLngs && layerP.getLatLngs()[0]) {
                area = L.GeometryUtil.geodesicArea(layerP.getLatLngs()[0]);
            }
        }

        if (area > 0) {
            const unit = Units.getAreaUnit(this.props.res);
            const areaValue = Units.formatValue(Units.convertArea(area, 'm2', this.props.res), this.props.res, 1);
            return areaValue + ' ' + unit;
        }
        return '';
    };

    handleSelectAllClick = (event, checked) => {
        let polys = this.getSelectablePolygons();
        if (checked) {
            let sel = [];
            for (let i = 0; i < polys.length; i++) {
                sel.push(polys[i].guid);
                let layer = this.mymap._layers[polys[i].guid];
                if (layer) {
                    layer.setStyle({ color: this.color_selected });
                }
            }
            this.setState({ sel_poly: sel });
            //this.setState({ sel_poly: this.state.polygons.map(x => { return x.guid; }) });
        } else {
            for (let i = 0; i < polys.length; i++) {
                let layer = this.mymap._layers[polys[i].guid];
                if (layer) {
                    layer.setStyle({ color: this.getItemBaseColor(polys[i]), fillColor: this.getItemBaseColor(polys[i]) });
                }
            }
            this.setState({ sel_poly: [] });
        }
    };

    importList = (itens, destination) => {
        this.setState({ itensImport: [], showImport: false });
        setTimeout(() => { this.fileMap(itens, destination) }, 10);
    };

    showPro = (b) => {
        let dF = document.getElementById('divPro');
        dF.classList.remove("sr-only");
        if (!b) {
            dF.classList.toggle("sr-only");
        }
    };

    showName = (show, sel_poly) => {
        if ((sel_poly && sel_poly.length > 0) || !show) {
            if (show) {
                this.updateName(sel_poly);
            } else {
                this.setState({ namesC: [] });
            }
            this.setState({ edit_name: show });
        }
    };

    updateName = (sel_poly) => {
        let array = [];
        let sel = this.state[this.tabID[Number(this.state.tab)]].filter(item => (sel_poly.includes(item.guid)));
        let last = this.state.namesC;
        let temp_poly = last.concat(this.state[this.tabID[Number(this.state.tab)]].filter(item => (!last.find(il => item.guid === il.guid))));

        for (let i = 0; i < sel.length; i++) {
            let exists = last.filter(item => { return item.guid === sel[i].guid });
            if (exists.length === 0) {
                array.push({
                    guid: sel[i].guid,
                    name: sel[i].name,
                    valid: temp_poly.filter(item => (item.guid !== sel[i].guid && item.name === sel[i].name)).length === 0
                });
            } else {
                array.push({
                    guid: exists[0].guid,
                    name: exists[0].name,
                    valid: temp_poly.filter(item => (item.guid !== exists[0].guid && item.name === exists[0].name)).length === 0
                });
            }
        }

        this.setState({ namesC: array });
    };

    handleChangeNameList = guid => event => {
        let temp_poly = this.state.namesC.concat(this.state[this.tabID[Number(this.state.tab)]].filter(item => (!this.state.namesC.find(il => item.guid === il.guid))));
        let valid = temp_poly.filter(item => (item.name === event.target.value && item.guid !== guid)).length === 0;
        let array = this.state.namesC;
        for (let i = 0; i < array.length; i++) {
            if (array[i].guid === guid) {
                array[i].name = event.target.value;
                array[i].valid = temp_poly.filter(item => (item.guid !== guid && item.name === event.target.value)).length === 0;
            } else {
                array[i].valid = temp_poly.filter(item =>
                    (item.guid !== array[i].guid && item.name === array[i].name) || (item.guid === array[i].guid && item.name === event.target.value)
                ).length === 0;
            }
        }
        this.setState({ namesC: array, valid_nameP: valid });
    };

    keyDown = (e) => {
        if (e.keyCode === 16) {
            this.shift = true;
        }
    };

    keyUp = (e) => {
        this.shift = false;
    };

    getSelectedZonePolygon = () => {
        const items = this.state[this.tabID[Number(this.state.tab)]] || [];
        const byGuid = this.getPolygonSelectionIndex(items).byGuid;
        const selected = this.state.sel_poly.map(guid => byGuid.get(guid));
        return selected.find(poly => poly && selected.every(item => item &&
            (item.guid === poly.guid || (item.type === 'X' && item.x === poly.guid)))) || null;
    };

    getManualAbPolygon = (guid) => {
        if (guid === undefined) guid = this.getSelectedZonePolygon()?.guid;
        if (!this.state.sel_poly.includes(guid)) return null;
        const selected = poly => poly.guid === guid && poly.type === 'N';
        return this.state.polygons.find(selected) || this.state.areas_client.find(selected) || null;
    };

    isManualAbPolygonRendered = (polygon) => {
        if (!polygon || !polygon.visible || !this.mymap || !this.featureGroupP) return false;
        const layer = this.mymap._layers[polygon.guid];
        if (!layer || !this.featureGroupP.hasLayer(layer)) return false;
        const element = layer.getElement && layer.getElement();
        return !element || element.style.display !== 'none';
    };

    regua = (start, type, side, guid) => {
        const manualPolygon = type === 'ab' ? this.getManualAbPolygon(guid) : null;
        if (type === 'ab' && !this.isManualAbPolygonRendered(manualPolygon)) return;
        if (type === 'ab') {
            if (this.state.ruler_a && this.drawCreateToolbar) this.drawCreateToolbar.disable();
            this.removeSelectedAbPreview(manualPolygon.guid);
        }
        if (this.state.create) {
            this.cancelCreate();
        }
        if (this.state.edit) {
            this.cancelEdit();
        }

        this.removeLayer(this.featureGroupPoly, this.mymap._layers['regua']);
        this.removeLayer(this.featureGroupPoly, this.mymap._layers['reguaM1']);
        this.removeLayer(this.featureGroupPoly, this.mymap._layers['reguaM2']);

        this.ruler_p.second.lat = null;
        this.ruler_p.second.lng = null;
        if (!start && (this.state.ruler_a || (type !== 'ab' && this.ruler_p.first.lat !== null))) {
            this.mymap.dragging.enable();
            this.ruler_p = { first: { lat: null, lng: null }, second: { lat: null, lng: null } };
            if (this.drawCreateToolbar) {
                this.drawCreateToolbar.disable();
            }
            this.setState({ ruler_a: false });
        } else {
            this.ruler_p.first = start ? { lat: start[0], lng: start[1] } : { lat: null, lng: null };
            this.ruler_p.type = type;
            this.ruler_p.side = side;
            this.ruler_p.guid = manualPolygon ? manualPolygon.guid : null;
            this.setState({ ruler_a: true });
            this.drawCreateToolbar = new L.Draw.Polyline(this.mymap, type === 'ab' ? {
                showLength: false,
                icon: L.icon({ iconUrl: side === 'second' ? iconB : iconA, iconSize: [40, 40], iconAnchor: [20, 35] }),
                shapeOptions: { color: '#fcba03', weight: 4, opacity: 0.5, fill: false }
            } : undefined);
            this.drawCreateToolbar.enable();
            if (start) {
                this.drawCreateToolbar.addVertex(start);
            }
        }
    };

    removeSelectedAbPreview = (guid) => {
        const preview = this.selectedAbLayers.get(guid);
        if (!preview) return;
        preview.layers.forEach(layer => this.removeLayer(this.featureGroupPoly, layer));
        this.selectedAbLayers.delete(guid);
    };

    syncSelectedAbPreviews = (polygons = []) => {
        const targets = new Map();
        polygons.forEach(polygon => {
            if (!this.isManualAbPolygonRendered(polygon)) return;
            if (this.state.ruler_a && this.ruler_p.type === 'ab' && this.ruler_p.guid === polygon.guid) return;
            const ab = this.parseAreaAb(polygon.ab, polygon.type);
            if (ab) targets.set(polygon.guid, { polygon, ab, key: JSON.stringify(ab) });
        });
        this.selectedAbLayers.forEach((preview, guid) => {
            const target = targets.get(guid);
            if (!target || target.key !== preview.key) {
                this.removeSelectedAbPreview(guid);
            }
        });
        targets.forEach((target, guid) => {
            if (!this.selectedAbLayers.has(guid)) {
                this.selectedAbLayers.set(guid, {
                    key: target.key,
                    layers: this.drawManualAb(target.polygon, target.ab, false)
                });
            }
        });
    };

    syncSelectedAb = (visibilityChanged = false) => {
        if (!this.mymap || !this.featureGroupPoly) return;
        if (this.ruler_p.type === 'ab' && !this.isManualAbPolygonRendered(this.getManualAbPolygon(this.ruler_p.guid))) {
            this.cancelRuler();
        }
        const polygon = this.getManualAbPolygon();
        if (this.state.sel_poly.length > 1 && !polygon) {
            if (this.ruler_p.type === 'ab' && !this.state.ruler_a) this.cancelRuler();
            const polygonIndex = this.getPolygonIndexByGuid();
            this.syncSelectedAbPreviews(this.state.sel_poly.map(guid => polygonIndex.get(guid)).filter(Boolean));
            return;
        }
        this.syncSelectedAbPreviews();
        if (!this.isManualAbPolygonRendered(polygon)) {
            if (this.ruler_p.type === 'ab') this.cancelRuler();
            return;
        }
        if ((!visibilityChanged && (this.state.manualAbGuid || this.state.manualAbOpen)) || this.mymap._layers.regua || this.state.ruler_a ||
            this.state.create || this.state.create_circle || this.state.create_waypoint || this.state.edit || this.state.delete ||
            this.state.split || this.state.merge || this.state.selector || this.state.showTrim) return;
        const ab = this.parseAreaAb(polygon.ab, polygon.type);
        if (!ab) return;
        this.drawManualAb(polygon, ab);
        if (this.state.manualAbGuid !== polygon.guid) this.setState({ manualAbGuid: polygon.guid });
    };

    openManualAb = () => {
        const polygon = this.getManualAbPolygon();
        if (!polygon) return;
        this.resetClick();
        if (this.state.showTrim) this.cancelTrim();
        const ab = this.parseAreaAb(polygon.ab, polygon.type);
        this.manualAbPrevious = { polygon, ab };
        const angle = ab ? turf.bearing(turf.point([ab[0][1], ab[0][0]]), turf.point([ab[1][1], ab[1][0]])) : 0;
        this.setState({ manualAbOpen: true, manualAbGuid: polygon.guid, manualAbAngle: tools.round((angle + 360) % 360, 2) });
        if (ab) this.drawManualAb(polygon, ab);
    };

    closeManualAb = () => {
        this.manualAbPrevious = null;
        if (this.ruler_p.type === 'ab') this.cancelRuler();
        this.setState({ manualAbOpen: false, manualAbGuid: null });
    };

    cancelManualAb = () => {
        const previous = this.manualAbPrevious;
        this.manualAbPrevious = null;
        const polygon = previous && (this.state.polygons.find(poly => poly.guid === previous.polygon.guid) ||
            this.state.areas_client.find(poly => poly.guid === previous.polygon.guid) || previous.polygon);
        let restoredAb = null;
        if (polygon) {
            restoredAb = this.parseAreaAb(previous.ab, polygon.type);
            const changed = JSON.stringify(this.parseAreaAb(polygon.ab, polygon.type)) !== JSON.stringify(restoredAb);
            polygon.ab = restoredAb;
            if (changed) this.updateArea(polygon, false);
        }
        if (this.ruler_p.type === 'ab') this.cancelRuler();
        const redraw = restoredAb && this.getManualAbPolygon()?.guid === polygon.guid;
        if (redraw) this.drawManualAb(polygon, restoredAb);
        this.setState({ manualAbOpen: false, manualAbGuid: redraw ? polygon.guid : null });
    };

    deleteManualAb = () => {
        const polygon = this.getManualAbPolygon();
        if (!polygon || polygon.guid !== this.state.manualAbGuid || !this.parseAreaAb(polygon.ab, polygon.type)) return;
        polygon.ab = null;
        this.closeManualAb();
        this.updateArea(polygon, false);
    };

    centerManualAb = (polygon, angle, length) => {
        let center = this.getMapAreaCenter(polygon);
        if (!center) {
            try {
                const points = JSON.parse(polygon.points);
                center = L.latLngBounds(points).getCenter();
            } catch (error) { return null; }
        }
        if (!center || !Number.isFinite(angle) || !Number.isFinite(length) || length < 0) return null;
        const origin = turf.point([center.lng, center.lat]);
        const cached = this.lazyGeometryCache && this.lazyGeometryCache.get(Number(polygon.id));
        let points;
        try {
            const stored = polygon.points || (cached && cached.points);
            points = typeof stored === 'string' ? JSON.parse(stored) : stored;
        } catch (error) { points = null; }
        if (!Array.isArray(points)) {
            const bounds = [polygon.min_lat, polygon.min_lng, polygon.max_lat, polygon.max_lng];
            if (bounds.every(value => value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value)))) {
                points = [[Number(polygon.min_lat), Number(polygon.min_lng)], [Number(polygon.min_lat), Number(polygon.max_lng)],
                [Number(polygon.max_lat), Number(polygon.min_lng)], [Number(polygon.max_lat), Number(polygon.max_lng)]];
            }
        }
        let halfCoverage = 0;
        const visit = coordinates => {
            if (!Array.isArray(coordinates)) return;
            if (coordinates.length >= 2 && typeof coordinates[0] === 'number' && typeof coordinates[1] === 'number') {
                const vertex = turf.point([coordinates[1], coordinates[0]]);
                const distance = turf.distance(origin, vertex);
                const difference = (turf.bearing(origin, vertex) - angle) * Math.PI / 180;
                halfCoverage = Math.max(halfCoverage, Math.abs(distance * Math.cos(difference)));
            } else coordinates.forEach(visit);
        };
        visit(points);
        // Grow short ABs to span the polygon along their heading, plus 5%.
        length = Math.max(length, halfCoverage * 2 * 1.05);
        if (length <= 0) return null;
        let heading = angle;
        let ab;
        // Center the segment while keeping the requested A-to-B bearing.
        // Geographic north changes along longer segments, so refine the heading.
        for (let i = 0; i < 4; i++) {
            const a = turf.destination(origin, length / 2, heading + 180).geometry.coordinates;
            const b = turf.destination(origin, length / 2, heading).geometry.coordinates;
            const latOffset = center.lat - (a[1] + b[1]) / 2;
            const lngOffset = center.lng - (a[0] + b[0]) / 2;
            ab = [[a[1] + latOffset, a[0] + lngOffset], [b[1] + latOffset, b[0] + lngOffset]];
            const bearing = turf.bearing(turf.point([ab[0][1], ab[0][0]]), turf.point([ab[1][1], ab[1][0]]));
            heading += ((angle - bearing + 540) % 360) - 180;
        }
        return this.parseAreaAb(ab, 'N');
    };

    saveManualAbAngle = () => {
        const polygon = this.getManualAbPolygon();
        const angle = Number(this.state.manualAbAngle);
        if (!polygon || polygon.guid !== this.state.manualAbGuid || this.state.manualAbAngle === '' || !Number.isFinite(angle)) return;
        const previous = this.parseAreaAb(polygon.ab, polygon.type);
        if (previous) {
            const bearing = turf.bearing(turf.point([previous[0][1], previous[0][0]]), turf.point([previous[1][1], previous[1][0]]));
            if (angle === tools.round((bearing + 360) % 360, 2)) {
                this.closeManualAb();
                return;
            }
        }
        const length = previous ? turf.distance(turf.point([previous[0][1], previous[0][0]]), turf.point([previous[1][1], previous[1][0]])) : 0.1;
        const ab = this.centerManualAb(polygon, angle, length);
        if (!ab) return;
        this.manualAbPrevious = null;
        this.cancelRuler();
        polygon.ab = ab;
        this.updateArea(polygon, false);
        this.drawManualAb(polygon, ab);
        this.setState({ manualAbOpen: false, manualAbAngle: tools.round(((angle % 360) + 360) % 360, 2) });
    };

    drawManualAb = (polygon, ab, useRuler = true) => {
        if (!this.isManualAbPolygonRendered(polygon)) return;
        if (useRuler) {
            this.ruler_p = {
                type: 'ab', guid: polygon.guid,
                first: { lat: ab[0][0], lng: ab[0][1] }, second: { lat: ab[1][0], lng: ab[1][1] }
            };
        }
        const polyline = L.polyline(ab, { color: '#f5c749', weight: 2, opacity: 1, interactive: useRuler });
        polyline._leaflet_id = useRuler ? 'regua' : 'selected-ab:' + polygon.guid;
        polyline.addTo(this.featureGroupPoly);
        const layers = [polyline];
        ab.forEach((point, index) => {
            const marker = L.marker(point, {
                interactive: true,
                icon: L.icon({ iconUrl: index === 0 ? iconA : iconB, iconSize: [40, 40], iconAnchor: [20, 35] })
            });
            marker._leaflet_id = useRuler ? (index === 0 ? 'reguaM1' : 'reguaM2') : 'selected-ab:' + polygon.guid + ':' + index;
            marker.on('mousedown', () => {
                if (!this.getManualAbPolygon(polygon.guid) || !this.isManualAbPolygonRendered(polygon)) return;
                this.mymap.dragging.disable();
                this.regua(ab[1 - index], 'ab', index === 0 ? 'second' : 'first', polygon.guid);
            });
            marker.addTo(this.featureGroupPoly);
            layers.push(marker);
        });
        return layers;
    };

    completeManualAb = () => {
        const polygon = this.getManualAbPolygon(this.ruler_p.guid);
        if (!this.isManualAbPolygonRendered(polygon)) {
            this.closeManualAb();
            return;
        }
        let points = [
            [this.ruler_p.first.lat, this.ruler_p.first.lng],
            [this.ruler_p.second.lat, this.ruler_p.second.lng]
        ];
        if (this.ruler_p.side === 'second') points.reverse();
        points = this.parseAreaAb(points, polygon.type);
        if (!points) return;
        const a = turf.point([points[0][1], points[0][0]]);
        const b = turf.point([points[1][1], points[1][0]]);
        const angle = (turf.bearing(a, b) + 360) % 360;
        const ab = this.centerManualAb(polygon, angle, turf.distance(a, b));
        if (!ab) return;
        this.cancelRuler();
        polygon.ab = ab;
        this.updateArea(polygon, false);
        const singleArea = this.getManualAbPolygon() === polygon;
        if (!singleArea) this.syncSelectedAb();
        else this.drawManualAb(polygon, ab);
        this.setState({ manualAbAngle: tools.round(angle, 2), manualAbGuid: singleArea ? polygon.guid : null });
    };

    completeRuler = () => {
        if (this.ruler_p.first.lat === null || this.ruler_p.second.lat === null) return;
        if (this.ruler_p.type === 'ab') {
            if (!this.state.ruler_a) return;
            this.completeManualAb();
            return;
        }
        if (this.drawCreateToolbar) {
            this.drawCreateToolbar.disable();
        }

        let latlngs = [
            [this.ruler_p.first.lat, this.ruler_p.first.lng],
            [this.ruler_p.second.lat, this.ruler_p.second.lng]
        ];
        let latlngF = L.latLng([this.ruler_p.first.lat, this.ruler_p.first.lng]);
        let latlngS = L.latLng([this.ruler_p.second.lat, this.ruler_p.second.lng]);
        let text = latlngF.distanceTo(latlngS);


        let polyline = L.polyline(latlngs);

        polyline._leaflet_id = 'regua';
        polyline.bindTooltip(this.formatRegua(text), { permanent: true }).openTooltip()
        polyline.addTo(this.featureGroupPoly);

        let m1 = L.marker([this.ruler_p.first.lat, this.ruler_p.first.lng], {
            icon: new L.DivIcon({
                iconSize: new L.Point(10, 10),
                className: 'leaflet-div-icon leaflet-editing-icon my-own-icon',
            })
        })
        m1.on('mousedown', (e) => {
            this.mymap.dragging.disable();
            this.regua([this.ruler_p.second.lat, this.ruler_p.second.lng]);
        })
        m1._leaflet_id = 'reguaM1';
        m1.addTo(this.featureGroupPoly);

        let m2 = L.marker([this.ruler_p.second.lat, this.ruler_p.second.lng], {
            icon: new L.DivIcon({
                iconSize: new L.Point(10, 10),
                className: 'leaflet-div-icon leaflet-editing-icon my-own-icon',
            })
        });
        m2.on('mousedown', (e) => {
            this.mymap.dragging.disable();
            this.regua([this.ruler_p.first.lat, this.ruler_p.first.lng]);
        })
        m2._leaflet_id = 'reguaM2';
        m2.addTo(this.featureGroupPoly);
    };

    cancelRuler = () => {
        if (this.state.ruler_a || this.ruler_p.first.lat !== null) {
            this.regua();
        }
    };

    loadLimit = () => {
        const apiUrl = Config.server + '/company_config';
        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    if (result.length > 0) {
                        if (result[0].limit_orc_ha <= 0) {
                            this.setState({ disable: true });
                        }
                    }
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    }
                    else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    loadUser = () => {
        const apiUrl = Config.server + '/currentProfile';
        let obj = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };
        fetch(apiUrl, obj)
            .then((res) => {
                if (res.status !== 200)
                    throw res;//new Error(res.status);
                else
                    return res.json();
            })
            .then(
                (result) => {
                    let array = [];
                    result.forEach(element => {
                        array.push(element.id_profile);
                    });
                    this.setState({ typeUser: array });
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    }
                    else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    loadClient = () => {
        const apiUrl = Config.server + '/customer';
        let obj = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };
        fetch(apiUrl, obj)
            .then((res) => {
                if (res.status !== 200)
                    throw res;//new Error(res.status);
                else
                    return res.json();
            })
            .then(
                (result) => {
                    this.setState({ clients: result });
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    } else if (error.status === 400) {
                        error.json().then(
                            (errCode) => {
                                notification.open({
                                    message: this.props.res[errCode.code],
                                    icon: <MaterialIcon icon="error" className="text-danger" />
                                });
                            });
                    } else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    loadProperty = (id_client, callback) => {
        const apiUrl = Config.server + '/properties/' + id_client;
        let obj = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };
        fetch(apiUrl, obj)
            .then((res) => {
                if (res.status !== 200)
                    throw res;//new Error(res.status);
                else
                    return res.json();
            })
            .then(
                (result) => {
                    callback(result);
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    }
                    else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    toMapPolygonSummary = (area, defaultVisible) => {
        const tempPoly = new polygon();
        tempPoly.id = area.id;
        tempPoly.id_region = area.id_region;
        tempPoly.guid = area.guid;
        tempPoly.name = area.name;
        tempPoly.type = area.type;
        tempPoly.ab = this.parseAreaAb(area.ab, area.type);
        tempPoly.id_property = area.id_property;
        tempPoly.id_folder_area = area.id_folder_area;
        tempPoly.custom_color = area.custom_color || '';
        tempPoly.center_lat = area.center_lat;
        tempPoly.center_lng = area.center_lng;
        tempPoly.min_lat = area.min_lat;
        tempPoly.max_lat = area.max_lat;
        tempPoly.min_lng = area.min_lng;
        tempPoly.max_lng = area.max_lng;
        tempPoly.visible = typeof area.visible === 'boolean' ? area.visible : !!defaultVisible;
        // Hydration supplies points for actions, but must not bypass viewport rendering.
        tempPoly._lazyViewport = true;

        // The geometry preview is added only after its polygon is requested.
        tempPoly.svg = '';
        return tempPoly;
    };

    getAreaSummaryPage = (id, offset) => {
        const apiUrl = Config.server + '/areas/summary/' + id + '?offset=' + offset + '&limit=' + this.summaryPageSize;
        return fetch(apiUrl, {
            method: 'GET',
            headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
        }).then((res) => {
            if (res.status !== 200) throw res;
            return res.json();
        }).then((page) => {
            const fields = Array.isArray(page.fields) ? page.fields : [];
            const rows = Array.isArray(page.rows) ? page.rows : [];
            const legacyPointsById = new Map();
            const legacyRows = Array.isArray(page.legacy_points) ? page.legacy_points : [];
            for (let i = 0; i < legacyRows.length; i++) {
                const legacyRow = legacyRows[i];
                if (!Array.isArray(legacyRow) || legacyRow.length < 2) continue;
                legacyPointsById.set(String(legacyRow[0]), legacyRow[1]);
            }
            const items = rows.map((values) => {
                const item = {};
                for (let i = 0; i < fields.length; i++) {
                    item[fields[i]] = values[i];
                }

                const storedPoints = legacyPointsById.get(String(item.id));
                const bounds = this.getMapBoundsFromStoredPoints(storedPoints);
                if (bounds) {
                    const fieldsToFill = ['center_lat', 'center_lng', 'min_lat', 'max_lat', 'min_lng', 'max_lng'];
                    for (let i = 0; i < fieldsToFill.length; i++) {
                        const field = fieldsToFill[i];
                        if (item[field] === null || item[field] === undefined || item[field] === '' ||
                            !Number.isFinite(Number(item[field]))) {
                            item[field] = bounds[field];
                        }
                    }
                }
                return item;
            });

            return {
                items: items,
                has_more: !!page.has_more,
                next_offset: page.next_offset
            };
        });
    };

    scheduleNextAreaSummaryPage = (key) => {
        const pager = this.summaryPagers[key];
        if (!pager || !pager.hasMore || pager.loading || pager.timer !== null) return;

        // Give React and Leaflet a turn to paint before ingesting the next page.
        pager.timer = window.setTimeout(() => {
            pager.timer = null;
            this.loadNextAreaSummaryPage(key);
        }, 160);
    };

    loadNextAreaSummaryPage = (key) => {
        const pager = this.summaryPagers[key];
        if (!pager || !pager.hasMore || pager.loading) return;

        const version = pager.version;
        pager.loading = true;
        this.getAreaSummaryPage(pager.id, pager.offset).then((page) => {
            if (pager.version !== version) return;

            const rows = Array.isArray(page.items) ? page.items : [];
            const summaries = rows.map(area => this.toMapPolygonSummary(
                area,
                !area.id_folder_area && !area.id_property
            ));
            pager.offset = Number(page.next_offset) || (pager.offset + summaries.length);
            pager.hasMore = !!page.has_more;
            pager.loading = false;

            if (!summaries.length) {
                if (!pager.hasMore) {
                    this.setState({ loadingAreaSummaries: false });
                } else {
                    this.scheduleNextAreaSummaryPage(key);
                }
                return;
            }

            pager.pendingSummaries = pager.pendingSummaries.concat(summaries);
            pager.pagesSinceMapRefresh++;
            const shouldRefreshVisuals = pager.pagesSinceMapRefresh >= 3 || !pager.hasMore;

            if (!shouldRefreshVisuals) {
                this.scheduleNextAreaSummaryPage(key);
                return;
            }

            const summaryBatch = pager.pendingSummaries;
            pager.pendingSummaries = [];
            pager.pagesSinceMapRefresh = 0;
            this.setState((previous) => ({
                [key]: previous[key].concat(summaryBatch),
                // The map and list receive the same staged batch. This avoids
                // re-rendering the list for every network page while still
                // exposing all areas as the initial load progresses.
                listRenderLimit: previous[key].length + summaryBatch.length
            }), () => {
                this.requestLazyViewportRefresh();
                if (!pager.hasMore) {
                    this.setState({ loadingAreaSummaries: false });
                } else {
                    this.scheduleNextAreaSummaryPage(key);
                }
            });
        }).catch((error) => {
            if (pager.version !== version) return;
            pager.loading = false;
            this.setState({ loadingAreaSummaries: false });
            if (error && (error.status === 401 || error.status === 403)) this.props.link('/login');
        });
    };

    handleAreaListPointerMove = (event) => {
        const element = event.currentTarget;
        if (!element) return;
        if (element.scrollHeight <= element.clientHeight) {
            element.classList.remove('area-list-scrollbar-hover');
            return;
        }

        const bounds = element.getBoundingClientRect();
        // On overlay scrollbars clientWidth does not include the bar. Start
        // with its compact width and preserve the expanded hit area afterwards.
        const compactWidth = Math.max(element.offsetWidth - element.clientWidth, 7);
        const scrollbarWidth = element.classList.contains('area-list-scrollbar-hover')
            ? Math.max(compactWidth, 14)
            : compactWidth;
        const overScrollbar = event.clientX >= bounds.right - scrollbarWidth && event.clientX <= bounds.right;

        element.classList.toggle('area-list-scrollbar-hover', overScrollbar);
    };

    handleAreaListPointerEnter = () => {
        this.areaListIsActive = true;
        this.flushListPreviewRefresh();
    };

    handleAreaListPointerLeave = (event) => {
        this.areaListIsActive = false;
        this.cancelListPreviewRefresh();
        event.currentTarget.classList.remove('area-list-scrollbar-hover');
    };

    loadAreas = (id, callback) => {
        const key = Number(id) === 0 ? 'polygons' : 'areas_client';
        const pager = this.summaryPagers[key];
        pager.version++;
        pager.id = Number(id) || 0;
        pager.offset = 0;
        pager.hasMore = false;
        pager.loading = true;
        pager.pagesSinceMapRefresh = 0;
        pager.pendingSummaries = [];
        if (pager.timer !== null) window.clearTimeout(pager.timer);
        pager.timer = null;
        const version = pager.version;
        this.setState({ loadingAreaSummaries: true, listRenderLimit: 400 });

        this.getAreaSummaryPage(id, 0)
            .then((page) => {
                if (pager.version !== version) return;

                const rows = Array.isArray(page.items) ? page.items : [];
                pager.offset = Number(page.next_offset) || rows.length;
                pager.hasMore = !!page.has_more;
                pager.loading = false;

                if (!pager.hasMore) this.setState({ loadingAreaSummaries: false });

                if (Number(id) === 0) {
                    if (callback) callback(rows);
                    return;
                }

                const areasClient = rows.map(area => this.toMapPolygonSummary(
                    area,
                    !area.id_folder_area && !area.id_property
                ));
                this.lazyViewportToken++;
                // Entries are keyed by the area id. Keep them across a summary
                // reload so a geometry imported moments ago is rendered from
                // memory instead of fetched a second time.
                this.lazyGeometryRequests.clear();
                this.setState({ areas_client: areasClient }, () => {
                    this.resetPolygons();
                    this.scheduleNextAreaSummaryPage(key);
                    if (callback) callback(areasClient);
                });
            })
            .catch((error) => {
                if (pager.version !== version) return;
                pager.loading = false;
                this.setState({ loadingAreaSummaries: false });
                if (error.status === 405) {
                    notification.open({
                        message: this.props.res.PERMISSAO,
                        description: this.props.res.PERMISSAO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                } else if (error.status === 401 || error.status === 403) {
                    this.props.link('/login');
                }
                else {
                    console.log(error);
                    notification.open({
                        message: this.props.res.ERRO,
                        description: this.props.res.ERRO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                }

                if (callback) {
                    callback([]);
                }
            });
    };

    updateArea = (area, update, callback) => {
        let apiUrl = Config.server + '/area';
        let method = 'PUT';
        let poly = area;
        let tab = area.id_client ? 0 : 1;

        if (!poly.points) {
            this.getLazyGeometryRows([poly]).then(() => {
                const geometry = this.lazyGeometryCache.get(Number(poly.id));
                if (!geometry || !geometry.points) return;
                poly.points = geometry.points;
                this.updateArea(poly, update, callback);
            }).catch(() => { });
            return;
        }

        const formData = new URLSearchParams();
        if (poly.id) {
            formData.append('id', poly.id);
        }
        if (poly.id_client) {
            formData.append('id_client', poly.id_client);
        }
        if (poly.id_property) {
            formData.append('id_property', poly.id_property);
        }
        if (poly.id_region) {
            formData.append('id_region', poly.id_region);
        }
        if (poly.id_folder_area) {
            formData.append('id_folder_area', poly.id_folder_area);
        }
        formData.append('guid', poly.guid);
        const points = JSON.parse(poly.points);
        for (let i = 0; i < points.length; i++) {
            points[i] = [tools.round(points[i][0], 7), tools.round(points[i][1], 7)];
        }
        formData.append('points', JSON.stringify(points));
        formData.append('type', poly.type);
        if (poly.ab !== undefined) {
            formData.append('ab', JSON.stringify(this.parseAreaAb(poly.ab, poly.type)));
        }
        formData.append('name', poly.name);
        formData.append('custom_color', poly.custom_color ? poly.custom_color : '');

        let options = {
            method: method,
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    if (result) {
                        poly.id = result;
                    }
                    if (update) {
                        if (tab === 0) {
                            let temp_here = this.state[this.tabID[0]].filter(item => { return item.guid !== poly.guid; });
                            let temp_there = this.state[this.tabID[1]];
                            temp_there.push(poly);
                            this.setState({ [this.tabID[0]]: temp_here, [this.tabID[1]]: temp_there }, () => {
                                if (callback) {
                                    callback(poly);
                                }
                            });
                        } else {
                            let temp_here = this.state[this.tabID[1]].filter(item => { return item.guid !== poly.guid; });
                            let temp_there = this.state[this.tabID[0]];
                            temp_there.push(poly);
                            this.setState({ [this.tabID[1]]: temp_here, [this.tabID[0]]: temp_there }, () => {
                                if (callback) {
                                    callback(poly);
                                }
                            });
                        }
                    } else if (callback) {
                        callback(poly);
                    }
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        console.log(error);
                        this.props.link('/login');
                    }
                    else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    moveAreas = (areas, id_property, id_folder_area) => {
        let apiUrl = Config.server + '/areas';
        let method = 'PUT';
        let poly = areas;
        let tab = id_property ? 0 : 1;

        const formData = new URLSearchParams();
        formData.append('ids_areas', poly.map((item) => (item.id)).join(','));
        if (id_property) {
            formData.append('id_property', id_property);
        }
        if (id_folder_area) {
            formData.append('id_folder_area', id_folder_area);
        }

        let options = {
            method: method,
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    let polygons = [...this.state[this.tabID[0]]];
                    let areas_client = [...this.state[this.tabID[1]]];

                    for (let i = 0; i < areas.length; i++) {
                        const area = areas[i];

                        if (id_property && this.state.tab === '0') {
                            polygons = polygons.filter(item => item !== area);
                            areas_client.push(area);
                            this.removeLayer(this.featureGroupP, this.mymap._layers[area.guid]);
                        } else if (!id_property && this.state.tab === '1') {
                            areas_client = areas_client.filter(item => item !== area);
                            polygons.push(area);
                            this.removeLayer(this.featureGroupP, this.mymap._layers[area.guid]);
                        }

                        area.id_property = id_property;
                        area.id_folder_area = id_folder_area;
                    }

                    this.setState({
                        [this.tabID[0]]: polygons,
                        [this.tabID[1]]: areas_client,
                        sel_poly: []
                    }, () => {
                        this.openListItem(id_property, id_folder_area);
                    });
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        console.log(error);
                        this.props.link('/login');
                    }
                    else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    moveArea = () => {
        this.setState({ anchorEl: null });
        if (this.state.sel_poly.length > 0) {
            const elements = this.state[this.tabID[Number(this.state.tab)]].filter(item => this.state.sel_poly.findIndex(sel => sel === item.guid) >= 0);
            let id_property = this.state.id_clientPup > 0 ? this.state.id_propertyPup : null;
            let id_folder_area = this.state.id_folderPup > 0 ? this.state.id_folderPup : null;
            this.moveAreas(elements, id_property, id_folder_area);
        }
    };

    deleteArea = (ids, callback) => {
        let apiUrl = Config.server + '/area';
        let method = 'DELETE';

        const formData = new URLSearchParams();
        formData.append('ids', ids);

        let options = {
            method: method,
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    const deletedIds = new Set(ids.map(id => String(id)));
                    this.setState(state => ({
                        polygons: state.polygons.filter(area => !area.id || !deletedIds.has(String(area.id))),
                        areas_client: state.areas_client.filter(area => !area.id || !deletedIds.has(String(area.id)))
                    }), () => {
                        if (callback) callback();
                    });
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        console.log(error);
                        this.props.link('/login');
                    }
                    else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    openSplit = () => {
        this.resetClick();
        this.setState({ merge: false, split: true });
        this.drawCreateToolbar = new L.Draw.Polyline(this.mymap);
        this.drawCreateToolbar.enable();
    }

    useSplitLine = () => {
        if (this.drawCreateToolbar && this.drawCreateToolbar._markers.length > 1) {
            this.drawCreateToolbar.completeShape();
            this.editSplit();

            this.setState({ merge: true, type: '6', gap_size: '0' });
        }
    }

    getRenderedSplitAreas = (areas) => {
        const layers = this.mymap && this.mymap._layers;
        return areas.filter(element => {
            if (!element || element.type === 'XL' || element.type === 'X') return false;
            const layer = layers && layers[element.guid];
            return !!(layer && typeof layer.toGeoJSON === 'function');
        });
    };

    getSplitPolygonGeoJson = (element) => {
        const layer = this.mymap._layers[element.guid];
        if (element.radius > 0) {
            if (!element.points) throw new Error('split-geometry-not-found');
            return L.polygon(JSON.parse(element.points)).toGeoJSON();
        }
        if (!layer || typeof layer.toGeoJSON !== 'function') throw new Error('split-layer-not-rendered');
        return layer.toGeoJSON();
    };

    split = async () => {
        const item = this.mymap._layers['spliLine'];
        const tabKey = this.tabID[Number(this.state.tab)];
        const areas = this.state[tabKey] || [];
        const splitAreas = this.getRenderedSplitAreas(areas);

        this.showPro(true);
        const formData = new URLSearchParams();
        const polys = [];

        try {
            const circlesWithoutPoints = splitAreas.filter(element => element.radius > 0 && !element.points);
            if (circlesWithoutPoints.length) {
                await this.getLazyGeometryRows(circlesWithoutPoints);
                circlesWithoutPoints.forEach(element => this.hydrateLazyArea(element.guid, tabKey));
                this.setState({ [tabKey]: [...(this.state[tabKey] || [])] });
            }

            this.getRenderedSplitAreas(splitAreas).forEach(element => {
                const geoj = this.getSplitPolygonGeoJson(element);
                polys.push({ poly: geo.simplify(geoj.geometry.coordinates[0], 0.000002), name: element.name, guid: element.guid });
            });
        } catch (error) {
            this.showPro(false);
            if (error && (error.status === 401 || error.status === 403)) {
                this.props.link('/login');
            } else {
                notification.open({
                    message: this.props.res.ERRO,
                    description: this.props.res.ERRO_MSG,
                    icon: <MaterialIcon icon="error" className="text-danger" />
                });
            }
            this.cancelSplit();
            return;
        }

        let apiUrl = Config.server + '/merge_polygons';
        let method = 'POST';

        formData.append('polygons', JSON.stringify(polys));
        formData.append('origem', JSON.stringify([]));
        formData.append('polygons_xcl', JSON.stringify(geo.turfLine(item._latlngs)));
        formData.append('size', this.state.gap_size);
        formData.append('type', this.state.type);

        let options = {
            method: method,
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    this.showPro(false);
                    //this.setState({ progress: false });
                    if (result.msgErro) {
                        notification.open({
                            message: result.msgErro,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (result.poly) {
                        this.splited(result);
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                },
                (error) => {
                    this.showPro(false);
                    //this.setState({ progress: false });
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        console.log(error);
                        this.props.link('/login');
                    }
                    else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );

        this.cancelSplit();
    };

    splited = (result) => {
        let remove = result.x;

        if (this.drawEditToolbar) {
            this.drawEditToolbar.save();
            this.drawEditToolbar.disable();
        }
        let changeTab = true;
        let polys = { ob: [] };
        let ids = [];
        remove.forEach(element => {
            let l = this.mymap._layers[element];
            //polys.layers.push(l);
            let temp_poly = this.state.polygons.filter(itemP => { return itemP.guid === element; });
            if (temp_poly.length > 0) {
                changeTab = false;
                polys.ob = polys.ob.concat(temp_poly);
                this.removeLayer(this.featureGroupP, l);

                if (this.state.tab === '0') {
                    ids.push(temp_poly[0].id);
                }
            }
        });
        if (ids.length > 0) {
            this.deleteArea(ids);
        }

        let itens = this.state.polygons.filter(item => { return !remove.includes(item.guid); });
        for (let i = 0; i < result.poly.length; i++) {
            for (let j = 0; j < result.poly[i].polys.length; j++) {
                const element = result.poly[i].polys[j];
                let guid = tools.newGuid();

                let tempRumo = new polygon();
                tempRumo.type = 'N';
                tempRumo.guid = guid;
                tempRumo.name = result.poly[i].name + ' (' + (j + 1) + ')';

                const latlng = this.geojsonToLeafletArray(element.geometry.coordinates[0]);
                tempRumo.points = JSON.stringify(latlng);
                tempRumo.svg = this.generateSVGPath(latlng);
                tempRumo.old = polys;
                setTimeout(() => {
                    this.drawPolygon(tempRumo, this.tabID[0]);
                }, 10 * i + 20 * j);
                this.updateArea(tempRumo);
                itens.push(tempRumo);
            }
        }
        this.setState({ polygons: itens, tab: '0' }, () => {
            if (changeTab) {
                this.resetPolygons(true);
            }
        });
        //this.savePolygons(itens);
    }

    editSplit = () => {
        if (this.drawEditToolbar) {
            this.drawEditToolbar.enable();
        }
        this.state.polygons.forEach(item => {
            let layer = this.mymap._layers[item.guid];
            if (layer) {
                layer.editing.disable();
            }
        });
        let layer = this.mymap._layers['spliLine'];
        if (layer) {
            layer.editing.enable();
        }
    }

    cancelSplit = () => {
        this.setState({ merge: false, split: false });
        if (this.drawCreateToolbar) {
            this.drawCreateToolbar.disable();
        }
        if (this.drawEditToolbar) {
            this.drawEditToolbar.save();
            this.drawEditToolbar.disable();
        }
        let item = this.mymap._layers['spliLine'];
        if (item) {
            this.removeLayer(this.featureGroupP, item);
        }
    }

    clear = () => {
        this.filterInputValue = '';
        if (this.filterTimer !== null) {
            window.clearTimeout(this.filterTimer);
            this.filterTimer = null;
        }
        if (this.filterInputNode) {
            this.filterInputNode.value = '';
        }
        this.setState({
            filtro: ''
        });
    };

    handleChangeTab = name => (event, newValue) => {
        if (this.state[name] !== newValue) {
            this.setState({
                [name]: newValue,
            }, () => {
                this.resetPolygons();
            });
        }
    };

    resetPolygons = (isFixed) => {
        this.setState({ sel_poly: [] });
        this.lazyViewportToken++;
        if (this.lazyRenderFrame !== null) {
            window.cancelAnimationFrame(this.lazyRenderFrame);
            this.lazyRenderFrame = null;
        }
        this.featureGroupP.clearLayers();
        this.lazyRenderedGuids.clear();
        this.lazyRenderedLayers.clear();
        if (this.overlapGroup) {
            try {
                this.overlapGroup.clearLayers();
            } catch (e) { }
        }
        let hasPoly = false;
        if (this.state.tab === '1') {
            for (let i = 0; i < this.state.areas_client.length; i++) {
                const areas_client = this.state.areas_client[i];
                if (areas_client.visible && areas_client.points && !areas_client._lazyViewport) {
                    //setTimeout(() => {
                    this.drawPolygon(areas_client, this.tabID[1]);
                    //}, 2 * i);
                    hasPoly = true;
                }
            }
        } else {
            for (let i = 0; i < this.state.polygons.length; i++) {
                const polygon = this.state.polygons[i];
                if (polygon.visible && polygon.points && !polygon._lazyViewport) {
                    //setTimeout(() => {
                    this.drawPolygon(polygon, this.tabID[0]);
                    //}, 2 * i);
                    hasPoly = true;
                }
            }
        }
        if (hasPoly && !isFixed) {
            const bounds = this.featureGroupP.getBounds();
            if (bounds.isValid()) {
                this.mymap.fitBounds(bounds);
            }
        }
        this.syncPolygonClusters();
    }

    handleChangeClient = (name, ref, loadArea) => event => {
        const selectedValue = event.target.value;
        const isMainClientChange = name === 'id_client' && selectedValue !== 0;

        this.setState({
            [name]: selectedValue,
            new_error: selectedValue === 0,
            ...(isMainClientChange && { loadingClientData: true })
        }, () => {
            if (selectedValue !== 0) {

                if (isMainClientChange) {
                    let pending = 3;

                    const finishLoading = () => {
                        pending--;
                        if (pending <= 0) {
                            this.setState({ loadingClientData: false });
                        }
                    };

                    this.loadProperty(selectedValue, (res) => {
                        if (ref) {
                            this.setState({ [ref]: res }, finishLoading);
                        } else {
                            finishLoading();
                        }
                    });

                    this.loadAreas(this.state.id_client, () => {
                        finishLoading();
                    });

                    this.loadPastas(
                        this.state.id_client,
                        'folders_properties',
                        () => {
                            finishLoading();
                        }
                    );

                    const tempA = this.state.anchorEl;
                    this.setState({ anchorEl: null }, () => {
                        this.setState({ anchorEl: tempA });
                    });

                } else {
                    this.loadProperty(selectedValue, (res) => {
                        if (ref) this.setState({ [ref]: res });
                    });

                    if (loadArea && name === 'id_client') {
                        this.loadAreas(this.state.id_client);
                    }

                    if (name === 'id_clientPup' || name === 'id_client') {
                        this.loadPastas(
                            name === 'id_clientPup' ? this.state.id_clientPup : this.state.id_client,
                            name === 'id_clientPup' ? 'foldersPup' : 'folders_properties'
                        );

                        const tempA = this.state.anchorEl;
                        this.setState({
                            anchorEl: null,
                            id_propertyPup: name === 'id_clientPup' ? 0 : this.state.id_propertyPup,
                            id_folderPup: name === 'id_clientPup' ? 0 : this.state.id_folderPup
                        }, () => {
                            this.setState({ anchorEl: tempA });
                        });
                    }
                }

                if (name === 'id_propertyPup') {
                    this.setState({ id_folderPup: 0 }, () => {
                        if (this.state.id_propertyPup != 0) {
                            let f = this.state.foldersPup.filter(item => (
                                item.id_property === this.state.id_propertyPup
                            ));
                            this.mountFoldersPup(f);
                        } else {
                            this.mountFoldersPup([]);
                        }
                    });
                } else if (this.state.id_propertyPup != 0 && name !== 'id_client') {
                    let f = this.state.folders_properties.filter(item => (
                        item.id_property === this.state.id_propertyPup
                    ));
                    this.mountFoldersPup(f);
                } else if (name !== 'id_client') {
                    this.mountFoldersPup([]);
                }

            } else {
                if (name === 'id_client') {
                    this.setState({
                        fazenda_client: [],
                        folders_properties: [],
                        areas_client: [],
                        sel_poly: [],
                        areaPup: null,
                        loadingClientData: false
                    }, () => {
                        this.resetPolygons(true);
                    });
                } else if (name === 'id_clientPup') {
                    this.setState({
                        fazenda_clientPup: [],
                        foldersPup: [],
                        id_propertyPup: 0,
                        id_folderPup: 0
                    }, () => {
                        this.mountFoldersPup([]);
                    });
                } else if (name === 'id_propertyPup') {
                    this.setState({
                        id_folderPup: 0
                    }, () => {
                        this.mountFoldersPup([]);
                    });
                } else {
                    this.mountFoldersPup([]);
                }
            }
        });
    };

    handleItem = (guid) => {
        this.clickItem = true;
    }

    onCloseEditProperty = () => {
        this.setState({
            showForm: false,
            id_property: null,
            name: ''
        });
    };

    openModal = (type) => {
        this.type_name = type;
        const areaPupIsPolygon = this.state.areaPup && this.state.areaPup.guid;
        if (type === 'copy') this.copySourceType = this.state.type_menu;

        if (type === 'rename') {
            const isFolderOrProperty = this.state.type_menu === 'folder' || this.state.type_menu === 'property';
            if (!isFolderOrProperty && (this.state.sel_poly.length > 0 || areaPupIsPolygon)) {
                const tempList = this.state.sel_poly.find(a => this.state.areaPup.guid === a) ? this.state.sel_poly : [...this.state.sel_poly, this.state.areaPup.guid];
                this.setState({ sel_poly: tempList, anchorEl: null }, () => {
                    this.showItem()
                });
            } else {
                this.setState({ showForm: true, name: this.state.areaPup.name, anchorEl: null });
            }
        } else if (type === 'move' || type === 'copy') {
            const tempA = this.state.anchorEl;
            if (type === 'copy' && this.copySourceType === 'folder') {
                this.setState({ type_menu: type, sel_poly: [], anchorEl: null }, () => {
                    this.setState({ anchorEl: tempA });
                });
            } else if (this.state.sel_poly.length > 0 || areaPupIsPolygon) {
                const tempList = this.state.sel_poly.find(a => this.state.areaPup.guid === a) ? this.state.sel_poly : [...this.state.sel_poly, this.state.areaPup.guid];
                this.setState({ type_menu: type, sel_poly: tempList, anchorEl: null }, () => {
                    this.setState({ anchorEl: tempA });
                });
            } else {
                this.setState({ type_menu: type, anchorEl: null }, () => {
                    this.setState({ anchorEl: tempA })
                });
            }
        } else if (type === 'color') {
            this.openColorPicker(this.state.areaPup);
        } else if (type === 'excluir') {
            if (this.state.sel_poly.length > 0 || areaPupIsPolygon) {
                this.deletePoly();
                this.setState({ anchorEl: null });
            } else {
                this.setState({ showForm: true, anchorEl: null });
            }
        } else {
            this.setState({ showForm: true, anchorEl: null, name: '' });
        }
    };

    prepareAreaCopies = async (areas, destination, folderIds = new Map()) => {
        await this.getLazyGeometryRows(areas);
        const usedGuids = new Set(this.state.polygons.concat(this.state.areas_client, areas).map(area => area.guid));
        const guids = new Map();
        areas.forEach(area => {
            let guid = tools.newGuid();
            while (usedGuids.has(guid)) guid = tools.newGuid();
            usedGuids.add(guid);
            guids.set(area.guid, guid);
        });

        return areas.map((area, index) => {
            const geometry = this.lazyGeometryCache.get(Number(area.id));
            const rawPoints = area.points || (geometry && geometry.points);
            const points = typeof rawPoints === 'string' ? JSON.parse(rawPoints) : rawPoints;
            if (!Array.isArray(points) || points.length < 3) throw new Error(this.props.res.ERRO_MSG);
            const parentGuid = area.x || String(area.guid || '').split('_xcl')[0];
            const copiedParent = area.type === 'X' && parentGuid !== area.guid ? guids.get(parentGuid) : null;
            const guid = copiedParent ? copiedParent + '_xcl' + (index + 1) : guids.get(area.guid);
            const copy = this.toMapPolygonSummary({
                ...area, id: null, guid, visible: true,
                id_property: destination.id_property,
                id_folder_area: folderIds.get(Number(area.id_folder_area)) || destination.id_folder_area
            }, true);
            copy.id_client = destination.id_client;
            copy.points = JSON.stringify(points);
            copy.x = copiedParent || '';
            Object.assign(copy, this.getMapBoundsFromStoredPoints(points));
            return copy;
        });
    };

    copyFolderContents = async (folder, destination) => {
        const headers = { 'Authorization': localStorage.getItem('access-token-jwt') };
        const sourceClient = this.state.tab === '1' ? this.state.id_client : 0;
        // Read complete snapshots so unloaded pages and copies into descendants are handled too.
        const responses = await Promise.all([
            fetch(Config.server + '/folder_area', { method: 'GET', headers }),
            fetch(Config.server + '/areas/' + sourceClient, { method: 'GET', headers })
        ]);
        for (const response of responses) if (response.status !== 200) throw response;
        const [folders, sourceAreas] = await Promise.all(responses.map(response => response.json()));
        const root = folders.find(item => Number(item.id) === Number(folder.id));
        if (!root) throw new Error(this.props.res.ERRO_MSG);
        const ordered = [root];
        const sourceIds = new Set([Number(root.id)]);
        for (let index = 0; index < ordered.length; index++) {
            const parentId = Number(ordered[index].id);
            folders.forEach(item => {
                if (Number(item.id_folder_area) === parentId && !sourceIds.has(Number(item.id))) {
                    sourceIds.add(Number(item.id));
                    ordered.push(item);
                }
            });
        }

        const folderIds = new Map();
        const copiedFolders = [];
        for (const source of ordered) {
            const parentId = folderIds.get(Number(source.id_folder_area)) || destination.id_folder_area;
            const body = new URLSearchParams();
            body.append('name', source.name);
            body.append('color', source.color || '#ffffff');
            if (destination.id_property) body.append('id_property', destination.id_property);
            if (parentId) body.append('id_folder_area', parentId);
            const response = await fetch(Config.server + '/folder_area', { method: 'POST', headers, body });
            if (response.status !== 200) throw response;
            const id = Number(await response.json());
            if (!Number.isInteger(id) || id <= 0) throw new Error(this.props.res.ERRO_MSG);
            folderIds.set(Number(source.id), id);
            copiedFolders.push({ ...source, id, guid: tools.newGuid(), id_property: destination.id_property, id_folder_area: parentId });
        }
        return {
            areas: sourceAreas.filter(area => sourceIds.has(Number(area.id_folder_area))),
            folderIds, rootId: folderIds.get(Number(root.id)), folders: folders.concat(copiedFolders)
        };
    };

    copyToDestination = async () => {
        if (this.isImporting || this.state.id_clientPup < 0 || (this.state.id_clientPup > 0 && !this.state.id_propertyPup)) return;
        const propertyId = this.state.id_clientPup > 0 ? Number(this.state.id_propertyPup) : null;
        const destination = {
            id_client: propertyId ? Number(this.state.id_clientPup) : null,
            id_property: propertyId,
            id_folder_area: Number(this.state.id_folderPup) || null
        };
        const sourceFolder = this.copySourceType === 'folder' ? this.state.areaPup : null;
        const selected = new Set(this.state.sel_poly);
        let areas = this.state[this.tabID[Number(this.state.tab)]].filter(area => selected.has(area.guid));
        if (!sourceFolder && areas.length === 0) return;
        this.isImporting = true;
        this.setState({ anchorEl: null });
        this.showPro(true);
        try {
            const folderCopy = sourceFolder ? await this.copyFolderContents(sourceFolder, destination) : null;
            if (folderCopy) areas = folderCopy.areas;
            const copies = await this.prepareAreaCopies(areas, destination, folderCopy ? folderCopy.folderIds : undefined);
            const saved = await this.saveImportedPolygons(copies);
            await this.addImportedPolygonsToState(saved.successful);
            const target = { ...destination, id_folder_area: folderCopy ? folderCopy.rootId : destination.id_folder_area };
            if (destination.id_client) {
                this.activateImportedClientDestination(target, saved.successful.map(area => area.guid));
            } else {
                const update = { tab: '0', sel_poly: [] };
                if (folderCopy) update.folders = this.estruturaPastas(folderCopy.folders.filter(folder => !folder.id_property));
                this.setState(update, () => {
                    this.openListItem(null, target.id_folder_area);
                    this.resetPolygons(true);
                    this.requestLazyViewportRefresh();
                });
            }
            if (saved.failed.length > 0) this.notifyImportSaveError(saved.failed[0].error);
        } catch (error) {
            this.notifyImportSaveError(error);
        } finally {
            this.isImporting = false;
            this.showPro(false);
        }
    };

    editProperty = id => {
        this.setState({ id_property: id });
        this.openModal();
    };

    saveProperty = () => {
        this.loadProperty(this.state.id_client, res => {
            this.setState({
                fazenda_client: res
            }, () => {
                this.loadAreas(this.state.id_client, result => {
                    this.setState({
                        ini: result
                    });
                });
            });
        });
    };

    moveArea = () => {
        this.setState({ anchorEl: null });
        if (this.state.sel_poly.length > 0) {
            const elements = this.state[this.tabID[Number(this.state.tab)]].filter(item => this.state.sel_poly.findIndex(sel => sel === item.guid) >= 0);
            let id_property = this.state.id_clientPup > 0 && this.state.id_clientPup > 0 ? this.state.id_propertyPup : null;
            let id_folder_area = this.state.id_folderPup > 0 ? this.state.id_folderPup : null;
            this.moveAreas(elements, id_property, id_folder_area);
        }
    };

    getAreas = () => {
        this.setState({ loadingClientData: true });

        const finishLoading = () => {
            this.setState({ loadingClientData: false });
        };

        const montaPoly = (areas, polys) => {
            let polygons = [];
            for (let i = 0; i < areas.length; i++) {
                const area = areas[i];
                polygons.push(this.toMapPolygonSummary(
                    area,
                    !area.id_folder_area && !area.id_property
                ));
            }
            polygons = polygons.concat(polys);
            this.lazyViewportToken++;
            this.lazyGeometryCache.clear();
            this.lazyGeometryRequests.clear();
            this.setState({ polygons }, () => {
                this.resetPolygons(true);
                this.recalculateOverlaps();
                this.syncPolygonClusters();
                this.scheduleNextAreaSummaryPage('polygons');
                finishLoading();
            });
        };
        this.loadAreas(0, (areas) => {
            //varifica se tem poly on localStorage
            let polys = localStorage.getItem('c-polygons');
            if (polys) polys = JSON.parse(polys);
            if (polys && polys.length > 0) {
                let polygons = [];
                for (let j = 0; j < polys.length; j++) {
                    let update = true;
                    for (let i = 0; i < areas.length; i++) {
                        if (polys[j].guid === areas[i].guid) {
                            update = false;
                            break;
                        }
                    }
                    if (update) {
                        polys[j].custom_color = (this.getAreaColorsStorage()[polys[j].guid]) || polys[j].custom_color || '';
                        this.updateArea(polys[j], true);
                        localStorage.setItem('c-polygons', JSON.stringify([]));
                        polygons.push(polys[j]);
                    }
                }
                montaPoly(areas, polygons);
            } else {
                montaPoly(areas, []);
            }
        });
    };

    selector = (start) => {
        this.resetClick();
        this.markClick = true;
        if (this.state.create) {
            this.cancelCreate();
        }
        if (this.state.edit) {
            this.cancelEdit();
        }
        if (this.state.ruler_a) {
            this.cancelRuler();
        }

        if (!start && this.state.selector) {
            this.cancelSelector();
        } else {
            this.setState({ selector: true });

            const options = {
                showArea: false,
                showLength: false,
                shapeOptions: {
                    stroke: true,
                    color: '#3388ff',
                    weight: 3,
                    opacity: 0.5,
                    fill: false,
                    fillColor: null, //same as color by default
                    fillOpacity: 0,
                    clickable: false,
                    dashArray: '10, 10',
                    dashOffset: '10'
                },
                // Whether to use the metric measurement system (truthy) or not (falsy).
                // Also defines the units to use for the metric system as an array of
                // strings (e.g. `['ha', 'm']`).
                metric: true,
                feet: true, // When not metric, to use feet instead of yards for display.
                nautic: false, // When not metric, not feet use nautic mile for display
                // Defines the precision for each type of unit (e.g. {km: 2, ft: 0}
                precision: {}
            };
            this.drawCreateToolbar = new L.Draw.Polygon(this.mymap, options);
            this.drawCreateToolbar.enable();
        }
    };

    selectorRet = (start) => {
        this.resetClick();
        this.markClick = true;
        if (this.state.create) {
            this.cancelCreate();
        }
        if (this.state.edit) {
            this.cancelEdit();
        }
        if (this.state.ruler_a) {
            this.cancelRuler();
        }

        if (!start && this.state.selector) {
            this.cancelSelector();
        } else {
            this.setState({ selector: true });

            const options = {
                shapeOptions: {
                    stroke: true,
                    color: '#3388ff',
                    weight: 3,
                    opacity: 0.5,
                    fill: false,
                    fillColor: null, //same as color by default
                    fillOpacity: 0,
                    showArea: false,
                    clickable: false,
                    dashArray: '10, 10',
                    dashOffset: '10'
                },
                metric: true // Whether to use the metric measurement system or imperial
            };
            this.drawCreateToolbar = new L.Draw.Rectangle(this.mymap, options);
            this.drawCreateToolbar.enable();
        }
    };

    completeSelector = (selector) => {
        let sel = [];
        this.cancelSelector();
        const clusteredGuids = new Set();
        const selectedClusterGuids = new Set();
        if (this.featureGroupCluster) {
            this.featureGroupCluster.eachLayer(marker => {
                if (!marker.areaGuids || !marker.getLatLng) return;
                const center = marker.getLatLng();
                const inside = turf.booleanPointInPolygon(turf.point([center.lng, center.lat]), selector);
                marker.areaGuids.forEach(guid => {
                    clusteredGuids.add(guid);
                    if (inside) selectedClusterGuids.add(guid);
                });
            });
        }
        let area = 0;
        for (let i = 0; i < this.state[this.tabID[Number(this.state.tab)]].length; i++) {
            const polys = this.state[this.tabID[Number(this.state.tab)]][i];
            const layer = this.mymap._layers[polys.guid];
            let myLayer = layer;
            let selected = selectedClusterGuids.has(polys.guid);
            if (!clusteredGuids.has(polys.guid)) {
                if (polys.radius > 0 && polys.points) myLayer = L.polygon(JSON.parse(polys.points));
                if (myLayer && typeof myLayer.toGeoJSON === 'function') {
                    const geoj = myLayer.toGeoJSON();
                    selected = TurfOverlap(geoj, selector) || TurfContains(selector, geoj);
                }
            }
            if (selected) {
                sel.push(polys.guid);
                if (layer && layer.setStyle) {
                    layer.setStyle({ color: this.color_selected });
                }
                let tArea = Number(polys.area) || 0;
                if (!tArea && myLayer && typeof myLayer.getLatLngs === 'function') {
                    tArea = L.GeometryUtil.geodesicArea(myLayer.getLatLngs()[0]);
                }
                area += tArea;
            }
        }
        let update = { sel_poly: sel };
        if (area > 0) {
            const unit = Units.getAreaUnit(this.props.res);
            let text = Units.formatValue(Units.convertArea(area, 'm2', this.props.res), this.props.res) + ' ' + unit;
            update.label_text = text;
        } else {
            update.label_text = '';
        }
        this.setState(update);
    };

    cancelSelector = () => {
        setTimeout(() => { this.setState({ selector: false }) }, 20);
        if (this.drawCreateToolbar) this.drawCreateToolbar.disable();
        let s = this.mymap._layers['selector'];
        this.removeLayer(this.featureGroupP, s);
        let sM = this.mymap._layers['selectorM'];
        this.removeLayer(this.featureGroupP, sM);
        this.selector_l = [];
    };

    setAnchor = (type) => (event) => {
        if (event) {
            this.setState({ anchorMN: event.currentTarget, typeTool: type });
        } else {
            this.setState({ anchorMN: null }, () => setTimeout(() => this.setState({ typeTool: type }), 200));
        }
    };

    openWaypointTypeMenu = () => {
        this.resetClick();
        this.setState({ showWaypointTypes: !this.state.showWaypointTypes, waypointType: '', waypointName: '' });
    };

    createWaypoint = (type) => {
        this.resetClick();

        const waypointType = type === 'H' ? 'H' : 'P';
        const icon = L.icon({
            iconUrl: waypointType === 'H' ? HangarIcon : markerIconGreen,
            iconAnchor: waypointType === 'H' ? [17, 34] : [13, 33]
        });
        const prefix = waypointType === 'H' ? 'Hangar ' : 'Pista ';
        let index = 1;
        let waypointName = prefix + index;
        const runways = Array.isArray(this.state.runways) ? this.state.runways : [];

        while (runways.find(item => item.name === waypointName)) {
            index++;
            waypointName = prefix + index;
        }

        this.drawCreateToolbar = new L.Draw.Marker(this.mymap, { icon: icon });
        this.drawCreateToolbar.enable();

        this.setState({
            create_waypoint: true,
            waypointType: waypointType,
            waypointName: waypointName,
            showWaypointTypes: false
        });

        this.markClick = true;
    };

    cancelCreateWaypoint = () => {
        if (this.drawCreateToolbar) {
            this.drawCreateToolbar.disable();
        }
        this.markClick = false;
        this.setState({ create_waypoint: false, showWaypointTypes: false, waypointType: '', waypointName: '' });
    };

    saveWaypoint = (layer) => {
        if (!layer || !layer._latlng) {
            return;
        }

        const waypointType = this.state.waypointType === 'H' ? 'H' : 'P';
        const name = this.state.waypointName ? this.state.waypointName : (waypointType === 'H' ? 'Hangar' : 'Pista');
        const marker = {
            id: '',
            guid: tools.newGuid(),
            name: name,
            lat: layer._latlng.lat,
            lng: layer._latlng.lng,
            height: 0,
            radios: 0,
            icon: waypointType === 'H' ? 'hangar' : 'marker-icon-green',
            type: waypointType
        };

        let apiUrl = Config.server + '/point';

        const formData = new URLSearchParams();
        formData.append('guid', marker.guid);
        formData.append('name', marker.name);
        formData.append('lat', marker.lat);
        formData.append('lng', marker.lng);
        formData.append('height', marker.height);
        formData.append('radios', marker.radios);
        formData.append('icon', marker.icon);
        formData.append('type', marker.type);

        let options = {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    marker.id = result;
                    const runways = (this.state.runways || []).concat(marker);
                    this.setState({
                        runways: runways,
                        create_waypoint: false,
                        showWaypointTypes: false,
                        waypointType: '',
                        waypointName: ''
                    }, () => {
                        this.renderRunwaysOnMap();
                    });
                    this.markClick = false;
                },
                (error) => {
                    this.cancelCreateWaypoint();
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    } else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    readRunways = () => {
        const apiUrl = Config.server + '/point/R';
        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                return res.json();
            })
            .then((result) => {
                const runways = Array.isArray(result) ? result : [];
                this.setState({ runways: runways }, () => {
                    this.renderRunwaysOnMap();
                });
            })
            .catch((error) => {
                if (error.status === 405) {
                    notification.open({
                        message: this.props.res.PERMISSAO,
                        description: this.props.res.PERMISSAO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                } else if (error.status === 401 || error.status === 403) {
                    this.props.link('/login');
                } else {
                    notification.open({
                        message: this.props.res.ERRO,
                        description: this.props.res.ERRO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                }
            });
    };

    getRunwayIcon = (runway, selected) => {
        const runwayType = runway && runway.type ? String(runway.type).toUpperCase() : '';
        let iconUrl = markerIconGreen;
        let imageWidth = 26;
        let imageHeight = 33;
        let wrapperWidth = 34;
        let wrapperHeight = 41;
        let iconAnchor = [17, 41];
        let popupAnchor = [0, -28];

        if (runwayType === 'H') {
            iconUrl = HangarIcon;
            imageWidth = 34;
            imageHeight = 34;
            wrapperWidth = 44;
            wrapperHeight = 44;
            iconAnchor = [22, 44];
            popupAnchor = [0, -26];
        }

        const wrapperStyle = selected
            ? [
                'display:flex',
                'align-items:center',
                'justify-content:center',
                'width:' + wrapperWidth + 'px',
                'height:' + wrapperHeight + 'px',
                'border-radius:999px',
                'background:rgba(230,126,34,0.18)',
                'border:2px solid #E67E22',
                'box-shadow:0 0 0 3px rgba(230,126,34,0.12)',
                'transform:scale(1.05)'
            ].join(';')
            : [
                'display:flex',
                'align-items:center',
                'justify-content:center',
                'width:' + wrapperWidth + 'px',
                'height:' + wrapperHeight + 'px'
            ].join(';');

        const imageStyle = [
            'display:block',
            'width:' + imageWidth + 'px',
            'height:' + imageHeight + 'px'
        ].join(';');

        return L.divIcon({
            className: '',
            html:
                '<div style="' + wrapperStyle + '">' +
                '<img src="' + iconUrl + '" style="' + imageStyle + '" />' +
                '</div>',
            iconSize: [wrapperWidth, wrapperHeight],
            iconAnchor: iconAnchor,
            popupAnchor: popupAnchor
        });
    };

    clearRunwaysFromMap = () => {
        if (this.featureGroupM) {
            this.featureGroupM.clearLayers();
        }
    };

    renderRunwaysOnMap = () => {
        if (!this.mymap || !this.featureGroupM) return;

        this.clearRunwaysFromMap();

        const runways = Array.isArray(this.state.runways) ? this.state.runways : [];
        const selectedRunways = Array.isArray(this.state.sel_runways) ? this.state.sel_runways : [];

        for (let i = 0; i < runways.length; i++) {
            const runway = runways[i];
            const lat = Number(runway.lat);
            const lng = Number(runway.lng);

            if (!isFinite(lat) || !isFinite(lng)) {
                continue;
            }

            const runwayGuid = String(runway.guid || runway.id || ('runway-' + i));
            const isSelected = selectedRunways.indexOf(runwayGuid) >= 0;

            const marker = L.marker([lat, lng], {
                icon: this.getRunwayIcon(runway, isSelected)
            });

            marker._leaflet_id = runwayGuid;
            marker.runway_guid = runwayGuid;
            marker.runway_data = runway;

            marker.on('click', (e) => {
                if (e && e.originalEvent) {
                    L.DomEvent.stopPropagation(e);
                }
                this.handleClickRunway(runwayGuid);
            });

            if (runway.name) {
                marker.bindTooltip(runway.name, {
                    permanent: false,
                    direction: 'top',
                    className: 'tool-tip-L tool-tip-size16-L'
                });
            }

            this.featureGroupM.addLayer(marker);
        }
    };

    setRunwayMarkerSelected = (guid, selected) => {
        if (!this.featureGroupM) return;

        this.featureGroupM.eachLayer((layer) => {
            if (String(layer.runway_guid) === String(guid)) {
                layer.setIcon(this.getRunwayIcon(layer.runway_data, selected));
            }
        });
    };

    clearRunwaySelection = () => {
        const selectedRunways = Array.isArray(this.state.sel_runways) ? this.state.sel_runways : [];

        for (let i = 0; i < selectedRunways.length; i++) {
            this.setRunwayMarkerSelected(selectedRunways[i], false);
        }

        this.setState({ sel_runways: [] });
    };

    handleClickRunway = (guid) => {
        const current = Array.isArray(this.state.sel_runways) ? this.state.sel_runways.slice() : [];
        const index = current.indexOf(guid);

        if (index >= 0) {
            current.splice(index, 1);
            this.setRunwayMarkerSelected(guid, false);
        } else {
            current.push(guid);
            this.setRunwayMarkerSelected(guid, true);
        }

        this.setState({ sel_runways: current });
    };

    renderSelectedRunwaysList = () => {
        const selectedRunways = Array.isArray(this.state.sel_runways) ? this.state.sel_runways : [];
        const runways = Array.isArray(this.state.runways) ? this.state.runways : [];

        if (selectedRunways.length <= 0) return null;

        return (
            <div style={{ marginTop: '.35rem', marginBottom: '.35rem' }}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '.55rem .75rem',
                        backgroundColor: '#f7f7f7',
                        borderLeft: '5px solid #E67E22',
                        borderBottom: '1px solid #e5e5e5'
                    }}
                >
                    <span style={{ fontWeight: 600, color: '#444' }}>Pistas selecionadas</span>
                    <span style={{ fontSize: '.8rem', color: '#666' }}>
                        {selectedRunways.length}
                    </span>
                </div>

                <List component="nav" aria-labelledby="runways-selected" style={{ paddingTop: 0, paddingBottom: 0 }}>
                    {selectedRunways.map((guid, index) => {
                        const runway = runways.find(item => String(item.guid || item.id) === String(guid));

                        if (!runway) return null;

                        const runwayType = runway.type ? String(runway.type).toUpperCase() : 'P';
                        const secondaryText = runwayType === 'H' ? 'Hangar' : 'Pista';

                        return (
                            <ListItem
                                key={'selected-runway-' + guid + '-' + index}
                                button
                                onClick={() => this.handleClickRunway(String(guid))}
                                style={{
                                    borderLeft: '5px solid #E67E22',
                                    backgroundColor: 'rgba(230,126,34,0.12)',
                                    marginBottom: '1px'
                                }}
                                title={runway.name || secondaryText}
                            >
                                <ListItemIcon style={{ minWidth: '2rem' }}>
                                    <RoomIcon style={{ color: '#E67E22' }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={this.limitChar(runway.name || secondaryText, 300)}
                                    secondary={secondaryText}
                                />
                            </ListItem>
                        );
                    })}
                </List>
            </div>
        );
    };

    getSelectedClient = () => {
        const selectedGuids = Array.isArray(this.state.sel_poly) ? this.state.sel_poly : [];
        const sourceList = this.state[this.tabID[Number(this.state.tab)]] || [];
        let idClient = 0;
        let idProperty = 0;

        for (let i = 0; i < selectedGuids.length; i++) {
            const area = sourceList.find(item => item.guid === selectedGuids[i]);
            if (area && area.id_client) {
                idClient = area.id_client;
                idProperty = area.id_property ? area.id_property : 0;
                break;
            }
        }

        if (!idClient && this.state.tab === '1' && this.state.id_client) {
            idClient = this.state.id_client;
            idProperty = this.state.id_property ? this.state.id_property : 0;
        }

        if (!idClient) return null;

        const client = this.state.clients.find(item => Number(item.id) === Number(idClient));
        const property = this.state.fazenda_client.find(item => Number(item.id) === Number(idProperty));

        return {
            id: idClient,
            name: client ? client.name : '',
            id_property: idProperty || '',
            property: property ? property.name : ''
        };
    };

    buildSelectedPointsForServiceOrder = () => {
        const listPoints = [];
        const selectedRunways = Array.isArray(this.state.sel_runways) ? this.state.sel_runways : [];
        const runways = Array.isArray(this.state.runways) ? this.state.runways : [];

        for (let i = 0; i < selectedRunways.length; i++) {
            const guid = selectedRunways[i];
            const runway = runways.find(item => String(item.guid || item.id) === String(guid));

            if (!runway) {
                continue;
            }

            const lat = runway.lat != null ? String(runway.lat) : '';
            const lng = runway.lng != null ? String(runway.lng) : '';

            listPoints.push({
                guid: runway.guid || runway.id || ('prefill-runway-' + i),
                name: runway.name || '',
                lat: lat,
                lng: lng,
                points_place: JSON.stringify([[Number(runway.lat), Number(runway.lng)]]),
                type: runway.type || 'P',
                img_place: runway.img_place || ''
            });
        }

        return listPoints;
    };

    buildSelectedAreasForServiceOrder = () => {
        const listAreas = [];
        const selectedGuids = Array.isArray(this.state.sel_poly) ? this.state.sel_poly : [];
        const sourceList = this.state[this.tabID[Number(this.state.tab)]] || [];

        for (let i = 0; i < selectedGuids.length; i++) {
            const guid = selectedGuids[i];
            const area = sourceList.find(item => item.guid === guid);

            if (!area) {
                continue;
            }

            let pointsPlace = '[]';
            if (typeof area.points === 'string' && area.points.trim() !== '') {
                pointsPlace = area.points;
            } else if (Array.isArray(area.points)) {
                pointsPlace = JSON.stringify(area.points);
            }

            let lat = '';
            let lng = '';

            try {
                const parsedPoints = typeof pointsPlace === 'string' ? JSON.parse(pointsPlace) : pointsPlace;
                if (Array.isArray(parsedPoints) && parsedPoints.length > 0 && Array.isArray(parsedPoints[0])) {
                    const firstPoint = parsedPoints[0];
                    const latValue = Number(firstPoint[0]);
                    const lngValue = Number(firstPoint[1]);

                    if (!isNaN(latValue)) {
                        lat = String(latValue.toFixed(6));
                    }

                    if (!isNaN(lngValue)) {
                        lng = String(lngValue.toFixed(6));
                    }
                }
            } catch (e) { }

            listAreas.push({
                guid: area.guid,
                name: area.name || '',
                lat: lat,
                lng: lng,
                points_place: pointsPlace,
                id_client: area.id_client || '',
                id_property: area.id_property || '',
                type: 'area',
                poly_type: area.type
            });
        }

        return listAreas;
    };

    buildSelectedPlanningPoints = () => {
        const selectedRunways = Array.isArray(this.state.sel_runways) ? this.state.sel_runways : [];
        const runways = Array.isArray(this.state.runways) ? this.state.runways : [];

        let base = null;
        let fuel = [];

        for (let i = 0; i < selectedRunways.length; i++) {
            const guid = selectedRunways[i];
            const runway = runways.find(item => String(item.guid || item.id) === String(guid));

            if (!runway) {
                continue;
            }

            const lat = Number(runway.lat);
            const lng = Number(runway.lng);
            const type = runway.type ? String(runway.type).toUpperCase() : 'P';

            if (!isFinite(lat) || !isFinite(lng)) {
                continue;
            }

            if (type === 'H') {
                if (!base) {
                    base = {
                        guid: String(runway.guid || runway.id || ('planning-base-' + i)),
                        lat: lat,
                        lng: lng,
                        type: 'H',
                        name: runway.name || ''
                    };
                }
            } else {
                fuel.push({
                    guid: String(runway.guid || runway.id || ('planning-fuel-' + i)),
                    lat: lat,
                    lng: lng,
                    status: 'Y',
                    type: 'P',
                    name: runway.name || ''
                });
            }
        }

        return { base, fuel };
    };

    readLocalOverlapPreference = () => {
        try {
            if (!this.overlapPreferenceStorageKey) return null;
            const value = localStorage.getItem(this.overlapPreferenceStorageKey);
            return value === 'true' ? true : (value === 'false' ? false : null);
        } catch (_) {
            return null;
        }
    };

    loadOverlapPreference = () => {
        const token = localStorage.getItem('access-token-jwt');
        try {
            const tokenPayload = token ? token.split('.')[1] : null;
            if (tokenPayload) {
                const base64 = tokenPayload.replace(/-/g, '+').replace(/_/g, '/');
                const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
                const payload = JSON.parse(atob(padded));
                const companyId = payload.company_id || payload.id_company;
                if (companyId) this.overlapPreferenceStorageKey = 'areas-show-overlaps:' + companyId;
            }
        } catch (_) { }

        const localPreference = this.readLocalOverlapPreference();
        if (localPreference !== null) {
            this.setState({ showOverlaps: localPreference }, this.recalculateOverlaps);
        }

        const applyPreference = (companyDefault) => {
            // A pending request must not overwrite a choice made in the menu.
            if (this.overlapPreferenceChanged) return;
            const saved = this.readLocalOverlapPreference();
            this.setState({ showOverlaps: saved === null ? companyDefault : saved }, this.recalculateOverlaps);
        };

        fetch(`${Config.server}/company_preferences`, {
            method: 'GET',
            headers: { 'Authorization': token }
        })
            .then((res) => {
                if (res.status !== 200) throw res;
                return res.json();
            })
            .then((result) => {
                if (result.id_company) this.overlapPreferenceStorageKey = 'areas-show-overlaps:' + result.id_company;
                applyPreference(!!result.preferences && result.preferences.showOverlaps === true);
            })
            .catch(() => applyPreference(false));
    };

    toggleOverlapVisibility = () => {
        const showOverlaps = !this.state.showOverlaps;
        this.overlapPreferenceChanged = true;
        try {
            if (this.overlapPreferenceStorageKey) {
                localStorage.setItem(this.overlapPreferenceStorageKey, String(showOverlaps));
            }
        } catch (_) { }
        this.setState({ showOverlaps, anchorAPO: null }, this.recalculateOverlaps);
    };

    loadCompanyOpenModules = () => {
        try {
            const token = localStorage.getItem('access-token-jwt');
            const tokenPayload = token ? token.split('.')[1] : null;

            if (!tokenPayload) {
                return;
            }

            const base64 = tokenPayload.replace(/-/g, '+').replace(/_/g, '/');
            const paddedBase64 = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
            const payload = JSON.parse(atob(paddedBase64));
            const companyId = payload.id_company;

            if (!companyId) {
                return;
            }

            fetch(`${Config.server}/company/${companyId}`, {
                method: 'GET',
                headers: {
                    'Authorization': token
                }
            })
                .then((res) => {
                    if (res.status !== 200) throw res;
                    return res.json();
                })
                .then((result) => {
                    const company = Array.isArray(result) ? result[0] : result;

                    this.setState({
                        openModules: !!company && Number(company.openModules) === 1
                    });
                })
                .catch(() => {
                    this.setState({ openModules: false });
                });
        } catch (_) {
            this.setState({ openModules: false });
        }
    };

    openAppPath = (path, navigationState = null) => {
        if (this.state.openModules) {
            const newWindow = window.open(`${window.location.origin}${path}`, '_blank');

            if (newWindow) {
                return;
            }
        }

        this.props.link(path, navigationState);
    };

    abrirOrdemServico = () => {
        const listAreas = this.buildSelectedAreasForServiceOrder();
        const listPoints = this.buildSelectedPointsForServiceOrder();
        const selectedClient = this.getSelectedClient();

        if (!listAreas.length && !listPoints.length) {
            return;
        }

        try {
            sessionStorage.setItem('serviceOrderPrefillAreas', JSON.stringify(listAreas));
            sessionStorage.setItem('serviceOrderPrefillPoints', JSON.stringify(listPoints));
            if (selectedClient) {
                sessionStorage.setItem('serviceOrderPrefillClient', JSON.stringify(selectedClient));
            } else {
                sessionStorage.removeItem('serviceOrderPrefillClient');
            }
        } catch (_) { }

        this.openAppPath('/app/ordem-servico/edit', {
            state: {
                prefilledAreas: listAreas,
                prefilledPoints: listPoints,
                prefilledClient: selectedClient
            }
        });
    };

    abrirPlanejamento = async () => {
        const tabKey = this.tabID[Number(this.state.tab)];
        const byGuid = new Map(this.state[tabKey].map(poly => [poly.guid, poly]));
        const selected = this.state.sel_poly
            .map(guid => byGuid.get(guid))
            .filter(Boolean);
        try {
            if (selected.some(poly => !poly.points)) {
                await this.getLazyGeometryRows(selected);
                selected.forEach(poly => this.hydrateLazyArea(poly.guid, tabKey));
            }
            if (selected.some(poly => !poly.points)) return;
        } catch (error) {
            notification.open({ message: this.props.res.ERRO, description: this.props.res.ERRO_MSG });
            return;
        }
        let polyPlan = [];
        const sel_poly = selected.map(poly => poly.guid);
        for (let i = 0; i < sel_poly.length; i++) {
            const element = selected.filter(item => item.guid === sel_poly[i]);
            if (element.length > 0) {
                polyPlan.push({
                    "guid": element[0].guid,
                    "name": element[0].name,
                    "points": element[0].points,
                    "type": element[0].type,
                    "id_property": element[0].id_property,
                    ...(element[0].type === 'N' ? { ab: this.parseAreaAb(element[0].ab, element[0].type) } : {})
                });
            }
        }
        //let d_estimate = localStorage.getItem('f-estimate');

        const planningPoints = this.buildSelectedPlanningPoints();
        const selectedClient = this.getSelectedClient();
        let new_estimate = {
            polygons: polyPlan,
            base: planningPoints.base,
            fuel: planningPoints.fuel,
            client: selectedClient,
            id_client: selectedClient ? selectedClient.id : null
        };
        localStorage.setItem('f-estimate', JSON.stringify(new_estimate));
        this.openAppPath('/app/estimativa');
    };

    selectSendPlanes = (id) => {
        let selPlanes = this.state.selectedSendPlanes;
        let i = selPlanes.indexOf(id);
        if (i > -1) {
            selPlanes.splice(i, 1);
        } else {
            selPlanes.push(id);
        }
        this.setState({ selectedSendPlanes: selPlanes });
    };

    updateListPlanes = () => {
        const apiUrl = Config.server + '/plane_dgps';

        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    this.setState({ planes: result });
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        console.log(error);
                        this.props.link('/login');
                    }
                    else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    sendFile = () => {
        let list_area = this.state.sel_poly;
        let list_plane = this.state.selectedSendPlanes;

        this.setState({ progress: true, anchorPL: null });
        let apiUrl = Config.server + '/transfer';
        let method = 'POST';

        let ids = [];
        let polys = this.state[this.tabID[Number(this.state.tab)]];
        for (let i = 0; i < list_area.length; i++) {
            const element = polys.filter(p => (list_area[i] === p.guid));
            if (element.length > 0) {
                ids.push(element[0].id);
            }
        }

        const formData = new URLSearchParams();
        formData.append('list_plane', JSON.stringify(list_plane));
        formData.append('list_area', JSON.stringify(ids));
        formData.append('type', 'region');
        formData.append('name', this.state.nameR);

        let options = {
            method: method,
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }

        fetch(apiUrl, options)
            .then((resData) => {
                if (resData.status !== 200) throw resData;
                else return resData.json();
            })
            .then(
                (result) => {
                    this.setState({ progress: false });
                    if (result.msg) {
                        notification.open({
                            message: this.props.res.ENVIANDO_AREAS,
                            icon: <MaterialIcon icon="check_circle" className="text-success" />
                        });
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                },
                (error) => {
                    this.setState({ progress: false });
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    }
                    else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    getChangePatternButton = () => {
        const polygon = this.getSelectedZonePolygon();
        let icon;
        let title;

        if (polygon && polygon.type === 'X') {
            icon = "close";
            title = this.props.res.POLY_X;
        } else if (polygon && polygon.type === 'T') {
            icon = "indeterminate_check_box";
            title = this.props.res.POLY_T;
        } else {
            icon = "check";
            title = this.props.res.POLY_N;
        }

        if (polygon) {
            return (
                <span>
                    <Button className="buttonS buttonMenu" disabled={this.state.disable || this.state.split} onClick={event => this.changeType(this.tabID[Number(this.state.tab)])} title={title}>
                        <MaterialIcon icon={icon} className="iconMap" />
                    </Button>
                    <Button className={"buttonS buttonMenu buttonMenuPS"} onClick={this.setAnchor('type')}>
                        <MaterialIcon icon="arrow_drop_down" className="iconMap" />
                    </Button>
                </span>
            );
        }
    };
    trim_poly = null;
    createTrim = () => {
        const guid = this.state.sel_poly[0];
        const areas = this.state[this.tabID[Number(this.state.tab)]] || [];
        const area = areas.find(item => item.guid === guid);
        const layer = this.mymap && this.mymap._layers ? this.mymap._layers[guid] : null;
        const poly = layer && typeof layer.getLatLngs === 'function'
            ? layer.getLatLngs()[0]
            : area && area.points ? L.polygon(JSON.parse(area.points)).getLatLngs()[0] : null;
        const line = this.state.sel_trim === 'point' ? this.trim_line : [];
        const size = parseFloat(this.state.trim_size);
        const type = this.state.type_trim;
        if (!poly || (this.state.sel_trim === 'point' && !line?.length) || size <= 0) {
            return;
        }

        const polys = geo.createTrimFromLine(poly, line, size, type);

        if (!polys || polys.length === 0) {
            notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.TRIM_CREATE_ERROR,
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
            return;
        }
        //const sPoly = this.state.polygons.find(item => item.guid === this.state.sel_poly[0]);
        this.trim_poly = {
            guid: tools.newGuid(),
            name: '',
            type: 'T',
            points: JSON.stringify(polys),
            //old: { ob: [this.state.areaPup] }
        }
        this.drawPolygon(this.trim_poly, this.tabID[0]);
    };
    side_trim = 'L';
    handleChangeTrim = name => event => {
        const value = isNaN(event.target.value) ? event.target.value : Units.toCanonicalLength(event.target.value, this.res);
        const nextState = { [name]: value };

        if (name === 'sel_oper') {
            // Combining needs the external border; reducing needs the internal one.
            // A new trim starts internally but keeps the selector enabled.
            nextState.type_trim = value === 'merge' ? 'out' : 'in';
        }

        this.setState(nextState, () => {
            if (name === 'sel_trim') {
                if (value === 'point') {
                    this.removeLayer(this.featureGroupP, this.mymap._layers[this.trim_poly?.guid]);
                    this.featureGroupM.clearLayers();

                    const sPoly = this.state.polygons.find(item => item.guid === this.state.sel_poly[0]);
                    const points = JSON.parse(sPoly.points);
                    for (let i = 0; i < points.length; i++) {
                        const marker = L.circleMarker(points[i], {
                            radius: 12,
                            color: 'black',
                            fillColor: 'white',
                            fillOpacity: 1
                        }).addTo(this.featureGroupM);
                        marker.on('click', () => {
                            if (!this.trim_line || this.trim_line.length === 0) {
                                this.trim_line = [[marker.getLatLng().lat, marker.getLatLng().lng]];
                            } else {
                                let cPoints = geo.connectPoints(points, this.trim_line, marker.getLatLng(), this.side_trim);
                                this.trim_line = cPoints.line;
                                this.side_trim = cPoints.side;
                            }
                            this.removeLayer(this.featureGroupP, this.mymap._layers[this.trim_poly?.guid]);
                            if (this.trim_line.length > 1) {
                                this.createTrim();
                            }

                            let layers = this.featureGroupM._layers;
                            for (let i = 0; i < Object.keys(layers).length; i++) {
                                let layer = layers[Object.keys(layers)[i]];
                                this.removeLayer(this.featureGroupM, layer);
                                let sel = false;
                                for (let k = 0; k < this.trim_line.length; k++) {
                                    const ll = layer.getLatLng();
                                    if (ll.lat === this.trim_line[k][0] && ll.lng === this.trim_line[k][1]) {
                                        layer.setStyle({
                                            color: 'white',
                                            fillColor: '#ff7b00'
                                        });
                                        sel = true;
                                    }
                                }
                                if (!sel) {
                                    layer.setStyle({
                                        color: 'black',
                                        fillColor: 'white'
                                    });
                                }
                                layer.addTo(this.featureGroupM);
                            }
                        });
                    }
                } else {
                    this.removeLayer(this.featureGroupP, this.mymap._layers[this.trim_poly?.guid]);
                    this.createTrim();
                    this.featureGroupM.clearLayers();
                }
            } else {
                this.removeLayer(this.featureGroupP, this.mymap._layers[this.trim_poly?.guid]);
                this.createTrim();
            }
        });
    };
    subtrairGeometria = (area_sel, area_ger) => {
        let geoj_sel;
        let geoj_ger;
        let difference;

        try {
            const myLayer_sel = L.polygon(JSON.parse(area_sel.points));
            geoj_sel = myLayer_sel.toGeoJSON();
            const myLayer_ger = L.polygon(JSON.parse(area_ger.points));
            geoj_ger = myLayer_ger.toGeoJSON();

            // Turf 5 receives the two features separately, not a FeatureCollection.
            difference = turf.difference(geoj_sel, geoj_ger);
        } catch (error) {
            console.error('Erro ao subtrair geometrias', error);
            notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.ERRO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
            return;
        }

        // createTrimFromLine opens a closed trim with a 0.1 m cut so Leaflet
        // can render it without a hole. Remove that artificial, narrow bridge
        // from the remaining geometry before saving the subtraction.
        if (difference && difference.geometry && this.state.sel_trim === 'poly' && this.state.type_trim !== 'out') {
            try {
                // geo.createTrimFromLine creates the opening with a 0.1 m buffer.
                // Use a small margin so projection/rounding cannot retain a sliver.
                const cutHalfWidthMeters = 0.15;
                const eroded = turf.buffer(difference, -cutHalfWidthMeters, { units: 'meters' });
                const withoutCutLine = eroded && turf.buffer(eroded, cutHalfWidthMeters, { units: 'meters' });
                if (withoutCutLine && withoutCutLine.geometry) {
                    difference = withoutCutLine;
                }
            } catch (error) {
                // Keep the exact Turf difference if the geometry cannot be normalized.
                console.warn('Não foi possível remover a linha de corte do trim', error);
            }
        }

        const parts = [];
        if (difference && difference.geometry) {
            if (difference.geometry.type === 'Polygon') {
                parts.push(difference);
            } else if (difference.geometry.type === 'MultiPolygon') {
                difference.geometry.coordinates.forEach(coordinates => {
                    try {
                        parts.push(turf.polygon(coordinates, difference.properties || {}));
                    } catch (error) {
                        console.warn('Parte inválida retornada pela subtração', error);
                    }
                });
            }
        }

        const removedGuids = [area_sel.guid, area_ger.guid];
        removedGuids.forEach(guid => {
            this.removeLayer(this.featureGroupP, this.mymap._layers[guid]);
        });

        if (area_sel.id !== undefined && area_sel.id !== null) {
            this.deleteArea([area_sel.id]);
        }

        const itens = this.state.polygons.filter(item => item.guid !== area_sel.guid);
        const old = { ob: [area_sel] };
        const resultGuids = [];

        parts.forEach((part, index) => {
            // Douglas-Peucker simplification can reconnect the two sides of the
            // narrow trim opening and recreate the central leakage line. Keep
            // the topology returned by Turf and remove only redundant vertices.
            try {
                const cleanPart = turf.cleanCoords(part);
                const coordinates = cleanPart.geometry && cleanPart.geometry.coordinates && cleanPart.geometry.coordinates[0];
                if (!coordinates || coordinates.length < 4) return;

                const latlngs = this.geojsonToLeafletArray(coordinates);
                if (latlngs.length < 4) return;

                const tempRumo = new polygon();
                tempRumo.id_region = area_sel.id_region;
                tempRumo.id_client = area_sel.id_client;
                tempRumo.id_property = area_sel.id_property;
                tempRumo.id_folder_area = area_sel.id_folder_area;
                tempRumo.type = area_sel.type || 'N';
                tempRumo.guid = tools.newGuid();
                tempRumo.name = parts.length === 1 ? area_sel.name : area_sel.name + ' (' + (index + 1) + ')';
                tempRumo.points = JSON.stringify(latlngs);
                tempRumo.svg = this.generateSVGPath(latlngs);
                tempRumo.old = old;
                tempRumo.custom_color = area_sel.custom_color || '';
                tempRumo.ab = this.parseAreaAb(area_sel.ab, area_sel.type);

                this.drawPolygon(tempRumo, this.tabID[0]);
                this.updateArea(tempRumo);
                itens.push(tempRumo);
                resultGuids.push(tempRumo.guid);
            } catch (error) {
                console.warn('Não foi possível criar uma área resultante da subtração', error);
            }
        });

        this.trim_poly = null;
        const selectResult = index => {
            if (index >= resultGuids.length) return;
            this.handleClickP(resultGuids[index], this.tabID[0], () => selectResult(index + 1));
        };

        this.setState({ polygons: itens, tab: '0', sel_poly: [] }, () => {
            this.past_merge = true;
            selectResult(0);
        });
    };
    saveTrim = () => {
        const sPoly = this.state.polygons.find(item => item.guid === this.state.sel_poly[0]);
        if (this.state.sel_oper === 'merge') {
            this.trim_poly.type = sPoly ? sPoly.type : 'T';
            this.setState({
                sel_poly: this.state.sel_poly.concat([this.trim_poly.guid]),
                gap_size: 10,
                type: 5,
                showTrim: false
            }, () => {
                this.junta();
            });
        } else if (this.state.sel_oper === 'reduce') {
            this.setState({
                sel_poly: this.state.sel_poly.concat([this.trim_poly.guid]),
                showTrim: false
            }, () => {
                console.log('sel_poly', this.state.sel_poly);

                this.subtrairGeometria(sPoly, this.trim_poly);
            });
        } else {
            this.trim_poly.name = sPoly.name + ' - Trim';
            this.updateArea(this.trim_poly);
            this.setState({
                polygons: this.state.polygons.concat(this.trim_poly),
                showTrim: false
            });
        }
        this.featureGroupM.clearLayers();
    };
    cancelTrim = () => {
        this.trimGeometryRequest = (this.trimGeometryRequest || 0) + 1;
        if (this.trim_poly) {
            this.removeLayer(this.featureGroupP, this.mymap._layers[this.trim_poly.guid]);
            this.featureGroupM.clearLayers();
        }
        this.setState({ showTrim: false });
    };
    showTrim = async () => {
        const request = this.trimGeometryRequest = (this.trimGeometryRequest || 0) + 1;
        const from = this.tabID[Number(this.state.tab)];
        const guid = this.state.sel_poly[0];
        const area = (this.state[from] || []).find(item => item.guid === guid);
        if (!area || this.state.sel_poly.length !== 1) return;

        try {
            if (!area.points) {
                await this.getLazyGeometryRows([area]);
                this.hydrateLazyArea(guid, from);
            }
            if (request !== this.trimGeometryRequest || from !== this.tabID[Number(this.state.tab)] ||
                this.state.sel_poly.length !== 1 || this.state.sel_poly[0] !== guid) return;
            if (!area.points) throw new Error('trim-geometry-not-found');

            if (this.state.manualAbGuid) this.closeManualAb();
            this.trim_line = [];
            this.setState({ showTrim: true, sel_trim: 'poly' }, this.createTrim);
        } catch (error) {
            if (request !== this.trimGeometryRequest) return;
            if (error && (error.status === 401 || error.status === 403)) {
                this.props.link('/login');
            } else {
                notification.open({
                    message: this.props.res.ERRO,
                    description: this.props.res.TRIM_CREATE_ERROR,
                    icon: <MaterialIcon icon="error" className="text-danger" />
                });
            }
        }
    };

    loadPastas = (id, ref, callback) => {
        if (!id) {
            //let folders = this.estruturaPastas([{ id: 'c', name: 'Áreas Compartilhadas' }, { id: 'm', name: 'Minhas Áreas' }]);
            //this.setState({ folders: folders });

            if (callback) {
                callback([]);
            }
            return;
        }

        let ref_id = id;
        let apiUrl = Config.server + '/folder_area';
        if (ref_id) {
            apiUrl += '/client/' + ref_id;
        }

        let obj = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, obj)
            .then((res) => {
                if (res.status !== 200)
                    throw res;
                else
                    return res.json();
            })
            .then(
                (result) => {
                    if (result) {
                        let r1 = result.filter(item => item.id_property === null);
                        let r2 = result.filter(item => item.id_property !== null);
                        let folders = this.estruturaPastas(r1);
                        let foldersP = this.estruturaPastas(r2);

                        if (!ref_id) {
                            this.setState({ folders: folders }, () => {
                                this.mountFoldersPup(folders);

                                if (callback) {
                                    callback(folders);
                                }
                            });
                        } else {
                            this.setState({ [ref]: foldersP }, () => {
                                if (callback) {
                                    callback(foldersP);
                                }
                            });
                        }
                    } else {
                        if (callback) {
                            callback([]);
                        }
                    }
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    }
                    else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }

                    if (callback) {
                        callback([]);
                    }
                }
            );
    };

    estruturaPastas = (folders) => {
        let tree = [];
        let map = {};
        folders.forEach((folder) => {
            map[folder.id] = { ...folder, children: [], active: false, visible: false };
        });

        folders.forEach((folder) => {
            if (folder.id_folder_area) {
                map[folder.id_folder_area].children.push(map[folder.id]);
            } else {
                tree.push(map[folder.id]);
            }
        });
        return tree;
    };

    mountList = (folders, polys, lvl, open, cache) => {
        const change = { marginLeft: (lvl ? lvl * 4 : 0) + 'px', maxHeight: open ? 'fit-content' : '0px' };

        if (lvl > 0 && !open) {
            return <div className={lvl ? 'panel' : ''} style={change}></div>;
        }

        return <div className={lvl ? 'panel' : ''} style={change}>
            {this.mountFonder(folders, lvl, cache)}
            {this.mountPolygons(polys, lvl, cache)}
        </div>;
    };

    getFolderById = (folders, id) => {
        for (let i = 0; i < folders.length; i++) {
            const folder = folders[i];
            if (folder.id === id) {
                return folder;
            } else if (folder.children.length > 0) {
                const res = this.getFolderById(folder.children, id);
                if (res) {
                    return res;
                }
            }
        }
        return null;
    };

    removeFolderById = (folders, id) => {
        if (!Array.isArray(folders)) {
            return false;
        }
        for (let i = 0; i < folders.length; i++) {
            const folder = folders[i];
            if (!folder) continue;
            if (folder.id === id) {
                folders.splice(i, 1);
                return true;
            } else if (Array.isArray(folder.children) && folder.children.length > 0) {
                if (this.removeFolderById(folder.children, id)) {
                    return true;
                }
            }
        }
        return false;
    };

    addFolderBy = (folders, id_parent, folder_add) => {
        if (!id_parent) {
            folders.push(folder_add);
            return true;
        }
        for (let i = 0; i < folders.length; i++) {
            const folder = folders[i];
            if (folder.id === id_parent) {
                folder.children.push(folder_add);
                return true;
            } else if (folder.children.length > 0) {
                if (this.addFolderById(folder.children, id_parent, folder_add)) {
                    return true;
                }
            }
        }
        return false;
    };

    mountFoldersPup = (folders) => {
        const list = [];
        const mouuntList = (fs, lvl) => {
            for (let i = 0; i < fs.length; i++) {
                list.push({ ...fs[i], lvl });
                if (fs[i].children.length > 0) {
                    mouuntList(fs[i].children, lvl + 1);
                }
            }
        };
        mouuntList(folders, 0);
        this.setState({ foldersPup: list });
    };

    mountFonder = (folders, lvl, cache) => {
        const filteredFolders = sortByName(this.getFilteredFolders(folders));
        const selectedMap = cache.selectedMap;
        const folderIndex = cache.folderIndex;

        return filteredFolders.map((item, index) => {
            const isSelected = selectedMap[item.guid] ? true : false;
            const childPolygons = folderIndex[item.id] || [];

            return <React.Fragment key={index + "_fragfo_" + item.id}>
                <div
                    type='folder'
                    lvl={lvl}
                    idFolder={item.id}
                    key={index + "_divfo_" + item.id}
                    id={index + "_divfo_" + item.id}
                    style={{ display: 'flex', position: 'relative' }}
                >
                    {lvl > 0
                        ? <div style={{ width: '.5rem', margin: '-1.1rem -12px 0 0', height: '2.6rem', borderLeft: 'solid 2px #0000002e', borderBottom: 'solid 2px #0000002e' }}></div>
                        : <div style={{ width: '.5rem', margin: '-1.1rem -12px 0 0', height: '2.6rem' }}></div>
                    }

                    <ListItem
                        key={index + 'pf1' + item.id}
                        button
                        className={isSelected ? 'SelItem' : ''}
                        onClick={event => this.handleFolderClick(index + "_divfo_" + item.id, item)}
                        title={item.name}
                    >
                        <ListItemIcon style={{ minWidth: '20px', marginLeft: '-.7rem' }}>
                            {!item.active
                                ? <MaterialIcon icon="arrow_right" className="iconMap" />
                                : <MaterialIcon icon="arrow_drop_down" className="iconMap" />
                            }
                        </ListItemIcon>

                        <ListItemIcon style={{ minWidth: '30px', marginLeft: '-.8rem' }}>
                            <MaterialIcon icon="folder_open" className="iconMap" />
                        </ListItemIcon>

                        <ListItemText id={index} primary={this.limitChar(item.name, 300)} />
                    </ListItem>

                    <ListItem
                        key={index + 'pf3' + item.id}
                        button
                        style={isSelected ? { width: '3rem', height: '3rem', backgroundColor: '#f0f0f0' } : { width: '3rem', height: '3rem' }}
                        title={item.name}
                        onClick={event => this.handleVisibilityClickBusy(event, item, 'folder')}
                    >
                        {item.visible
                            ? <MaterialIcon style={{ marginLeft: '-.2rem', opacity: '.8' }} icon="visibility" className="iconMap" />
                            : <MaterialIcon style={{ marginLeft: '-.2rem' }} icon="visibility_off" className="iconMap" />
                        }
                    </ListItem>

                    <ListItem
                        key={index + 'pf2' + item.id}
                        button
                        style={isSelected ? { width: '3rem', height: '3rem', backgroundColor: '#f0f0f0' } :
                            this.state.sel_poly.length > 0 && !this.state.sel_poly.includes(item.guid)
                                ? { width: '3rem', height: '3rem', opacity: '.1' }
                                : { width: '3rem', height: '3rem' }}
                        onClick={event => { this.setState({ anchorEl: event.currentTarget, areaPup: item, type_menu: 'folder' }); }}
                        title={item.name}
                        disabled={this.state.sel_poly.length > 0 && !this.state.sel_poly.includes(item.guid)}
                    >
                        <h2>...</h2>
                    </ListItem>
                </div>

                {this.mountList(item.children, childPolygons, lvl + 1, item.active, cache)}
            </React.Fragment>;
        });
    };

    mountPolygons = (polys, lvl, cache) => {
        const selectedMap = cache.selectedMap;
        const renderedPolygons = sortByName(polys).slice(0, this.state.listRenderLimit);
        const from = this.tabID[Number(this.state.tab)];
        const hasSelection = this.state.sel_poly.length > 0;

        return renderedPolygons.map((item, index) => {
            const orderNumber = selectedMap[item.guid] || null;
            return <AreaPolygonRow
                key={item.guid || (index + "_divpa_" + item.id)}
                area={item}
                from={from}
                level={lvl}
                orderNumber={orderNumber}
                hasSelection={hasSelection}
                color={this.getPolygonColor(item)}
                name={item.name}
                visible={item.visible}
                svg={item.svg}
                hasOverlap={item.has_overlap}
                map={this}
                onVisible={this.observeListPolygon}
            />;
        });
    };

    //converte from leaflet coordinates to svg path in the scale viewBox="-1 0 11 11"
    generateSVGPath = (points) => {
        if (!points || points.length === 0) {
            return '';
        }
        // Apply Mercator projection correction for latitude distortion
        // Convert lat/lng to meters using Web Mercator projection
        const toWebMercator = (lat, lng) => {
            const earthRadius = 6378137; // Earth's radius in meters
            const x = lng * Math.PI / 180 * earthRadius;
            const y = Math.log(Math.tan((90 + lat) * Math.PI / 360)) * earthRadius;
            return [x, y];
        };

        // Convert all points to Web Mercator. Avoid Array#map here because this
        // path is generated for every imported polygon.
        const mercatorPoints = new Array(points.length);
        for (let i = 0; i < points.length; i++) {
            mercatorPoints[i] = toWebMercator(points[i][0], points[i][1]);
        }

        // Find bounds in Web Mercator coordinates
        let minX = mercatorPoints[0][0];
        let maxX = mercatorPoints[0][0];
        let minY = mercatorPoints[0][1];
        let maxY = mercatorPoints[0][1];

        for (let i = 1; i < mercatorPoints.length; i++) {
            if (mercatorPoints[i][0] < minX) minX = mercatorPoints[i][0];
            if (mercatorPoints[i][0] > maxX) maxX = mercatorPoints[i][0];
            if (mercatorPoints[i][1] < minY) minY = mercatorPoints[i][1];
            if (mercatorPoints[i][1] > maxY) maxY = mercatorPoints[i][1];
        }

        const xRange = maxX - minX || 1;
        const yRange = maxY - minY || 1;

        // Use the larger range to maintain aspect ratio
        const maxRange = Math.max(xRange, yRange);

        // ViewBox is "-1 0 11 11", so use 8x8 area centered
        const scale = 8;
        const viewBoxCenterX = 5;
        const viewBoxCenterY = 5.5;

        const pathParts = new Array(mercatorPoints.length);
        for (let i = 0; i < mercatorPoints.length; i++) {
            // Normalize to -0.5 to 0.5 range, then scale and center
            const normalizedX = (mercatorPoints[i][0] - minX - xRange / 2) / maxRange;
            const normalizedY = (mercatorPoints[i][1] - minY - yRange / 2) / maxRange;

            const x = viewBoxCenterX + normalizedX * scale;
            const y = viewBoxCenterY - normalizedY * scale; // Flip Y axis for SVG

            pathParts[i] = (i === 0 ? 'M ' : 'L ') + x.toFixed(2) + ' ' + y.toFixed(2);
        }
        return pathParts.join(' ') + ' Z';
    };

    handleFolderClick = (divId, item) => {
        const div = document.getElementById(divId);
        if (div) {
            this.changeDiv(div, item);
        }
    };

    handleVisibilityClick = (item, type) => {
        if (item) {
            item.visible = !item.visible;

            if (type === 'poly') {
                this.updateVisibilityLayer(this.featureGroupP, item, item.visible, false);
            } else {
                this.updateVisibleLayers(this.featureGroupP, item, item.visible, type);

                if (item.children && item.children.length > 0) {
                    for (let i = 0; i < item.children.length; i++) {
                        this.handleVisibilityClick(item.children[i], 'folder');
                    }
                }
            }

            if (type === 'folder') {
                this.checkVisibility(item);
            } else {
                this.checkVisibility();
            }

            if (this.state.tab === '0') {
                this.setState({ folders: [...this.state.folders] });
            } else {
                this.setState({
                    folders_properties: [...this.state.folders_properties],
                    fazenda_client: [...this.state.fazenda_client]
                });
            }
        } else {
            if (this.state.tab === '0') {
                const rootPolys = this.state.polygons;
                for (let j = 0; j < rootPolys.length; j++) {
                    this.updateVisibilityLayer(this.featureGroupP, rootPolys[j], this.state.visibleAll !== 1, false);
                }
                this.checkVisibility();
                this.setState({ polygons: [...this.state.polygons] });
            } else {
                const rootPolys = this.state.areas_client.filter(p => p.id_property !== null);
                for (let j = 0; j < rootPolys.length; j++) {
                    this.updateVisibilityLayer(this.featureGroupP, rootPolys[j], this.state.visibleAll !== 1, false);
                }
                this.checkVisibility();
                this.setState({
                    areas_client: [...this.state.areas_client],
                    folders_properties: [...this.state.folders_properties],
                    fazenda_client: [...this.state.fazenda_client]
                });
            }
        }
    };

    updateVisibleLayers = (map, item, visible, type) => {
        const polygons = this.state.tab === '0' ? this.state.polygons : this.state.areas_client;
        let polys = [];

        for (let i = 0; i < polygons.length; i++) {
            const p = polygons[i];

            const isFolderMatch = type === 'folder' && Number(p.id_folder_area) === Number(item.id);
            const isPropertyMatch = type === 'property' && Number(p.id_property) === Number(item.id);

            if (isFolderMatch || isPropertyMatch) {
                if (!visible) {
                    this.removeLayer(map, this.mymap._layers[p.guid]);
                    p.visible = false;
                } else {
                    p.visible = true;
                    polys.push(p);
                }
            }
        }

        if (polys.length > 0) {
            this.loadPolygons(polys);
        }

        if (this.state.tab === '0') {
            this.setState({ polygons: [...this.state.polygons] });
        } else {
            this.setState({ areas_client: [...this.state.areas_client] });
        }

        if (type === 'folder') {
            this.checkVisibility(item);
        } else {
            this.checkVisibility();
        }

        this.syncPolygonClusters();
    };

    updateVisibilityLayer = (map, item, visible, update_state) => {
        if (!visible) {
            this.removeLayer(map, this.mymap._layers[item.guid]);
            item.visible = false;
        } else {
            item.visible = true;
            this.loadPolygons([item]);
        }

        if (update_state) {
            if (this.state.tab === '0') {
                this.setState({ polygons: [...this.state.polygons] });
            } else {
                this.setState({ areas_client: [...this.state.areas_client] });
            }
        }

        this.checkVisibility();
        this.syncPolygonClusters();
    };

    checkVisibility = (folder) => {
        const polygons = this.state.tab === '0' ? this.state.polygons : this.state.areas_client;
        const checkFolderVisibility = (currentFolder) => {
            let allVisible = true;
            let anyVisible = false;
            let hasPoly = false;
            for (let i = 0; i < polygons.length; i++) {
                const p = polygons[i];
                if (p.id_folder_area === currentFolder.id) {
                    hasPoly = true;
                    if (p.visible) {
                        anyVisible = true;
                    } else {
                        allVisible = false;
                    }
                }
            }
            if (currentFolder.children && currentFolder.children.length > 0) {
                for (let j = 0; j < currentFolder.children.length; j++) {
                    const childVisibility = checkFolderVisibility(currentFolder.children[j]);
                    allVisible = allVisible && childVisibility.allVisible;
                    anyVisible = anyVisible || childVisibility.anyVisible;
                }
            } else if (!hasPoly) {
                allVisible = false;
            }
            currentFolder.visible = anyVisible;
            return { allVisible, anyVisible };
        };
        if (folder) {
            const polysVisible = polygons.filter(p => p.id_folder_area === folder.id && p.visible);
            const polysTotal = polygons.filter(p => p.id_folder_area === folder.id);
            const result = checkFolderVisibility(folder);

            if (result.allVisible && polysTotal.length === polysVisible.length) {
                this.setState({ visibleAll: 1 });
            } else if (result.anyVisible || polysVisible.length > 0) {
                this.setState({ visibleAll: 2 });
            } else {
                this.setState({ visibleAll: 0 });
            }
        } else {
            if (this.state.tab !== '0') {
                const rootFolders = this.state.folders_properties;
                for (let j = 0; j < rootFolders.length; j++) {
                    const property = this.state.fazenda_client.find(p => p.id === rootFolders[j].id_property);
                    property.visible = checkFolderVisibility(rootFolders[j]).anyVisible;
                }
                this.setState({ fazenda_client: this.state.fazenda_client });

                const polysVisible = polygons.filter(p => p.id_property && p.visible);
                const polysTotal = polygons.filter(p => p.id_property);

                if (polysTotal.length > 0) {
                    if (polysTotal.length === polysVisible.length) {
                        this.setState({ visibleAll: 1 });
                    } else if (polysVisible.length > 0) {
                        this.setState({ visibleAll: 2 });
                    } else {
                        this.setState({ visibleAll: 0 });
                    }
                }
            } else {
                const polysVisible = polygons.filter(p => p.visible);
                const polysTotal = polygons;

                if (polysTotal.length > 0) {
                    if (polysTotal.length === polysVisible.length) {
                        this.setState({ visibleAll: 1 });
                    } else if (polysVisible.length > 0) {
                        this.setState({ visibleAll: 2 });
                    } else {
                        this.setState({ visibleAll: 0 });
                    }
                }
            }
        }
    };

    treeSearch = (folders, item) => {
        for (let i = 0; i < folders.length; i++) {
            if (folders[i].id === item.id_folder_area) {
                return folders[i];
            } else if (folders[i].children && folders[i].children.length > 0) {
                const found = this.treeSearch(folders[i].children, item);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    };

    putProperty = (item) => {
        console.log('putProperty', this.state.folders_properties);

        if (!item.id_folder_area) {
            this.state.folders_properties.push(item);
        } else {
            console.log('folder');
            const parent_item = this.treeSearch(this.state.folders_properties, item);
            if (parent_item) {
                console.log('children', parent_item);
                parent_item.children.push(item);
            }
        }
        return this.state.folders_properties;
    };
    putFolder = (item) => {
        if (!item.id_folder_area) {
            this.state.folders.push(item);
        } else {
            const parent_item = this.treeSearch(this.state.folders, item);
            if (parent_item) {
                parent_item.children.push(item);
            }
        }
        return this.state.folders;
    };

    createFolder = () => {
        let apiUrl = Config.server + '/folder_area';
        let id_property;

        const formData = new URLSearchParams();
        formData.append('name', this.state.name);
        formData.append('color', '#ffffff');

        if (this.state.tab === '1') {
            if (this.state.areaPup.id_client) {
                id_property = this.state.areaPup.id;
                formData.append('id_property', this.state.areaPup.id);
            } else {
                if (this.state.areaPup.id_folder_area) {
                    const parent_folder = this.treeSearch(this.state.folders_properties, this.state.areaPup);
                    id_property = parent_folder ? parent_folder.id_property : null;
                } else {
                    id_property = this.state.areaPup.id_property;
                }
                if (id_property) {
                    formData.append('id_property', id_property);
                } else {
                    notification.open({
                        message: this.props.res.ERRO,
                        description: this.props.res.ERRO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                    return;
                }
                formData.append('id_folder_area', this.state.areaPup.id);
            }
        } else {
            if (this.state.areaPup) {
                formData.append('id_folder_area', this.state.areaPup.id);
            }
        }
        let options = {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }
        fetch(apiUrl, options)
            .then((resData) => {
                if (resData.status !== 200) throw resData;
                else return resData.json();
            })
            .then(
                (result) => {
                    const newFolder = {
                        id: result,
                        guid: tools.newGuid(),
                        name: this.state.name,
                        children: [],
                        active: false,
                        visible: false
                    };
                    if (this.state.tab === '1') {
                        newFolder.id_property = id_property;
                        if (this.state.areaPup.id_client) {
                            this.state.folders_properties.push(newFolder);
                        } else {
                            newFolder.id_folder_area = this.state.areaPup ? this.state.areaPup.id : null;
                            this.state.areaPup.active = true;
                            this.state.areaPup.children.push(newFolder);
                        }

                        this.setState({
                            folders_properties: this.state.folders_properties,
                            fazenda_client: this.state.fazenda_client
                        }, () => {
                            this.openListItem(id_property, newFolder.id_folder_area);
                        });
                    } else {
                        newFolder.id_folder_area = this.state.areaPup ? this.state.areaPup.id : null;

                        if (this.state.areaPup) {
                            this.state.areaPup.active = true;
                        }

                        this.setState({ folders: this.putFolder(newFolder) }, () => {
                            this.openListItem(null, newFolder.id_folder_area);
                        });
                    }
                    this.setState({ anchorEl: null, areaPup: null, type_menu: '', showForm: false, name: '' });
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    } else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    updateFolder = () => {
        const isPropertyRename = this.type_name === 'rename' && this.state.type_menu === 'property';
        let apiUrl = Config.server + (isPropertyRename ? '/property/' : '/folder_area/') + this.state.areaPup.id;
        let id_folder_area;

        const formData = new URLSearchParams();
        formData.append('id', this.state.areaPup.id);
        if (this.type_name === 'rename') {
            formData.append('name', this.state.name);
            if (isPropertyRename) {
                ['id_client', 'cep', 'logradouro', 'numero', 'bairro', 'localidade', 'uf', 'designativo', 'obs', 'phoneNumbers'].forEach(field => {
                    formData.append(field, this.state.areaPup[field] || '');
                });
            } else {
                formData.append('id_folder_area', this.state.areaPup.id_folder_area);
                if (this.state.areaPup.id_property) {
                    formData.append('id_property', this.state.areaPup.id_property);
                }
            }
        } else {
            const id_property = this.state.id_clientPup > 0 ? this.state.id_propertyPup : null;
            id_folder_area = this.state.id_folderPup > 0 ? this.state.id_folderPup : null;

            const check_move = (list) => {
                if (!list || list.length === 0) return false;
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === this.state.areaPup.id) {
                        return true;
                    } else if (list[i].children && list[i].children.length > 0) {
                        if (check_move(list[i].children)) {
                            return true;
                        }
                    }
                }
                return false;
            };

            if (!check_move(this.state.areaPup.children) && !id_folder_area && !id_property) {
                return;
            } else {
                formData.append('name', this.state.areaPup.name);
                formData.append('id_folder_area', id_folder_area);
                if (this.state.areaPup.id_property) {
                    this.state.areaPup.id_property = id_property;
                    formData.append('id_property', id_property);
                }
            }
        }
        formData.append('color', this.state.areaPup.color || '');
        let options = {
            method: 'PUT',
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }
        fetch(apiUrl, options)
            .then((resData) => {
                if (resData.status !== 200) throw resData;
                else return resData.json();
            })
            .then(
                (result) => {
                    if (result && result.error) {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res[result.message] || this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                        return;
                    }
                    if (this.type_name === 'rename') {
                        this.state.areaPup.name = this.state.name;
                    } else {
                        if (this.state.areaPup.id_folder_area) {//remove from old parent
                            const item = this.treeSearch(this.state.folders_properties, this.state.areaPup);
                            if (item) {
                                item.children = item.children.filter(child => child.id !== this.state.areaPup.id);
                            }
                        }
                        this.state.areaPup.id_folder_area = id_folder_area;
                        if (id_folder_area) {//add to new parent
                            const item = this.treeSearch(this.state.folders_properties, this.state.areaPup);
                            if (item) {
                                item.active = true;
                                item.children.push(this.state.areaPup);
                            }
                        }
                    }

                    if (this.state.tab === '1') {
                        this.setState({
                            folders_properties: this.state.folders_properties.slice(),
                            fazenda_client: this.state.fazenda_client.slice()
                        }, () => {
                            if (this.type_name !== 'rename') {
                                this.openListItem(this.state.areaPup.id_property, id_folder_area);
                            }
                        });
                    }

                    this.setState({
                        anchorEl: null,
                        areaPup: null,
                        type_menu: '',
                        showForm: false,
                        name: ''
                    });

                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    } else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    deleteFolder = (ids, callback) => {
        let apiUrl = Config.server + '/folder_area';
        const formData = new URLSearchParams();
        formData.append('ids', ids.join(','));
        let options = {
            method: 'DELETE',
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }
        fetch(apiUrl, options)
            .then((resData) => {
                if (resData.status !== 200) throw resData;
                else return resData.json();
            })
            .then((result) => {
                this.setState({ anchorEl: null, areaPup: null, type_menu: '' });
                callback();
            }, (error) => {
                if (error.status === 405) {
                    notification.open({
                        message: this.props.res.PERMISSAO,
                        description: this.props.res.PERMISSAO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                } else if (error.status === 401 || error.status === 403) {
                    this.props.link('/login');
                } else {
                    console.log(error);
                    notification.open({
                        message: this.props.res.ERRO,
                        description: this.props.res.ERRO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                }
            });
    };

    deleteItens = () => {
        const areaPup = this.state.areaPup;
        if (!areaPup || !areaPup.id) {
            this.setState({ showForm: false, sel_poly: [] });
            return;
        }

        let poly_ids = [];
        //get folders ids by lvl
        poly_ids = poly_ids.concat(
            this.state.tab === '0'
                ? this.state.polygons
                    .filter(p => p.id_folder_area === areaPup.id)
                    .map(p => p.id)
                : this.state.areas_client
                    .filter(p => p.id_folder_area === areaPup.id)
                    .map(p => p.id)
        );

        const lvls = [[areaPup.id]];
        const getFolderIds = (folder, lvl) => {
            if (!folder || !Array.isArray(folder.children) || folder.children.length === 0) {
                return;
            }

            if (!lvls[lvl + 1]) {
                lvls[lvl + 1] = [];
            }
            for (let i = 0; i < folder.children.length; i++) {
                const child = folder.children[i];

                if (!child) continue;

                lvls[lvl + 1].push(child.id);

                poly_ids = poly_ids.concat(
                    this.state.tab === '0'
                        ? this.state.polygons
                            .filter(p => p.id_folder_area === child.id)
                            .map(p => p.id)
                        : this.state.areas_client
                            .filter(p => p.id_folder_area === child.id)
                            .map(p => p.id)
                );
                getFolderIds(child, lvl + 1);
            }
        };
        getFolderIds(areaPup, 0);

        const runDelete = (lvl) => {
            if (lvl < 0 || !lvls[lvl] || lvls[lvl].length === 0) {
                if (this.state.tab === '0') {
                    this.removeFolderById(this.state.folders, areaPup.id);
                } else {
                    this.removeFolderById(this.state.folders_properties, areaPup.id);
                }

                this.setState({
                    folders_properties: this.state.folders_properties,
                    folders: this.state.folders,
                    showForm: false,
                    sel_poly: []
                });

                return;
            }

            this.deleteFolder(lvls[lvl], () => {
                runDelete(lvl - 1);
            });
        };

        if (poly_ids.length > 0) {
            //delete polygons by ids
            const polys_to_delete = this.state.tab === '0'
                ? this.state.polygons.filter(p => poly_ids.includes(p.id))
                : this.state.areas_client.filter(p => poly_ids.includes(p.id));

            const ids = polys_to_delete.map(area => area.id);
            this.deleteArea(ids, () => {
                for (let i = 0; i < poly_ids.length; i++) {
                    const element = poly_ids[i];
                    if (this.mymap && this.mymap._layers && this.mymap._layers[element]) {
                        this.removeLayer(this.featureGroupP, this.mymap._layers[element]);
                    }
                }

                runDelete(lvls.length - 1);
            });
        } else {
            runDelete(lvls.length - 1);
        }
    };

    deletePropertyItens = () => {
        const property = this.state.areaPup;

        if (!property || !property.id) {
            this.setState({ showForm: false, sel_poly: [] });
            return;
        }

        const propertyId = property.id;
        let folderIds = [];
        let areaIds = [];

        const collectFolderIds = (folder) => {
            if (!folder) return;

            folderIds.push(folder.id);

            if (Array.isArray(folder.children) && folder.children.length > 0) {
                for (let i = 0; i < folder.children.length; i++) {
                    collectFolderIds(folder.children[i]);
                }
            }
        };

        const rootFolders = (this.state.folders_properties || []).filter(folder => Number(folder.id_property) === Number(propertyId));

        for (let i = 0; i < rootFolders.length; i++) {
            collectFolderIds(rootFolders[i]);
        }

        const directAreas = (this.state.areas_client || [])
            .filter(area => Number(area.id_property) === Number(propertyId) && !area.id_folder_area)
            .map(area => area.id);

        const folderAreas = (this.state.areas_client || [])
            .filter(area => area.id_folder_area && folderIds.includes(area.id_folder_area))
            .map(area => area.id);

        areaIds = directAreas.concat(folderAreas);

        const apiUrl = Config.server + '/property/full';
        const formData = new URLSearchParams();
        formData.append('id', propertyId);

        fetch(apiUrl, {
            method: 'DELETE',
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        })
            .then((res) => {
                if (res.status !== 200) throw res;
                return res.json();
            })
            .then(() => {
                if (this.mymap && this.mymap._layers) {
                    for (let i = 0; i < areaIds.length; i++) {
                        const element = areaIds[i];
                        if (this.mymap._layers[element]) {
                            this.removeLayer(this.featureGroupP, this.mymap._layers[element]);
                        }
                    }
                }

                const removeFoldersRecursively = (folders, idsToRemove) => {
                    if (!Array.isArray(folders)) return [];

                    const newFolders = [];

                    for (let i = 0; i < folders.length; i++) {
                        const folder = folders[i];
                        if (!folder) continue;
                        if (idsToRemove.includes(folder.id)) continue;

                        newFolders.push({
                            ...folder,
                            children: removeFoldersRecursively(folder.children, idsToRemove)
                        });
                    }

                    return newFolders;
                };

                const newAreasClient = (this.state.areas_client || []).filter(area => {
                    if (Number(area.id_property) === Number(propertyId)) return false;
                    if (area.id_folder_area && folderIds.includes(area.id_folder_area)) return false;
                    return true;
                });

                const newFoldersProperties = removeFoldersRecursively(this.state.folders_properties || [], folderIds);
                const newFazendaClient = (this.state.fazenda_client || []).filter(item => Number(item.id) !== Number(propertyId));

                this.setState({
                    areas_client: newAreasClient,
                    folders_properties: newFoldersProperties,
                    fazenda_client: newFazendaClient,
                    showForm: false,
                    sel_poly: []
                });
            })
            .catch((error) => {
                if (error.status === 405) {
                    notification.open({
                        message: this.props.res.PERMISSAO,
                        description: this.props.res.PERMISSAO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                } else if (error.status === 401 || error.status === 403) {
                    console.log(error);
                    this.props.link('/login');
                } else {
                    console.log(error);
                    notification.open({
                        message: this.props.res.ERRO,
                        description: this.props.res.ERRO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                }
            });
    };

    buildWaypointIcon = () => {
        if (this.waypointIcon) return this.waypointIcon;

        this.waypointIcon = L.icon({
            iconUrl: pinWaypoint,
            iconSize: [30, 30],
            iconAnchor: [15, 30],
            popupAnchor: [0, -28]
        });

        return this.waypointIcon;
    };

    formatWaypointPopup = (latlng) => {
        const latValue = latlng && latlng.lat != null
            ? latlng.lat
            : (this.state && this.state.lat && this.state.lat.value != null ? this.state.lat.value : null);

        const lngValue = latlng && latlng.lng != null
            ? latlng.lng
            : (this.state && this.state.lng && this.state.lng.value != null ? this.state.lng.value : null);

        const latText = this.formatCoordText(latValue, 'latitude');
        const lngText = this.formatCoordText(lngValue, 'longitude');

        return `
        <div style="font-size: 12px; line-height: 1.35;">
            <div><b>${this.props.res.LAT}:</b> ${latText}</div>
            <div><b>${this.props.res.LNG}:</b> ${lngText}</div>
        </div>
    `;
    };

    openWaypointPopup = () => {
        if (this.waypointMarker) {
            this.waypointMarker.openPopup();
        }
    };

    closeWaypointPopup = () => {
        if (this.waypointMarker) {
            this.waypointMarker.closePopup();
        }
    };

    createWaypointMarker = (latlng) => {
        const icon = this.buildWaypointIcon();

        const marker = L.marker(latlng, {
            icon: icon,
            keyboard: false
        });

        marker.bindPopup(this.formatWaypointPopup(latlng), { closeButton: true, autoClose: false, closeOnClick: false });

        marker.on('click', (ev) => {
            if (ev && ev.originalEvent) {
                L.DomEvent.stopPropagation(ev.originalEvent);
            }
            this.openWaypointPopup();
        });

        marker.addTo(this.mymap);

        this.waypointMarker = marker;
        this.openWaypointPopup();
    };

    moveWaypointMarker = (latlng) => {
        if (!this.waypointMarker) {
            this.createWaypointMarker(latlng);
            return;
        }

        this.waypointMarker.setLatLng(latlng);
        this.waypointMarker.setPopupContent(this.formatWaypointPopup(latlng));
        this.openWaypointPopup();
    };

    formatCoordText = (value, type) => {
        const mode = (this.state && this.state.coordMode) ? this.state.coordMode : 'dms';

        if (value == null || value === '' || !isFinite(Number(value))) return '';

        if (mode === 'dd') {
            return Number(value).toFixed(6);
        }

        return geo.toDMS(Number(value), type, 4, this.props.res);
    };

    applyCoordModeToState = () => {
        const center = this.mymap ? this.mymap.getCenter() : null;
        const latValue = center && center.lat != null
            ? center.lat
            : (this.state && this.state.lat && this.state.lat.value != null ? this.state.lat.value : null);
        const lngValue = center && center.lng != null
            ? center.lng
            : (this.state && this.state.lng && this.state.lng.value != null ? this.state.lng.value : null);

        const lat = {
            error: false,
            input: this.formatCoordText(latValue, 'latitude'),
            value: latValue
        };

        const lng = {
            error: false,
            input: this.formatCoordText(lngValue, 'longitude'),
            value: lngValue
        };

        this.setState({ lat: lat, lng: lng });
        this.updateMapCenterCoordinateDisplay(latValue, lngValue);

        if (this.waypointMarker) {
            const ll = this.waypointMarker.getLatLng();
            this.waypointMarker.setPopupContent(this.formatWaypointPopup(ll));
            if (this.waypointMarker.isPopupOpen()) this.waypointMarker.openPopup();
        }
    };

    toggleCoordMode = () => {
        const mode = (this.state && this.state.coordMode) ? this.state.coordMode : 'dms';
        const nextMode = (mode === 'dms') ? 'dd' : 'dms';

        this.setState({ coordMode: nextMode }, () => {
            this.applyCoordModeToState();
        });
    };

    gotoWaypoint = () => {
        if (!this.mymap) return;
        if (!this.waypointMarker) return;

        const ll = this.waypointMarker.getLatLng();
        if (!ll || ll.lat == null || ll.lng == null) return;

        const target = [ll.lat, ll.lng];
        const zoom = this.mymap.getZoom();

        const applyOffsetAndOpen = () => {
            if (!this.mymap) return;

            this.mymap.off('moveend', applyOffsetAndOpen);

            this.mymap.panBy([-180, 80], { animate: true });

            if (this.waypointMarker && this.waypointMarker.openPopup) {
                this.waypointMarker.openPopup();
            }
        };

        this.mymap.on('moveend', applyOffsetAndOpen);

        this.mymap.setView(target, zoom, { animate: true });

        setTimeout(() => {
            if (this.mymap) {
                applyOffsetAndOpen();
            }
        }, 350);
    };

    startDragPolling = () => {
        if (this.editDragInterval) return;

        this.editDragInterval = setInterval(() => {
            if (!this.editLive.active) return;
            if (!this.editLive.dragging) return;
            this.updateLiveAreaLabel();
        }, 50);
    };

    stopDragPolling = () => {
        if (this.editDragInterval) {
            clearInterval(this.editDragInterval);
            this.editDragInterval = null;
        }
    };

    getEditMarkersFromLayer = (layer) => {
        if (!layer || !layer.editing) return [];

        if (Array.isArray(layer.editing._markers) && layer.editing._markers.length) {
            return layer.editing._markers;
        }

        const group = layer.editing._markerGroup;
        if (group && group.eachLayer) {
            const arr = [];
            group.eachLayer((mk) => arr.push(mk));
            return arr;
        }

        return [];
    };

    getPolygonAreaM2FromEditMarkers = (layer) => {
        if (!layer || !layer.editing) return 0;

        const markers = this.getEditMarkersFromLayer(layer);
        if (!markers || !markers.length) return 0;

        const latlngs = [];
        for (let i = 0; i < markers.length; i++) {
            if (markers[i] && markers[i].getLatLng) latlngs.push(markers[i].getLatLng());
        }

        if (!latlngs.length) return 0;
        return L.GeometryUtil.geodesicArea(latlngs);
    };

    getLayerAreaM2ByGuid = (guid) => {
        if (!guid) return 0;

        let layer = null;

        if (this.featureGroupP && this.featureGroupP.getLayer) {
            layer = this.featureGroupP.getLayer(guid);
        }
        if (!layer && this.mymap && this.mymap._layers) {
            layer = this.mymap._layers[guid];
        }
        if (!layer) return 0;

        if (layer.getRadius && typeof layer.getRadius === 'function') {
            const r = layer.getRadius();
            return Math.PI * r * r;
        }

        if (layer.getLatLngs && layer.getLatLngs()[0]) {
            if (this.editLive.active && this.editLive.dragging && layer.editing) {
                const areaLive = this.getPolygonAreaM2FromEditMarkers(layer);
                if (areaLive > 0) return areaLive;
            }
            return L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]);
        }

        return 0;
    };

    getSelectedTotalAreaM2 = (guids) => {
        if (!Array.isArray(guids) || guids.length === 0) return 0;

        let total = 0;
        for (let i = 0; i < guids.length; i++) {
            total += this.getLayerAreaM2ByGuid(guids[i]);
        }
        return total;
    };

    formatAreaLabelFromM2 = (areaM2) => {
        if (!areaM2 || areaM2 <= 0) return '';
        const unit = Units.getAreaUnit(this.props.res);
        const value = Units.formatValue(Units.convertArea(areaM2, 'm2', this.props.res), this.props.res, 1);
        return value + ' ' + unit;
    };

    updateLiveAreaLabel = () => {
        if (!this.editLive.active) return;

        if (this.editRaf) cancelAnimationFrame(this.editRaf);

        this.editRaf = requestAnimationFrame(() => {
            const totalM2 = this.getSelectedTotalAreaM2(this.editLive.guids);
            this.setState({ label_text: this.formatAreaLabelFromM2(totalM2) });
        });
    };

    onLayerEditLive = () => {
        this.updateLiveAreaLabel();
    };

    bindEditMarkersForGuid = (guid) => {
        if (!this.editLive.active) return;

        const layer = this.mymap && this.mymap._layers ? this.mymap._layers[guid] : null;
        if (!layer || !layer.editing) return;

        const markers = this.getEditMarkersFromLayer(layer);
        if (!markers || !markers.length) return;

        if (!this.editLive.markerHandlers[guid]) this.editLive.markerHandlers[guid] = [];

        for (let i = 0; i < markers.length; i++) {
            const mk = markers[i];
            if (!mk || !mk.on) continue;

            const onDown = () => {
                if (!this.editLive.active) return;
                this.editLive.dragging = true;
                this.startDragPolling();
                this.updateLiveAreaLabel();
            };

            const onUp = () => {
                if (!this.editLive.active) return;
                this.editLive.dragging = false;
                this.stopDragPolling();
                this.updateLiveAreaLabel();
            };

            mk.on('mousedown', onDown);
            mk.on('touchstart', onDown);
            mk.on('dragstart', onDown);

            mk.on('mouseup', onUp);
            mk.on('touchend', onUp);
            mk.on('dragend', onUp);

            this.editLive.markerHandlers[guid].push({ mk, onDown, onUp });
        }
    };

    startLiveEdit = (guids) => {
        const list = Array.isArray(guids) ? guids.slice() : [];
        const originalTotalM2 = this.getSelectedTotalAreaM2(list);

        this.editLive = {
            active: true,
            guids: list,
            originalTotalM2,
            dragging: false,
            markerHandlers: {}
        };

        this.setState({ label_text: this.formatAreaLabelFromM2(originalTotalM2) });

        if (!this.editDocMouseUpHandler) {
            this.editDocMouseUpHandler = () => {
                if (!this.editLive.active) return;
                if (!this.editLive.dragging) return;
                this.editLive.dragging = false;
                this.stopDragPolling();
                this.updateLiveAreaLabel();
            };
            document.addEventListener('mouseup', this.editDocMouseUpHandler, true);
        }

        if (!this.editDocTouchEndHandler) {
            this.editDocTouchEndHandler = () => {
                if (!this.editLive.active) return;
                if (!this.editLive.dragging) return;
                this.editLive.dragging = false;
                this.stopDragPolling();
                this.updateLiveAreaLabel();
            };
            document.addEventListener('touchend', this.editDocTouchEndHandler, true);
            document.addEventListener('touchcancel', this.editDocTouchEndHandler, true);
        }

        if (!this.editDocPointerDownHandler) {
            this.editDocPointerDownHandler = (e) => {
                if (!this.editLive.active) return;
                const target = e && e.target ? e.target : null;
                if (!target) return;

                const el = target.closest ? target.closest('.leaflet-marker-icon') : null;
                if (!el) return;

                this.editLive.dragging = true;
                this.startDragPolling();
                this.updateLiveAreaLabel();
            };
            document.addEventListener('pointerdown', this.editDocPointerDownHandler, true);
        }

        if (!this.editDocPointerUpHandler) {
            this.editDocPointerUpHandler = () => {
                if (!this.editLive.active) return;
                if (!this.editLive.dragging) return;
                this.editLive.dragging = false;
                this.stopDragPolling();
                this.updateLiveAreaLabel();
            };
            document.addEventListener('pointerup', this.editDocPointerUpHandler, true);
            document.addEventListener('pointercancel', this.editDocPointerUpHandler, true);
        }

        for (let i = 0; i < list.length; i++) {
            const guid = list[i];
            const layer = this.mymap && this.mymap._layers ? this.mymap._layers[guid] : null;
            if (!layer) continue;

            if (layer.on) layer.on('edit', this.onLayerEditLive);
        }

        setTimeout(() => {
            for (let i = 0; i < list.length; i++) this.bindEditMarkersForGuid(list[i]);
        }, 0);

        setTimeout(() => {
            for (let i = 0; i < list.length; i++) this.bindEditMarkersForGuid(list[i]);
        }, 60);

        setTimeout(() => {
            for (let i = 0; i < list.length; i++) this.bindEditMarkersForGuid(list[i]);
        }, 180);
    };

    stopLiveEdit = (restoreOriginal) => {
        const list = this.editLive.guids ? this.editLive.guids.slice() : [];

        this.editLive.dragging = false;
        this.stopDragPolling();

        for (let i = 0; i < list.length; i++) {
            const guid = list[i];
            const layer = this.mymap && this.mymap._layers ? this.mymap._layers[guid] : null;
            if (layer && layer.off) layer.off('edit', this.onLayerEditLive);

            const handlers = this.editLive.markerHandlers && this.editLive.markerHandlers[guid]
                ? this.editLive.markerHandlers[guid]
                : null;

            if (handlers && handlers.length) {
                for (let j = 0; j < handlers.length; j++) {
                    const it = handlers[j];
                    if (it && it.mk && it.mk.off) {
                        it.mk.off('mousedown', it.onDown);
                        it.mk.off('touchstart', it.onDown);
                        it.mk.off('dragstart', it.onDown);

                        it.mk.off('mouseup', it.onUp);
                        it.mk.off('touchend', it.onUp);
                        it.mk.off('dragend', it.onUp);
                    }
                }
            }
        }

        if (this.editRaf) {
            cancelAnimationFrame(this.editRaf);
            this.editRaf = null;
        }

        if (this.editDocMouseUpHandler) {
            document.removeEventListener('mouseup', this.editDocMouseUpHandler, true);
            this.editDocMouseUpHandler = null;
        }

        if (this.editDocTouchEndHandler) {
            document.removeEventListener('touchend', this.editDocTouchEndHandler, true);
            document.removeEventListener('touchcancel', this.editDocTouchEndHandler, true);
            this.editDocTouchEndHandler = null;
        }

        if (this.editDocPointerDownHandler) {
            document.removeEventListener('pointerdown', this.editDocPointerDownHandler, true);
            this.editDocPointerDownHandler = null;
        }

        if (this.editDocPointerUpHandler) {
            document.removeEventListener('pointerup', this.editDocPointerUpHandler, true);
            document.removeEventListener('pointercancel', this.editDocPointerUpHandler, true);
            this.editDocPointerUpHandler = null;
        }

        const label = restoreOriginal
            ? this.formatAreaLabelFromM2(this.editLive.originalTotalM2)
            : this.formatAreaLabelFromM2(this.getSelectedTotalAreaM2(list));

        this.editLive = { active: false, guids: [], originalTotalM2: 0, dragging: false, markerHandlers: {} };

        this.setState({ label_text: label });
    };

    getAreaColorsStorage = () => {
        let colors = localStorage.getItem('area-custom-colors');
        if (!colors) return {};

        try {
            return JSON.parse(colors);
        } catch (e) {
            return {};
        }
    };

    saveAreaColorsStorage = (colors) => {
        localStorage.setItem('area-custom-colors', JSON.stringify(colors));
    };

    applyColorToLayerPreview = (guid, color) => {
        if (!guid || !this.mymap || !this.mymap._layers) return;

        const layer = this.mymap._layers[guid];
        if (!layer || !layer.setStyle) return;

        const isSelected = this.state.sel_poly.includes(guid);

        layer.setStyle({
            color: isSelected ? this.color_selected : color,
            fillColor: isSelected ? this.color_selected : color,
            weight: 4,
            opacity: 0.5,
            fillOpacity: 0.2
        });
    };

    openColorPicker = (area) => {
        if (!area) return;

        const tabKey = this.tabID[Number(this.state.tab)];
        const list = this.state[tabKey] || [];

        let colorTargetType = 'area';
        let colorTargetGuids = [];

        if (this.state.type_menu === 'property') {
            colorTargetType = 'property';

            const propertyId = Number(area.id);

            colorTargetGuids = list
                .filter(item => Number(item.id_property) === propertyId)
                .map(item => item.guid);
        } else if (this.state.type_menu === 'folder') {
            colorTargetType = 'folder';

            const folderIds = [Number(area.id)];
            const foldersTree = this.state.tab === '0' ? this.state.folders : this.state.folders_properties;

            const collectChildFolders = (parentId) => {
                for (let i = 0; i < foldersTree.length; i++) {
                    const folder = foldersTree[i];
                    if (!folder) continue;

                    if (Number(folder.id_folder_area) === Number(parentId)) {
                        folderIds.push(Number(folder.id));
                        collectChildFolders(folder.id);
                    }
                }
            };

            collectChildFolders(area.id);

            colorTargetGuids = list
                .filter(item => item.id_folder_area && folderIds.includes(Number(item.id_folder_area)))
                .map(item => item.guid);
        } else {
            if (!area.guid) return;

            colorTargetType = 'area';
            colorTargetGuids = [area.guid];
        }

        if (!colorTargetGuids || colorTargetGuids.length === 0) return;

        const colorPreviousColors = {};
        for (let i = 0; i < colorTargetGuids.length; i++) {
            const guid = colorTargetGuids[i];
            const item = list.find(poly => poly.guid === guid);
            colorPreviousColors[guid] = this.getPolygonColor(item);
        }

        const firstGuid = colorTargetGuids[0];
        const firstItem = list.find(poly => poly.guid === firstGuid);
        const currentColor = this.getPolygonColor(firstItem);

        this.setState({
            anchorEl: null,
            showColorPicker: true,
            colorEditingGuid: colorTargetType === 'area' ? firstGuid : '',
            colorDraft: currentColor,
            colorTargetType: colorTargetType,
            colorTargetGuids: colorTargetGuids,
            colorPreviousColors: colorPreviousColors
        });
    };

    changeColorDraft = (color) => {
        this.setState({ colorDraft: color }, () => {
            const targetGuids = this.state.colorTargetGuids || [];

            for (let i = 0; i < targetGuids.length; i++) {
                this.applyColorToLayerPreview(targetGuids[i], color);
            }
        });
    };

    saveAreaColor = () => {
        const color = this.state.colorDraft;
        const targetGuids = this.state.colorTargetGuids || [];

        if (!targetGuids.length) {
            this.setState({
                showColorPicker: false,
                colorEditingGuid: '',
                colorDraft: '',
                colorTargetType: 'area',
                colorTargetGuids: [],
                colorPreviousColors: {}
            });
            return;
        }

        const tabKey = this.tabID[Number(this.state.tab)];
        const list = this.state[tabKey].slice();

        for (let i = 0; i < list.length; i++) {
            if (targetGuids.includes(list[i].guid)) {
                list[i].custom_color = color;
            }
        }

        this.setState({
            [tabKey]: list,
            showColorPicker: false,
            colorEditingGuid: '',
            colorDraft: '',
            colorTargetType: 'area',
            colorTargetGuids: [],
            colorPreviousColors: {}
        }, () => {
            for (let i = 0; i < list.length; i++) {
                if (targetGuids.includes(list[i].guid)) {
                    this.updateArea(list[i], false);
                }
            }

            this.recalculateOverlaps();
            this.syncPolygonClusters();
        });
    };

    cancelAreaColor = () => {
        const previousColors = this.state.colorPreviousColors || {};
        const guids = Object.keys(previousColors);

        for (let i = 0; i < guids.length; i++) {
            this.applyColorToLayerPreview(guids[i], previousColors[guids[i]]);
        }

        this.setState({
            showColorPicker: false,
            colorEditingGuid: '',
            colorDraft: '',
            colorTargetType: 'area',
            colorTargetGuids: [],
            colorPreviousColors: {}
        }, () => {
            this.recalculateOverlaps();
            this.syncPolygonClusters();
        });
    };

    mountColorPickerDialog = () => {
        const { res } = this.props;
        return (
            <Dialog
                open={this.state.showColorPicker}
                onClose={this.cancelAreaColor}
                maxWidth="xs"
            >
                <div className="divContent" style={{ width: '22rem', padding: '0' }}>

                    <div className="modalHeader">
                        <div className="leftDivHeader"></div>

                        <div className="centerDivHeader">
                            <h3 style={{ color: 'white', margin: '0', whiteSpace: 'nowrap' }}>
                                {res.ALTERAR_COR}
                            </h3>
                        </div>

                        <div className="rightDivHeader">
                            <Button
                                size="small"
                                className="popUpButton"
                                onClick={this.cancelAreaColor}
                            >
                                <MaterialIcon icon="close" style={{ color: 'white' }} />
                            </Button>
                        </div>
                    </div>

                    <div style={{ padding: '1rem' }}>

                        <div style={{ marginBottom: '0.35rem' }}>
                            {this.state.colorTargetType === 'property'
                                ? res.ALTERAR_COR_PROPRIEDADE
                                : this.state.colorTargetType === 'folder'
                                    ? res.ALTERAR_COR_PASTA
                                    : res.ALTERAR_COR_AREA}
                        </div>

                        <div style={{ marginBottom: '0.75rem', fontSize: '0.95rem', fontWeight: 700 }}>
                            {this.state.areaPup ? this.state.areaPup.name : ''}
                        </div>

                        <div style={{ fontSize: '0.95rem' }}>
                            {res.SELECIONAR_COR}
                        </div>

                        <div style={{ marginBottom: '1rem' }}>
                            <input
                                type="color"
                                value={this.state.colorDraft || this.color_default}
                                onChange={(e) => this.changeColorDraft(e.target.value)}
                                style={{
                                    width: '100%',
                                    height: '3rem',
                                    border: 'none',
                                    cursor: 'pointer',
                                    background: 'transparent'
                                }}
                            />
                        </div>

                    </div>

                    <div
                        className="divForm"
                        style={{
                            padding: '0.5rem 1rem 1rem 1rem',
                            display: 'flex',
                            justifyContent: 'flex-end'
                        }}
                    >
                        <Button
                            size="small"
                            className="popUpButton"
                            onClick={this.cancelAreaColor}
                        >
                            {res.CANCELAR}
                        </Button>

                        <Button
                            size="small"
                            className="popUpButton"
                            onClick={this.saveAreaColor}
                            style={{ marginLeft: '0.5rem' }}
                        >
                            {res.SALVAR}
                        </Button>
                    </div>

                </div>
            </Dialog>
        );
    };

    updateMapCenterCoordinateDisplay = (lat, lng) => {
        if (this.mapCenterLatNode) {
            this.mapCenterLatNode.textContent = this.formatCoordText(lat, 'latitude');
        }
        if (this.mapCenterLngNode) {
            this.mapCenterLngNode.textContent = this.formatCoordText(lng, 'longitude');
        }
    };

    syncMapCenterCoordinates = () => {
        if (!this.mymap) return;

        let center = this.mymap.getCenter();
        if (!center) return;

        let centerLat = center.lat;
        let centerLng = center.lng;

        this.updateMapCenterCoordinateDisplay(centerLat, centerLng);

        // Atualizar o estado inteiro faz o painel de áreas renderizar de novo a
        // cada movimento do mapa. As entradas precisam do estado somente quando
        // o diálogo "Ir para" está aberto.
        if (this.state.goto) {
            this.setState({
                lat: {
                    error: false,
                    input: this.formatCoordText(centerLat, 'latitude'),
                    value: centerLat
                },
                lng: {
                    error: false,
                    input: this.formatCoordText(centerLng, 'longitude'),
                    value: centerLng
                }
            });
        }
        window.history.replaceState(null, "Travicar", "/app/draw/" + this.round_coord(centerLat) + ',' + this.round_coord(centerLng));
    };

    getSelectablePolygons = () => {
        const tab = this.state.tab;
        const polygons = this.state[this.tabID[Number(tab)]];
        const filtro = (this.state.filtro || '').toUpperCase();
        const idClient = this.state.id_client;
        const cache = this.selectablePolygonsCache;
        if (cache && cache.polygons === polygons && cache.tab === tab && cache.filtro === filtro && cache.idClient === idClient) {
            return cache.items;
        }

        let items;
        if (tab === '0') {
            items = this.getPolygonFolderIndex().matchingPolygons;
        } else {
            items = polygons.filter(item => {
                if (this.state.tab === '1') {
                    if (!this.state.id_client || Number(this.state.id_client) === 0) {
                        return false;
                    }

                    if (Number(item.id_client) !== Number(this.state.id_client)) {
                        return false;
                    }
                }

                if (item.name) {
                    return this.getNormalizedPolygonName(item).includes(filtro);
                } else {
                    return filtro ? null : item;
                }
            });
        }

        this.selectablePolygonsCache = { polygons, tab, filtro, idClient, items };
        return items;
    };

    getNormalizedPolygonName = (polygon) => {
        if (!polygon || typeof polygon !== 'object') {
            return '';
        }
        const name = polygon && polygon.name ? String(polygon.name) : '';
        const cache = this.polygonNameCache.get(polygon);
        if (cache && cache.name === name) {
            return cache.normalized;
        }

        const normalized = name.toUpperCase();
        this.polygonNameCache.set(polygon, { name, normalized });
        return normalized;
    };

    getFilteredProperties = () => {
        const properties = this.state.fazenda_client;
        const filtro = (this.state.filtro || '').toUpperCase();
        const cache = this.filteredPropertiesCache;
        if (cache && cache.properties === properties && cache.filtro === filtro) {
            return cache.items;
        }

        const items = !filtro
            ? properties
            : properties.filter(item => item && item.name && String(item.name).toUpperCase().includes(filtro));
        this.filteredPropertiesCache = { properties, filtro, items };
        return items;
    };

    getPropertyPolygonIndex = () => {
        const tab = this.state.tab;
        const polygons = this.state[this.tabID[Number(tab)]];
        const filtro = (this.state.filtro || '').toUpperCase();
        const cache = this.propertyPolygonIndexCache;
        if (cache && cache.polygons === polygons && cache.tab === tab && cache.filtro === filtro) {
            return cache.index;
        }

        const index = {};
        for (let i = 0; i < polygons.length; i++) {
            const polygon = polygons[i];
            if (!polygon.id_property || polygon.id_folder_area) {
                continue;
            }

            if (filtro && !this.getNormalizedPolygonName(polygon).includes(filtro)) {
                continue;
            }

            if (!index[polygon.id_property]) {
                index[polygon.id_property] = [];
            }
            index[polygon.id_property].push(polygon);
        }

        this.propertyPolygonIndexCache = { polygons, tab, filtro, index };
        return index;
    };

    getFoldersPupFiltered = () => {
        if (this.state.id_clientPup === 0) {
            return [];
        }

        if (this.state.id_propertyPup === 0) {
            return this.state.foldersPup;
        }

        return this.state.foldersPup.filter(item => item.id_property === this.state.id_propertyPup);
    };

    getSelectedPolyMap = () => {
        const selected = {};
        for (let i = 0; i < this.state.sel_poly.length; i++) {
            selected[this.state.sel_poly[i]] = i + 1;
        }
        return selected;
    };

    getPolygonFolderIndex = () => {
        const polygons = this.state.tab === '0' ? this.state.polygons : this.state.areas_client;
        const tab = this.state.tab;
        const filtro = (this.state.filtro || '').toUpperCase();
        const cache = this.polygonFolderIndexCache;
        if (cache && cache.polygons === polygons && cache.tab === tab && cache.filtro === filtro) {
            return cache.value;
        }

        const folderIndex = {};
        const rootPolygons = [];
        const matchingPolygons = [];
        const hasFiltro = !!filtro;

        for (let i = 0; i < polygons.length; i++) {
            const polygon = polygons[i];
            const polygonName = this.getNormalizedPolygonName(polygon);

            if (hasFiltro && !polygonName.includes(filtro)) {
                continue;
            }

            matchingPolygons.push(polygon);

            if (polygon.id_folder_area) {
                if (!folderIndex[polygon.id_folder_area]) {
                    folderIndex[polygon.id_folder_area] = [];
                }
                folderIndex[polygon.id_folder_area].push(polygon);
            } else {
                rootPolygons.push(polygon);
            }
        }

        const value = {
            folderIndex,
            rootPolygons,
            matchingPolygons
        };
        this.polygonFolderIndexCache = { polygons, tab, filtro, value };
        return value;
    };

    getFilteredFolders = (folders) => {
        const filtro = (this.state.filtro || '').toUpperCase();

        if (!filtro) {
            return folders;
        }

        return folders.filter(item => (
            item && item.name && item.name.toUpperCase().includes(filtro)
        ));
    };

    setVisibilityButtonBusy = (button, busy) => {
        if (!button) return;

        if (busy) {
            button.style.pointerEvents = 'none';
            button.style.opacity = '0.6';
            button.style.cursor = 'wait';

            const icon = button.querySelector('.iconMap');
            if (icon) {
                icon.style.opacity = '0.45';
            }
        } else {
            button.style.pointerEvents = '';
            button.style.opacity = '';
            button.style.cursor = '';

            const icon = button.querySelector('.iconMap');
            if (icon) {
                icon.style.opacity = '';
            }
        }
    };

    handleVisibilityClickBusy = (event, item, type) => {
        const button = event.currentTarget;

        if (!button || button.dataset.visibilityBusy === '1') {
            return;
        }

        button.dataset.visibilityBusy = '1';
        this.setVisibilityButtonBusy(button, true);

        this.handleVisibilityClick(item, type);

        setTimeout(() => {
            button.dataset.visibilityBusy = '0';
            this.setVisibilityButtonBusy(button, false);
        }, 400);
    };

    activateImportedClientDestination = (destination, importedGuids) => {
        if (!destination || !destination.id_client) {
            return;
        }

        const id_client = Number(destination.id_client);
        const id_property = destination.id_property ? Number(destination.id_property) : 0;
        const id_folder_area = destination.id_folder_area ? Number(destination.id_folder_area) : 0;

        this.setState({
            tab: '1',
            id_client: id_client,
            loadingClientData: true,
            sel_poly: []
        }, () => {
            let pending = 3;
            const finishLoading = () => {
                pending--;
                if (pending > 0) {
                    return;
                }

                let areas_client = this.state.areas_client.slice();
                for (let i = 0; i < areas_client.length; i++) {
                    if (importedGuids.includes(areas_client[i].guid)) {
                        areas_client[i].visible = true;
                    }
                }

                this.setState({
                    areas_client: areas_client,
                    loadingClientData: false,
                    sel_poly: [],
                    sel_merge: false,
                    sel_x: false,
                    sel_t: false,
                    label_text: ''
                }, () => {
                    this.openListItem(id_property, id_folder_area);
                    this.resetPolygons(true);
                    this.checkVisibility();
                    for (let i = 0; i < importedGuids.length; i++) {
                        const importedItem = this.state.areas_client.find(item => item.guid === importedGuids[i]);
                        if (importedItem) {
                            this.setLayerColor(importedGuids[i], this.getItemBaseColor(importedItem));
                        }
                    }
                    this.syncPolygonClusters();
                });
            };

            this.loadProperty(id_client, (res) => {
                this.setState({ fazenda_client: res }, finishLoading);
            });

            this.loadAreas(id_client, () => {
                finishLoading();
            });

            this.loadPastas(id_client, 'folders_properties', () => {
                finishLoading();
            });
        });
    };

    openFolderPathById = (folders, folderId) => {
        if (!folderId || !Array.isArray(folders) || folders.length === 0) {
            return false;
        }

        for (let i = 0; i < folders.length; i++) {
            const folder = folders[i];
            if (!folder) continue;

            if (Number(folder.id) === Number(folderId)) {
                folder.active = true;
                return true;
            }

            if (folder.children && folder.children.length > 0) {
                const found = this.openFolderPathById(folder.children, folderId);
                if (found) {
                    folder.active = true;
                    return true;
                }
            }
        }

        return false;
    };

    openPropertyById = (properties, propertyId) => {
        if (!propertyId || !Array.isArray(properties) || properties.length === 0) {
            return;
        }

        for (let i = 0; i < properties.length; i++) {
            const property = properties[i];
            if (!property) continue;

            if (Number(property.id) === Number(propertyId)) {
                property.active = true;
                break;
            }
        }
    };

    openListItem = (id_property, id_folder_area) => {
        if (this.state.tab === '0') {
            if (id_folder_area) {
                this.openFolderPathById(this.state.folders, id_folder_area);
                this.setState({ folders: [...this.state.folders] });
            }
            return;
        }

        if (id_property) {
            this.openPropertyById(this.state.fazenda_client, id_property);
        }

        if (id_folder_area) {
            this.openFolderPathById(this.state.folders_properties, id_folder_area);
        }

        this.setState({
            fazenda_client: [...this.state.fazenda_client],
            folders_properties: [...this.state.folders_properties]
        });
    };

    render() {
        const { res, link } = this.props;
        const selectablePolygons = this.getSelectablePolygons();

        const polygonCache = this.getPolygonFolderIndex();
        const listCache = {
            folderIndex: polygonCache.folderIndex,
            rootPolygons: polygonCache.rootPolygons,
            selectedMap: this.getSelectedPolyMap()
        };

        const propertyFolderIndex = {};
        for (let i = 0; i < this.state.folders_properties.length; i++) {
            const folder = this.state.folders_properties[i];
            if (!propertyFolderIndex[folder.id_property]) {
                propertyFolderIndex[folder.id_property] = [];
            }
            propertyFolderIndex[folder.id_property].push(folder);
        }

        const propertyPolygonIndex = this.getPropertyPolygonIndex();

        const disabledButton = {
            color: 'lightgray'
        }

        return (
            <div className="rowMapCO maxVHMap">
                {this.state.downloading &&
                    <div role="status" aria-live="polite" style={{
                        position: 'fixed',
                        right: '1rem',
                        bottom: '1rem',
                        zIndex: 2000,
                        width: '24rem',
                        maxWidth: 'calc(100vw - 2rem)',
                        boxSizing: 'border-box',
                        pointerEvents: 'none'
                    }}>
                        <div style={{
                            padding: '1rem',
                            borderRadius: '.5rem',
                            backgroundColor: '#fff',
                            boxShadow: '0 4px 18px rgba(0, 0, 0, .2)'
                        }}>
                            <div style={{ marginBottom: '.75rem', textAlign: 'center', color: '#444' }}>
                                {this.state.downloadStatus}
                            </div>
                            <LinearProgress
                                variant={this.state.downloadProgress === null ? 'indeterminate' : 'determinate'}
                                value={this.state.downloadProgress === null ? 0 : this.state.downloadProgress}
                            />
                            {this.state.downloadProgress !== null &&
                                <div style={{ marginTop: '.5rem', textAlign: 'right', fontSize: '.8rem', color: '#666' }}>
                                    {this.state.downloadProgress}%
                                </div>
                            }
                        </div>
                    </div>
                }
                <div id="divPro" className="sr-only back-drop" style={{ opacity: .4, backgroundColor: '#fff', zIndex: 1002 }}>
                    <div className="in-back-drop">
                        <CircularProgress color="inherit" disableShrink />
                    </div>
                </div>
                <Dialog onClose={this.onCloseEditProperty} aria-labelledby="simple-dialog-title" open={this.state.showForm}>
                    {this.type_name === 'folder' || this.type_name === 'rename'
                        ? <div className="divContent" style={{ minWidth: '25rem' }}>
                            <div className="containerTop">
                                <div><h1>{this.type_name === 'rename' ? res.RENOMEAR : res.NOVA_PASTA}</h1></div>
                                <div className="centerTop"></div>
                                <div>
                                    <Button variant="contained" color="primary" className="popUpButton" onClick={this.type_name === 'rename' ? this.updateFolder : this.createFolder} disabled={(!this.state.name)}>
                                        <SaveIcon className="iconMapS" />
                                        {res.SALVAR}
                                    </Button>
                                </div>
                            </div>
                            <div className="form-group notTooBig">
                                <TextField
                                    id="name"
                                    label={res.NOME}
                                    value={this.state.name}
                                    onChange={this.handleChange('name')}
                                    margin="normal"
                                    fullWidth
                                    onInput={(e) => {
                                        e.target.value = e.target.value.toString().slice(0, 45)
                                    }}
                                />
                            </div>
                        </div>
                        : this.type_name === 'excluir'
                            ?
                            <>
                                <DialogTitle id="alert-dialog-title">
                                    {res.DESEJA_EXCLUIR_ITEM}
                                </DialogTitle>
                                <span style={{ width: '100%', textAlign: 'center' }}>{(() => {
                                    let msg = '';

                                    if (this.state.sel_poly.length > 0) {
                                        msg = `${res.AREAS}: ${this.state.sel_poly.length}`;
                                        return msg;
                                    }

                                    if (!this.state.areaPup) {
                                        return '';
                                    }

                                    const polygons = this.state.tab === '0' ? this.state.polygons : this.state.areas_client;
                                    const foldersProperties = this.state.folders_properties || [];

                                    let count_properties = 0;
                                    let count_folders = 0;
                                    let count_areas = 0;

                                    if (this.state.type_menu === 'property') {
                                        count_properties = 1;

                                        const propertyId = Number(this.state.areaPup.id);
                                        const folderIds = [];

                                        const collectFoldersByProperty = (parentId) => {
                                            for (let i = 0; i < foldersProperties.length; i++) {
                                                const folder = foldersProperties[i];
                                                if (!folder) continue;

                                                if (parentId === null) {
                                                    if (Number(folder.id_property) === propertyId) {
                                                        folderIds.push(folder.id);
                                                        collectFoldersByProperty(folder.id);
                                                    }
                                                } else {
                                                    if (Number(folder.id_folder_area) === Number(parentId)) {
                                                        folderIds.push(folder.id);
                                                        collectFoldersByProperty(folder.id);
                                                    }
                                                }
                                            }
                                        };

                                        collectFoldersByProperty(null);

                                        count_folders = folderIds.length;

                                        for (let j = 0; j < polygons.length; j++) {
                                            const polygon = polygons[j];
                                            if (!polygon) continue;

                                            if (Number(polygon.id_property) === propertyId) {
                                                count_areas += 1;
                                            }
                                        }

                                        msg = `${res.PROPRIEDADE}: ${count_properties}`;

                                        if (count_folders > 0) {
                                            msg = `${msg}, ${res.PASTAS}: ${count_folders}`;
                                        }

                                        if (count_areas > 0) {
                                            msg = `${msg}, ${res.AREAS}: ${count_areas}`;
                                        }

                                        return msg;
                                    }

                                    if (this.state.type_menu === 'folder') {
                                        const folderId = Number(this.state.areaPup.id);
                                        const folderIds = [folderId];

                                        const collectChildFolders = (parentId) => {
                                            for (let i = 0; i < foldersProperties.length; i++) {
                                                const folder = foldersProperties[i];
                                                if (!folder) continue;

                                                if (Number(folder.id_folder_area) === Number(parentId)) {
                                                    folderIds.push(folder.id);
                                                    collectChildFolders(folder.id);
                                                }
                                            }
                                        };

                                        collectChildFolders(folderId);

                                        count_folders = folderIds.length;

                                        for (let j = 0; j < polygons.length; j++) {
                                            const polygon = polygons[j];
                                            if (!polygon) continue;

                                            if (polygon.id_folder_area && folderIds.includes(Number(polygon.id_folder_area))) {
                                                count_areas += 1;
                                            }
                                        }

                                        msg = `${res.PASTAS}: ${count_folders}`;
                                        if (count_areas > 0) {
                                            msg = `${msg}, ${res.AREAS}: ${count_areas}`;
                                        }
                                        return msg;
                                    }
                                    return msg;
                                })()}</span>
                                <DialogActions>
                                    <Button onClick={() => this.state.type_menu === 'property' ? this.deletePropertyItens() : this.deleteItens()} color="primary">
                                        {res.SIM}
                                    </Button>
                                    <Button onClick={() => this.setState({ newFunc: false, showForm: false })} color="primary" autoFocus>
                                        {res.NAO}
                                    </Button>
                                </DialogActions>
                            </>
                            : <EditProperty link={link} res={res} modal={true} idClient={this.state.id_client} idProperty={this.state.id_property} onSave={this.saveProperty}></EditProperty>
                    }
                </Dialog>
                <ListFilter
                    res={res}
                    files={this.state.itensImport}
                    open={this.state.showImport}
                    index={1003}
                    clients={this.state.clients}
                    loadProperty={this.loadProperty}
                    listItens={this.importList}
                    onClose={() => { this.setState({ showImport: false }) }}
                />
                <div style={{ display: 'grid', gap: '.5rem', gridTemplateRows: '4rem auto' }}>
                    <div className='divContent  padding-title'>
                        <h1 className='title-align'>{res.AREAS}</h1>
                    </div>
                    <div id="divFloat" className="div-list_p divContentList" style={{ display: 'grid', gridTemplateRows: '4rem 4rem auto', height: '100%' }}>
                        <div style={{ padding: '.5rem', display: 'flex' }}>
                            <Tab value={this.state.tab} handleChange={this.handleChangeTab} name="tab" itens={this.tabItens} />
                        </div>
                        <div style={{ padding: '.5rem', display: 'flex', borderBottom: 'solid 1px #c9c9c9', margin: '.5rem' }}>
                            <div style={{ width: '78%', position: 'relative' }}>
                                <SearchIcon style={{ marginRight: '.5rem' }} />
                                <TextField
                                    placeholder={res.FILTRO}
                                    margin="normal"
                                    style={{ marginTop: '-0.3rem', width: '80%' }}
                                    defaultValue={this.state.filtro}
                                    inputRef={node => { this.filterInputNode = node; }}
                                    onChange={this.handleFilterChange}
                                    id="campoFiltro"
                                />
                                {(this.state.filtro !== '') &&
                                    <IconButton style={{ position: 'absolute', right: '1rem', top: '-1rem' }} onClick={() => this.clear()}>
                                        <MaterialIcon icon="clear" />
                                    </IconButton>
                                }
                            </div>
                            <div style={{ width: '10%', display: 'flex' }}>
                                <ListItem key={'a1'} button
                                    style={this.state.visibleAll === 2 ? { width: '3rem', height: '3rem', marginTop: '-.7rem', backgroundColor: '#f0f0f0' } : { width: '3rem', height: '3rem', marginTop: '-.7rem' }}
                                    onClick={event => this.handleVisibilityClickBusy(event, null, null)}
                                >
                                    {this.state.tab === '0' ?
                                        this.state.visibleAll === 1
                                            ? <MaterialIcon style={{ marginLeft: '-.2rem', opacity: '.8' }} icon="visibility" className="iconMap" />
                                            : <MaterialIcon style={{ marginLeft: '-.2rem' }} icon="visibility_off" className="iconMap" />
                                        : <MaterialIcon style={{ marginLeft: '-.2rem', opacity: '0' }} icon="visibility" className="iconMap" />
                                    }
                                </ListItem>
                                <div style={{ width: '30%', textAlign: 'right' }}>
                                    <Checkbox
                                        disableRipple
                                        className="checkMap"
                                        disabled={this.state.tab === '1' && (!this.state.id_client || Number(this.state.id_client) === 0)}
                                        indeterminate={
                                            this.state.sel_poly.length > 0 &&
                                            this.state.sel_poly.length < selectablePolygons.length
                                        }
                                        checked={
                                            selectablePolygons.length > 0 &&
                                            this.state.sel_poly.length === selectablePolygons.length
                                        }
                                        onChange={this.handleSelectAllClick}
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            className="area-list-scroll"
                            ref={this.setAreaListScrollNode}
                            onMouseEnter={this.handleAreaListPointerEnter}
                            onMouseMove={this.handleAreaListPointerMove}
                            onMouseLeave={this.handleAreaListPointerLeave}
                            style={{ position: 'relative', width: '100%', overflow: 'auto' }}
                        >
                            {this.state.loadingClientData &&
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: 'rgba(255,255,255,0.7)',
                                    zIndex: 20,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '.8rem'
                                    }}>
                                        <CircularProgress size={28} />
                                        <span style={{ fontSize: '.95rem', color: '#555' }}>
                                            {res.CARREGANDO}
                                        </span>
                                    </div>
                                </div>
                            }

                            {this.state.tab === '1' && <div style={{ width: '100%', padding: '1rem' }}>
                                <Select
                                    value={this.state.id_client}
                                    style={{ width: '100%' }}
                                    onChange={this.handleChangeClient('id_client', 'fazenda_client', true)}
                                    inputProps={{
                                        id: 'id_client',
                                    }}
                                >
                                    <MenuItem key={0} value={0}>{res.SELECIONE}</MenuItem>
                                    {this.state.clients.map((item, key) => {
                                        return <MenuItem key={key + '_client'} value={item.id}>{item.name}</MenuItem>;
                                    })}
                                </Select>
                            </div>}
                            <MenuList
                                anchorEl={this.state.anchorEl}
                                open={Boolean(this.state.anchorEl)}
                                onClose={(e) => { this.setState({ anchorEl: null }); }}
                            >
                                {(this.state.type_menu === 'move' || this.state.type_menu === 'copy')
                                    ? [
                                        <div key="move-area-title" style={{ width: '15rem', padding: '.5rem 1rem', fontSize: '1rem' }}>
                                            {this.state.sel_poly.length <= 1 ?
                                                <span>{this.limitChar(this.state.areaPup ? this.state.areaPup.name : '', 190)}</span>
                                                : <span>({this.state.sel_poly.length})  {res.SELECIONADOS}</span>
                                            }
                                        </div>,
                                        <div key="move-destination-title" style={{ width: '15rem', padding: '.5rem 1rem', fontSize: '1rem' }}>
                                            <b>{this.state.type_menu === 'copy' ? res.COPIAR_PARA : res.MOVER_PARA}</b>
                                        </div>,
                                        <div key="move-divider" className="divider"></div>,
                                        <div key="move-client-select" style={{ padding: '1rem' }}>
                                            <Select
                                                value={this.state.id_clientPup}
                                                style={{ width: '100%' }}
                                                onChange={this.handleChangeClient('id_clientPup', 'fazenda_clientPup', false)}
                                                inputProps={{
                                                    id: 'id_clientPup',
                                                }}
                                            >
                                                <MenuItem key={0} value={0}>{this.tabItens[0].label}</MenuItem>
                                                {this.state.clients.map((item, key) => {
                                                    return <MenuItem key={key + '_clientPup'} value={item.id}>{item.name}</MenuItem>;
                                                })}
                                            </Select>
                                        </div>,
                                        this.state.id_clientPup > 0 && (
                                            <div key="move-property-select" style={{ padding: '.5rem 1rem' }}>
                                                <Select
                                                    value={this.state.id_propertyPup}
                                                    style={{ width: '100%' }}
                                                    onChange={this.handleChangeClient('id_propertyPup', null, false)}
                                                    inputProps={{
                                                        id: 'id_propertyPup',
                                                    }}
                                                    disabled={this.state.fazenda_clientPup.length === 0}
                                                >
                                                    <MenuItem key={0} value={0}>{res.SELECIONE}</MenuItem>
                                                    {this.state.fazenda_clientPup.map((item, key) => {
                                                        return <MenuItem key={key + "_propertyPup"} value={item.id}>{item.name}</MenuItem>;
                                                    })}
                                                </Select>
                                            </div>
                                        ),
                                        <div key="move-folder-select" style={{ padding: '.5rem 1rem' }}>
                                            <Select
                                                value={this.state.id_folderPup}
                                                style={{ width: '100%' }}
                                                onChange={this.handleChangeClient('id_folderPup', null, false)}
                                                inputProps={{
                                                    id: 'id_folderPup',
                                                }}
                                                disabled={this.getFoldersPupFiltered().length === 0}
                                            >
                                                <MenuItem key={0} value={0}>{res.SELECIONE}</MenuItem>
                                                {this.getFoldersPupFiltered().map((item, key) => {
                                                    let tab = '';
                                                    if (item.lvl) {
                                                        for (let iLvl = 0; iLvl < item.lvl; iLvl++) {
                                                            tab += ' └ ';
                                                        }
                                                    }
                                                    return <MenuItem key={key + "_propertyPup"} value={item.id}>{tab}{item.name}</MenuItem>;
                                                })}
                                            </Select>
                                        </div>,
                                        <div key="move-submit" style={{ textAlign: 'right', padding: '.5rem 1rem' }}>
                                            <Button variant="contained" color="primary" className="popUpButton" onClick={this.state.type_menu === 'copy' ? this.copyToDestination : (this.state.sel_poly.length > 0 ? this.moveArea : this.updateFolder)} disabled={(this.state.tab === '0' && this.state.id_clientPup === -1) || (this.state.id_propertyPup === 0 && this.state.id_clientPup > 0)}>
                                                {this.state.type_menu === 'copy' ? res.COPIAR_PARA : res.MOVER_PARA}
                                            </Button>
                                        </div>,
                                    ]
                                    : [
                                        <div key="area-actions-title" style={{ width: '15rem', padding: '.5rem 1rem', fontSize: '1rem' }}>
                                            {this.state.sel_poly.length <= 1 ?
                                                <span>{this.limitChar(this.state.areaPup ? this.state.areaPup.name : '', 190)}</span>
                                                : <span>({this.state.sel_poly.length})  {res.SELECIONADOS}</span>
                                            }
                                        </div>,
                                        <div key="area-actions-divider" className="divider"></div>,
                                        <List
                                            key="area-actions-list"
                                            onKeyDown={this.keyDown}
                                            onKeyUp={this.keyUp}
                                            component="nav"
                                            aria-labelledby="areas"
                                        >
                                            <ListItem key="change-color" button onClick={event => this.openModal('color')} style={{ justifyContent: 'center' }}>
                                                <span>{res.ALTERAR_COR}</span>
                                            </ListItem>
                                            <ListItem key="new-folder" button onClick={event => this.openModal('folder')} style={{ justifyContent: 'center' }}
                                                disabled={this.state.sel_poly.length > 1 || this.state.type_menu === 'poly'}>
                                                <span>{res.NOVA_PASTA} </span>
                                            </ListItem>
                                            <ListItem key="move" button onClick={event => this.openModal('move')} style={{ justifyContent: 'center' }}>
                                                <span>{res.MOVER_PARA} </span>
                                            </ListItem>
                                            {this.state.type_menu !== 'property' &&
                                                <ListItem key="copy" button onClick={event => this.openModal('copy')} style={{ justifyContent: 'center' }}>
                                                    <span>{res.COPIAR_PARA}</span>
                                                </ListItem>
                                            }
                                            <ListItem key="rename" button onClick={event => this.openModal('rename')} style={{ justifyContent: 'center' }}>
                                                <span>{res.RENOMEAR} </span>
                                            </ListItem>
                                            <ListItem key="delete" button onClick={event => this.openModal('excluir')} style={{ justifyContent: 'center' }}>
                                                <span>{res.EXCLUIR} </span>
                                            </ListItem>
                                        </List>,
                                    ]
                                }
                            </MenuList>
                            {this.state.tab === '0'
                                ? <List
                                    onKeyDown={this.keyDown}
                                    onKeyUp={this.keyUp}
                                    component="nav"
                                    aria-labelledby="areas"
                                    style={{ position: 'absolute', width: '100%' }}
                                >
                                    {/*<ListItem key={-1} button
                                        style={{ justifyContent: 'right', borderRight: '6px solid #666', backgroundColor: '#f0f0f0', padding: '.5rem 0' }}
                                        onClick={event => this.openModal('folder')}
                                    >
                                        <span style={{ marginRight: '.5rem' }}>{res.NOVA_PASTA} </span>
                                        <AddIcon />
                                    </ListItem>*/}
                                    {this.mountList(
                                        this.state.folders,
                                        listCache.rootPolygons,
                                        0,
                                        true,
                                        listCache
                                    )}

                                    {this.renderSelectedRunwaysList()}
                                </List>
                                : <div>
                                    <ListItem key={-1} button
                                        disabled={this.state.new_error}
                                        style={{ justifyContent: 'right', borderRight: '6px solid #666', backgroundColor: '#f0f0f0', padding: '.5rem 0' }}
                                        onClick={event => this.openModal()}
                                    >
                                        <span style={{ marginRight: '.5rem' }}>{res.NOVA_PROPRIEDADE} </span>
                                        <AddIcon />
                                    </ListItem>
                                    <List
                                        onKeyDown={this.keyDown}
                                        onKeyUp={this.keyUp}
                                        component="nav"
                                        aria-labelledby="areas"
                                        style={{ position: 'absolute', width: '100%' }}
                                    >
                                        {this.getFilteredProperties()
                                            .map((item, index) => {
                                                return (<div key={index}>
                                                    <div
                                                        type='folder'
                                                        lvl={0}
                                                        idFolder={item.id}
                                                        key={index + "_divfo_" + item.id}
                                                        id={index + "_divfo_" + item.id}
                                                        style={{ display: 'flex', position: 'relative' }}
                                                    >
                                                        <div style={{ width: '.5rem', margin: '-1.1rem -12px 0 0', height: '2.6rem' }}></div>
                                                        <ListItem
                                                            key={index + 'pf1' + item.id}
                                                            button
                                                            className={(this.state.sel_poly.indexOf(item.guid) >= 0) ? 'SelItem' : ''}
                                                            onClick={event => this.handleFolderClick(index + "_divfo_" + item.id, item)}
                                                            title={item.name}
                                                        >
                                                            <ListItemIcon style={{ minWidth: '20px', marginLeft: '-.7rem' }}>
                                                                {!item.active
                                                                    ? <MaterialIcon icon="arrow_right" className="iconMap" />
                                                                    : <MaterialIcon icon="arrow_drop_down" className="iconMap" />
                                                                }
                                                            </ListItemIcon>
                                                            <ListItemText id={index} primary={this.limitChar(item.name, 300)} />
                                                        </ListItem>
                                                        <ListItem
                                                            key={index + 'pf3' + item.id}
                                                            button
                                                            style={(this.state.sel_poly.indexOf(item.guid) >= 0)
                                                                ? { width: '3rem', height: '3rem', backgroundColor: '#f0f0f0' }
                                                                : { width: '3rem', height: '3rem' }}
                                                            onClick={event => this.handleVisibilityClickBusy(event, item, 'property')}
                                                        >
                                                            {item.visible
                                                                ? <MaterialIcon style={{ marginLeft: '-.2rem', opacity: '.8' }} icon="visibility" className="iconMap" />
                                                                : <MaterialIcon style={{ marginLeft: '-.2rem' }} icon="visibility_off" className="iconMap" />
                                                            }
                                                        </ListItem>
                                                        <ListItem
                                                            key={index + 'pf2' + item.id}
                                                            button
                                                            style={(this.state.sel_poly.indexOf(item.guid) >= 0)
                                                                ? { width: '3rem', height: '3rem', backgroundColor: '#f0f0f0' }
                                                                : this.state.sel_poly.length > 0 && !this.state.sel_poly.includes(item.guid)
                                                                    ? { width: '3rem', height: '3rem', opacity: '.1' }
                                                                    : { width: '3rem', height: '3rem' }}
                                                            onClick={event => { this.setState({ anchorEl: event.currentTarget, areaPup: item, type_menu: 'property' }); }}
                                                        >
                                                            <h2>...</h2>
                                                        </ListItem>
                                                    </div>
                                                    {this.mountList(
                                                        propertyFolderIndex[item.id] || [],
                                                        propertyPolygonIndex[item.id] || [],
                                                        1,
                                                        item.active,
                                                        listCache
                                                    )}
                                                </div>)
                                            })}

                                        {this.renderSelectedRunwaysList()}
                                    </List>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="divContent divRelative map-p">
                    <div className="containerTop">
                        <div className="centerTop">
                            <div style={{ position: 'relative', textAlign: 'center', marginTop: '-1.5rem', minWidth: '20rem', marginRight: '-2rem' }}>
                                <TextField
                                    style={{ width: '80%' }}
                                    id="search_text"
                                    label={res.SEARCH_LOCATION}
                                    autoComplete="off"
                                    margin="normal"
                                    size='small'
                                    onChange={this.handleChange('search_text')}
                                    value={this.state.search_text}
                                />
                                {this.state.listSearch.length > 0 &&
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '4rem',
                                            left: 0,
                                            width: 'calc(100% - 1rem)',
                                            background: '#fff',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                            zIndex: 2000,
                                            borderRadius: '4px',
                                            maxHeight: '250px',
                                            overflowY: 'auto'
                                        }}
                                    >
                                        {this.state.listSearch.map((item, index) => (
                                            <MenuItem key={index + 'search'} className="popup-item" onClick={() => this.goto('search', item.location.latitude, item.location.longitude)}>
                                                <div style={{ paddingRight: '.7rem', display: 'flex', alignItems: 'center' }}>
                                                    <MaterialIcon icon="place" className="iconMap" />
                                                    <span style={{ marginLeft: '.5rem' }}>{item.displayName.text}</span>
                                                </div>
                                            </MenuItem>
                                        ))}
                                    </div>
                                }
                            </div>
                        </div>
                        <div className='menuLine'>
                            <div className="leftTop" style={{ zIndex: 900 }}>
                                <MenuList
                                    id="app-header-menu"
                                    className="popup-list"
                                    anchorEl={this.state.anchorMN}
                                    open={Boolean(this.state.anchorMN)}
                                    onClose={() => this.setAnchor()()}
                                    style={{ marginRight: '2rem' }}
                                >
                                    {this.state.typeTool === 'create' &&
                                        <div>
                                            <MenuItem className="popup-item" onClick={event => { this.setState({ cPoly: true }); this.setAnchor()(); this.criaPoly() }}>
                                                <div style={{ paddingRight: '.7rem' }}>
                                                    <SvgIcon viewBox="80 9 16 42" className="iconMap" style={{ verticalAlign: 'middle' }} >
                                                        <path id="polygon" d="M 100 23.4 L 97 36.9 L 83 39.6 L 76 27 L 86 18 Z" />
                                                    </SvgIcon>
                                                    {res.CRIAR_POLY}
                                                </div>
                                            </MenuItem>
                                            <MenuItem className="popup-item" onClick={event => { this.setState({ cPoly: false }); this.setAnchor()(); this.criaCirculo() }}>
                                                <div style={{ paddingRight: '.7rem' }}>
                                                    <MaterialIcon icon="fiber_manual_record" className="iconMap" />
                                                    {res.CRIAR_CIRCULO}
                                                </div>
                                            </MenuItem>
                                        </div>
                                    }
                                    {this.state.typeTool === 'select' &&
                                        <div>
                                            <MenuItem className="popup-item" onClick={event => { this.setState({ sPoly: true }); this.setAnchor()(); this.selectorRet() }}>
                                                <div style={{ paddingRight: '.7rem' }}>
                                                    <SvgIcon viewBox="80 9 16 42" className="iconMap" style={{ verticalAlign: 'middle' }} >
                                                        <path id="polygon" d="M 99 19 L 99 39 L 78 39 L 78 19 z M 97 34 L 99 34 L 99 30 L 97 30 L 97 28 L 99 28 L 99 24 L 97 24 L 97 21 L 94 21 L 94 19 L 90 19 L 90 21 L 87 21 L 87 19 L 83 19 L 83 21 L 80 21 L 80 24 L 78 24 L 78 28 L 80 28 L 80 30 L 78 30 L 78 34 L 80 34 L 80 37 L 83 37 L 83 39 L 87 39 L 87 37 L 90 37 L 90 39 L 94 39 L 94 37 L 97 37 z" />
                                                    </SvgIcon>
                                                    {res.SELECAO_RET}
                                                </div>
                                            </MenuItem>
                                            <MenuItem className="popup-item" onClick={event => { this.setState({ sPoly: false }); this.setAnchor()(); this.selector() }}>
                                                <div style={{ paddingRight: '.7rem' }}>
                                                    <SvgIcon viewBox="80 9 16 42" className="iconMap" style={{ verticalAlign: 'middle' }} >
                                                        <path id="polygon" d="M 100.003 22.997 L 97 36.9 L 83 40 L 76 27 L 86 18 z M 96.109 31.635 L 98.032 32.276 L 99.037 27.914 L 97.244 27.441 L 98.012 24.052 L 93.677 22.653 L 94.387 21.017 L 89.851 19.328 L 89.103 20.931 L 86.352 19.81 L 84 22 L 82.872 20.815 L 79.821 23.569 L 80.914 24.761 L 78.146 27.234 L 80.103 31.055 L 78.578 31.723 L 80.773 35.814 L 81.876 35.026 L 83.672 38.046 L 85.935 37.489 L 86.25 39.282 L 91.621 38.046 L 91.033 36.229 L 95.53 35.204 z" />
                                                    </SvgIcon>
                                                    {res.SELECAO_LIVRE}
                                                </div>
                                            </MenuItem>
                                        </div>
                                    }
                                    {this.state.typeTool === 'type' &&
                                        <div>
                                            <MenuItem className="popup-item" onClick={event => { this.changeType(this.tabID[Number(this.state.tab)], 'N'); this.setAnchor()(); }}>
                                                <div style={{ paddingRight: '.7rem' }}>
                                                    <MaterialIcon icon="check" className="iconMap" />
                                                    {res.SET_N}
                                                </div>
                                            </MenuItem>
                                            <MenuItem className="popup-item" onClick={event => { this.changeType(this.tabID[Number(this.state.tab)], 'X'); this.setAnchor()(); }}>
                                                <div style={{ paddingRight: '.7rem' }}>
                                                    <MaterialIcon icon="close" className="iconMap" />
                                                    {res.SET_X}
                                                </div>
                                            </MenuItem>
                                            <MenuItem className="popup-item" onClick={event => { this.changeType(this.tabID[Number(this.state.tab)], 'T'); this.setAnchor()(); }}>
                                                <div style={{ paddingRight: '.7rem' }}>
                                                    <MaterialIcon icon="indeterminate_check_box" className="iconMap" />
                                                    {res.SET_T}
                                                </div>
                                            </MenuItem>
                                        </div>
                                    }
                                </MenuList>

                                <Button className="buttonS buttonMenu buttonMenuSmall" onClick={event => this.showMenu()}>
                                    <MaterialIcon icon="menu" className="iconMapF" />
                                </Button>
                                {this.state.cPoly ?
                                    < Button className={this.state.create ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} disabled={this.state.disable || this.state.split} onClick={event => this.criaPoly()} title={res.CRIAR_POLY}>
                                        <SvgIcon viewBox="79 18 21 26" className="iconMapP" >
                                            <path id="polygon" d="M 100 23.4 L 97 36.9 L 83 39.6 L 76 27 L 86 18 Z" />
                                        </SvgIcon>
                                    </Button> :
                                    <Button className={this.state.create_circle ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} disabled={this.state.disable || this.state.split} onClick={event => this.criaCirculo()} title={res.CRIAR_CIRCULO}>
                                        <MaterialIcon icon="fiber_manual_record" className="iconMap" />
                                    </Button>
                                }
                                <Button className={"buttonS buttonMenu buttonMenuPS"} onClick={this.setAnchor('create')}>
                                    <MaterialIcon icon="arrow_drop_down" className="iconMap" />
                                </Button>
                                {this.state.sPoly ?
                                    < Button className={this.state.selector ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} disabled={this.state.disable || this.state.split} onClick={event => this.selectorRet()} title={'Selector'}>
                                        <SvgIcon viewBox="79 18 21 26" className="iconMapP" >
                                            <path id="polygon" d="M 99 19 L 99 39 L 78 39 L 78 19 z M 97 34 L 99 34 L 99 30 L 97 30 L 97 28 L 99 28 L 99 24 L 97 24 L 97 21 L 94 21 L 94 19 L 90 19 L 90 21 L 87 21 L 87 19 L 83 19 L 83 21 L 80 21 L 80 24 L 78 24 L 78 28 L 80 28 L 80 30 L 78 30 L 78 34 L 80 34 L 80 37 L 83 37 L 83 39 L 87 39 L 87 37 L 90 37 L 90 39 L 94 39 L 94 37 L 97 37 z" />
                                        </SvgIcon>
                                    </Button> :
                                    <Button className={this.state.selector ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} disabled={this.state.disable || this.state.split} onClick={event => this.selector()} title={'Selector'}>
                                        <SvgIcon viewBox="79 18 21 26" className="iconMapP" >
                                            <path id="polygon" d="M 100.003 22.997 L 97 36.9 L 83 40 L 76 27 L 86 18 z M 96.109 31.635 L 98.032 32.276 L 99.037 27.914 L 97.244 27.441 L 98.012 24.052 L 93.677 22.653 L 94.387 21.017 L 89.851 19.328 L 89.103 20.931 L 86.352 19.81 L 84 22 L 82.872 20.815 L 79.821 23.569 L 80.914 24.761 L 78.146 27.234 L 80.103 31.055 L 78.578 31.723 L 80.773 35.814 L 81.876 35.026 L 83.672 38.046 L 85.935 37.489 L 86.25 39.282 L 91.621 38.046 L 91.033 36.229 L 95.53 35.204 z" />
                                        </SvgIcon>
                                    </Button>
                                }
                                <Button className={"buttonS buttonMenu buttonMenuPS"} onClick={this.setAnchor('select')}>
                                    <MaterialIcon icon="arrow_drop_down" className="iconMap" />
                                </Button>

                                <Button className={this.state.edit ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} disabled={!(this.state.sel_poly.length > 0) || this.state.disable || this.state.split} onClick={event => this.editPoly()} title={res.EDITAR_POLY}>
                                    <MaterialIcon icon="edit" className="iconMap" />
                                </Button>

                                <Button className={this.state.delete ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} disabled={(this.state.polygons.length === 0 && this.state.areas_client.length === 0) || this.state.disable || this.state.split} onClick={event => this.deletePoly()} title={res.DELETAR_POLY}>
                                    <MaterialIcon icon="delete" className="iconMap" />
                                </Button>
                                <Button className="buttonS buttonMenu" disabled={!(this.state.sel_poly.length > 0) || this.state.disable || this.state.split} onClick={event => this.showItem()} title={res.EDITAR_NOME}>
                                    <MaterialIcon icon="format_shapes" className="iconMap" />
                                </Button>
                                <Button className="buttonS buttonMenu" disabled={this.state.disable} onClick={event => this.openSplit()} title={res.CORTAR}>
                                    <MaterialIcon icon="label_off" className="iconMap" />
                                </Button>
                                {this.state.sel_poly.length > 1 &&
                                    <Button className="buttonS buttonMenu" disabled={this.getMergeAreas().length < 2 || this.state.disable || this.state.split} onClick={() => this.openMerge()} title={res.AGRUPAR}>
                                        <MaterialIcon icon="view_compact" className="iconMap" />
                                    </Button>
                                }
                                {this.state.sel_merge &&
                                    <Button className="buttonS buttonMenu" disabled={this.state.disable || this.state.split} onClick={event => this.desfazer()} title={res.DESFAZER}>
                                        <MaterialIcon icon="undo" className="iconMap" />
                                    </Button>
                                }
                                <Button className="buttonS buttonMenu" disabled={!(this.state.sel_poly.length === 1) || this.state.disable || this.state.split} onClick={event => this.showTrim()} title={'Buffer'}>
                                    <MaterialIcon icon="border_style" className="iconMap" />
                                </Button>
                                {(this.state.sel_poly.length === 1 || this.getManualAbPolygon()) &&
                                    <Button
                                        className={this.state.manualAbOpen ? "buttonS buttonMenuHL" : "buttonS buttonMenu"}
                                        disabled={!this.getManualAbPolygon() || this.state.disable || this.state.create || this.state.create_circle || this.state.create_waypoint || this.state.edit || this.state.delete || this.state.split || this.state.merge || this.state.selector}
                                        onClick={() => this.openManualAb()}
                                        title={res.RUMO_MANUAL}
                                    >
                                        <MaterialIcon icon="explore" className="iconMap" />
                                    </Button>}
                                {this.getChangePatternButton()}

                                {/* {(this.state.sel_poly.length === 1 && !this.state.sel_merge) &&
                                        <span>
                                            {!this.state.sel_x ?
                                                <Button className="buttonS buttonMenu" disabled={this.state.disable || this.state.split} onClick={event => this.changeType(this.tabID[Number(this.state.tab)])} title={res.SET_X}>
                                                    <MaterialIcon icon="close" className="iconMap" />
                                                </Button>
                                                :
                                                <Button className="buttonS buttonMenu" disabled={this.state.disable || this.state.split} onClick={event => this.changeType(this.tabID[Number(this.state.tab)])} title={res.SET_N}>
                                                    <MaterialIcon icon="check" className="iconMap" />
                                                </Button>
                                            }
                                        </span>
                                    } */}

                            </div>
                            <div className="rightTop">
                                <Button className={this.state.showWaypointTypes || this.state.create_waypoint ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} title={res.ADD_WAYPOINT} disabled={this.state.disable || this.state.edit || this.state.delete || this.state.split} onClick={event => this.openWaypointTypeMenu()}>
                                    <MaterialIcon icon="add_location_alt" className="iconMap" />
                                </Button>
                                <Button className="buttonS buttonMenu" type="polygon" title={res.IMPORTAR_AREAS} disabled={this.state.disable} onClick={() => { this.handleChangeTab('tab')(null, '0'); this.setState({ showImport: true }); }}>
                                    <MaterialIcon icon="attach_file" className="iconMap" />
                                </Button>
                                <Button className="buttonS buttonMenu" onClick={event => this.download()} disabled={((this.state.sel_poly.length > 0) ? false : true) || this.state.disable || this.state.downloading} title={res.BAIXAR_SELECIONADOS}>
                                    <MaterialIcon icon="save" className="iconMap" />
                                </Button>
                                <Button className="buttonS buttonMenu" onClick={event => { this.setState({ anchorPL: event.currentTarget }); }} disabled={((this.state.sel_poly.length > 0) ? false : true) || this.state.disable} title={'Enviar Selecionados'}>
                                    <SvgIcon viewBox="0 96 960 960" style={{ width: '1.7rem', height: '1.7rem', marginRight: '-.1rem' }}>
                                        <path d="M253.308 875.999q-80.877 0-137.092-56.562-56.214-56.562-56.214-137.13 0-74.384 49.538-129.614 49.538-55.231 122.461-62.23 11.923-81.693 77.577-145.039 65.653-63.346 148.346-63.346 18.23 0 31.807 10.423 13.576 10.423 13.576 27.653v304.77l87.231-87.615 32.615 32.999-142.538 142.153-142.152-142.153 32.614-32.999 86.847 87.615V324q-82.923 6.385-135.193 70.692Q270.462 459 270.462 534.385h-19.385q-60.044 0-102.868 42.615t-42.824 105.692q0 63.077 43.846 105.5t104.183 42.423h494.509q44.231 0 75.461-31.293 31.231-31.293 31.231-75.269 0-43.976-31.231-75.207-31.23-31.231-75.597-31.231h-62.095v-83.23q0-63-29.923-110.384-29.923-47.385-77.691-75.616v-49.999q70.614 28.616 111.806 93.308 41.192 64.691 41.192 142.691v37.847h12.308q65.461-2.385 111.038 40.999 45.577 43.385 45.577 110.692 0 62.461-44.808 107.268-44.807 44.808-107.268 44.808H253.308ZM480 555.539Z" />
                                    </SvgIcon>
                                </Button>
                                <Button className="buttonS buttonMenu" onClick={event => this.abrirPlanejamento()} disabled={((this.state.sel_poly.length > 0) ? false : true) || this.state.disable} title={res.AREA_SELECIONADA_PLANEJAMENTO}>
                                    <MaterialIcon icon="flight_takeoff" className="iconMap" />
                                </Button>
                                <Button className="buttonS buttonMenu" onClick={event => this.abrirOrdemServico()} disabled={((this.state.sel_poly.length > 0 || this.state.sel_runways.length > 0) ? false : true) || this.state.disable} title={res.AREA_SELECIONADA_OS}>
                                    <MaterialIcon icon="description" className="iconMap" />
                                </Button>
                                <Button className={this.state.ruler_a && this.ruler_p.type !== 'ab' ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} disabled={(this.state.create || this.state.edit || this.state.delete || this.state.split) || this.state.disable} onClick={event => this.regua()} title={res.REGUA}>
                                    <MaterialIcon icon="settings_ethernet" className="iconMap highlightSVG" />
                                </Button>
                                <Button className="buttonS buttonMenu" onClick={event => this.showGoto()} title={res.IR_PARA}>
                                    <MaterialIcon icon="search" className="iconMap" />
                                </Button>
                                <Button className="buttonS buttonMenu" disabled={this.state.sel_poly.length <= 0} onClick={event => { this.goto("sel_poly") }} title={res.SELECIONADO}>
                                    <SvgIcon viewBox="79 18 21 26" className="iconMapP" style={this.state.sel_poly.length <= 0 ? disabledButton : {}} >
                                        <path id="polygon" d="M 100 23.4 L 97 36.9 L 88 40 L 88 27 L 76 27 L 86 18 z M 76 29 L 86 29 L 86 40 L 83 40 Z" />
                                    </SvgIcon>
                                </Button>
                                <Button className="buttonS buttonMenu" onClick={event => { this.setState({ anchorAPO: event.currentTarget }); }} title={'Opções'}>
                                    <h2 style={{ marginLeft: '-.7rem', fontWeight: 'bold', transform: 'rotate(270deg)', marginTop: '.6rem', fontSize: '23px' }}>...</h2>
                                </Button>
                            </div>
                        </div>
                    </div>
                    <MenuList //Refresh MAP
                        id="app-options-menu"
                        className="popup-list"
                        anchorEl={this.state.anchorAPO}
                        open={Boolean(this.state.anchorAPO)}
                        onClose={(Event) => { this.setState({ anchorAPO: null }) }}
                    >
                        <MenuItem key={'apo1'} onClick={() => this.resetPolygons(true)} className="popup-item" >
                            {'Refresh MAP'}
                        </MenuItem>
                        <MenuItem
                            key="show-overlaps"
                            onClick={this.toggleOverlapVisibility}
                            disabled={this.state.showOverlaps === null}
                            role="menuitemcheckbox"
                            aria-checked={this.state.showOverlaps === true}
                            className="popup-item"
                        >
                            <Checkbox checked={this.state.showOverlaps === true} tabIndex={-1} disableRipple />
                            {'Exibir sobreposição'}
                        </MenuItem>
                        <MenuItem disabled className="popup-item" style={{ opacity: 1, fontSize: '.72rem', color: '#6b7785', minHeight: '1.8rem' }}>
                            {res.RENDERIZACAO_MAPA}
                        </MenuItem>
                        <MenuItem
                            key={'apo-render-light'}
                            onClick={() => this.setMapRenderPreference('light')}
                            className="popup-item"
                            style={{ display: 'grid', gridTemplateColumns: '1.2rem auto', alignItems: 'center' }}
                        >
                            <span>{this.state.mapRenderPreference === 'light' ? '✓' : ''}</span>
                            <span>
                                <span style={{ display: 'block' }}>{res.RENDERIZACAO_LEVE}</span>
                            </span>
                        </MenuItem>
                        <MenuItem
                            key={'apo-render-medium'}
                            onClick={() => this.setMapRenderPreference('medium')}
                            className="popup-item"
                            style={{ display: 'grid', gridTemplateColumns: '1.2rem auto', alignItems: 'center' }}
                        >
                            <span>{this.state.mapRenderPreference === 'medium' ? '✓' : ''}</span>
                            <span>
                                <span style={{ display: 'block' }}>{res.RENDERIZACAO_MEDIO}</span>
                            </span>
                        </MenuItem>
                        <MenuItem
                            key={'apo-render-heavy'}
                            onClick={() => this.setMapRenderPreference('heavy')}
                            className="popup-item"
                            style={{ display: 'grid', gridTemplateColumns: '1.2rem auto', alignItems: 'center' }}
                        >
                            <span>{this.state.mapRenderPreference === 'heavy' ? '✓' : ''}</span>
                            <span>
                                <span style={{ display: 'block' }}>{res.RENDERIZACAO_PESADO}</span>
                            </span>
                        </MenuItem>
                    </MenuList>
                    <MenuList //enviar areas
                        id="app-header-menu"
                        className="popup-list"
                        anchorEl={this.state.anchorPL}
                        open={Boolean(this.state.anchorPL)}
                        onClose={(Event) => { this.setState({ anchorPL: null }) }}
                    >
                        <DialogActions onKeyDown={(e) => e.stopPropagation()} style={{ width: '16rem' }}>
                            <TextField
                                id="nameR"
                                label={'Nome da Região'}
                                margin="none"
                                className="textI"
                                size="small"
                                fullWidth
                                onChange={this.handleChange('nameR')}
                                value={this.state.nameR}
                                error={this.state.nameR === ''}
                                onInput={(e) => {
                                    e.target.value = e.target.value.toString().slice(0, 45)
                                }}
                            />
                        </DialogActions>
                        {this.state.planes
                            .filter(item => item.id_dgps)
                            .map((item, key) => (
                                <MenuItem key={key + 'pl'} onClick={() => this.selectSendPlanes(item.id)} className="popup-item" style={{ minWidth: '10rem', display: 'grid', gridTemplateColumns: '3rem auto', justifyItems: 'center' }}>
                                    <Checkbox checked={this.state.selectedSendPlanes.indexOf(item.id) > -1}
                                    />
                                    {item.name}
                                </MenuItem>
                            ))}
                        <DialogActions>
                            <Button type="submit" disabled={this.state.selectedSendPlanes.length === 0 || this.state.nameR === ''} variant="contained" color={"primary"} onClick={e => { this.sendFile() }}>
                                {'Enviar'}
                            </Button>
                        </DialogActions>
                    </MenuList>
                    <div className={this.state.showWaypointTypes || this.state.create_waypoint ? "divContent floatDiv floatDivItens" : "sr-only"}>
                        {this.state.showWaypointTypes &&
                            <span>
                                <Button className="popUpButton" onClick={event => this.createWaypoint('H')} title={res.HANGAR}>
                                    <img src={HangarIcon} alt="hangar" draggable="false" style={{ width: '1.8rem', height: '1.8rem' }} />
                                </Button>
                                <Button className="popUpButton" onClick={event => this.createWaypoint('P')} title={res.PISTA}>
                                    <img src={markerIconGreen} alt="pista" draggable="false" style={{ width: '1.6rem', height: '2rem' }} />
                                </Button>
                            </span>
                        }
                        {this.state.create_waypoint &&
                            <TextField
                                id="waypointName"
                                label={this.props.res.NOME}
                                margin="none"
                                className="textI"
                                size="small"
                                fullWidth
                                onChange={this.handleChange('waypointName')}
                                value={this.state.waypointName}
                                onInput={(e) => {
                                    e.target.value = e.target.value.toString().slice(0, 45)
                                }}
                            />
                        }
                        <Button size="small" className="popUpButton" onClick={event => this.cancelCreateWaypoint()}>
                            {this.props.res.CANCELAR}
                        </Button>
                    </div>
                    <div className="wrapperMap">{/* Map Div */}
                        <div style={{ width: '100%', height: '100%', position: 'absolute', zIndex: '1111', display: !this.state.disable ? 'none' : 'block' }}></div>
                        <div id="mapid"></div>
                        {(this.state.savingImportedAreas || (this.state.loadingAreaSummaries && !this.state.loadingClientData)) &&
                            <div style={{
                                position: 'absolute',
                                top: '.75rem',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                zIndex: 1102,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '.45rem',
                                padding: '.4rem .75rem',
                                borderRadius: '1rem',
                                backgroundColor: 'rgba(255,255,255,.96)',
                                boxShadow: '0 1px 5px rgba(0,0,0,.25)',
                                color: '#52606d',
                                fontSize: '.8rem',
                                pointerEvents: 'none'
                            }}>
                                <CircularProgress size={16} />
                                <span>{this.state.savingImportedAreas ? 'Salvando áreas…' : 'Carregando áreas…'}</span>
                            </div>
                        }
                        <div className="tool-tip-H" style={{
                            position: 'absolute',
                            right: '1rem',
                            bottom: '1.8rem',
                            zIndex: 1100,
                            textAlign: 'right',
                            color: '#edb83b'
                        }}>
                            <div><b>{res.LAT}:</b> <span ref={node => { this.mapCenterLatNode = node; }}>{this.state.lat ? this.formatCoordText(this.state.lat.value, 'latitude') : ''}</span></div>
                            <div><b>{res.LNG}:</b> <span ref={node => { this.mapCenterLngNode = node; }}>{this.state.lng ? this.formatCoordText(this.state.lng.value, 'longitude') : ''}</span></div>
                        </div>
                        <div className="zoomB">{/* Zoom Buttons */}
                            <Button className="buttonS buttonMenu" onClick={event => this.zoomInL()}>
                                <MaterialIcon icon="add" className="iconMap" />
                            </Button>
                            <Button className="buttonS buttonMenu" onClick={event => this.zoomOutL()}>
                                <MaterialIcon icon="remove" className="iconMap" />
                            </Button>
                        </div>
                        <div className={(!this.state.merge && this.state.split) || this.state.edit || this.state.delete ? "divContent floatDiv floatDivItens" : "sr-only"}>
                            <label className="textDiv">
                                {res.CLICK_DESFAZER}
                            </label>
                            <Button size="small" className="popUpButton" onClick={event => this.state.split ? this.useSplitLine() : this.state.edit ? this.saveEdit() : this.saveDelete()}>
                                {res.SALVAR}
                            </Button>
                            <Button size="small" className="popUpButton" onClick={event => this.state.split ? this.cancelSplit() : this.state.edit ? this.cancelEdit() : this.cancelDelete()}>
                                {res.CANCELAR}
                            </Button>
                        </div>
                        <div className={this.state.edit_name || this.state.create || this.state.create_circle ? "divContent floatDiv floatDivItens popUpF" : "sr-only"}>
                            <div style={{ overflowY: 'auto' }}>{/* Formulário de edição de nome */}
                                {this.state.create || this.state.create_circle ?
                                    <TextField
                                        id="name"
                                        label={res.NOME}
                                        margin="none"
                                        className="textI"
                                        size="small"
                                        fullWidth
                                        onChange={this.handleChange('nameP')}
                                        value={this.state.nameP}
                                        error={this.state.valid_nameP}
                                        onKeyDown={e => {
                                            if (e.keyCode === 13) { this.saveCreate() }
                                        }}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.toString().slice(0, 45)
                                        }}
                                    />
                                    :
                                    this.state.namesC
                                        .map((item, index) => {
                                            return (
                                                <TextField
                                                    key={index + '_names'}
                                                    id="namePoly"
                                                    label={res.NOME}
                                                    margin="none"
                                                    className="textI"
                                                    size="small"
                                                    fullWidth
                                                    onChange={this.handleChangeNameList(item.guid)}
                                                    value={item.name}
                                                    error={!item.valid}
                                                    onKeyDown={e => {
                                                        if (e.keyCode === 13) { this.saveItem() }
                                                    }}
                                                    onInput={(e) => {
                                                        e.target.value = e.target.value.toString().slice(0, 45)
                                                    }}
                                                />
                                            )
                                        })

                                }
                            </div>
                            <div className="divForm">
                                {!this.state.create_circle &&
                                    <Button size="small" className="popUpButton"
                                        disabled={
                                            !this.state.valid_nameP
                                            || this.state.namesC.filter(item => (!item.valid)).length > 0}
                                        onClick={event =>
                                            this.state.create
                                                ? this.saveCreate()
                                                : this.saveItem()}>
                                        {res.SALVAR}
                                    </Button>
                                }
                                {this.state.create &&
                                    <Button size="small" className="popUpButton" onClick={event => this.deleteLastCreate()}>
                                        {res.DESFAZER}
                                    </Button>
                                }
                                <Button size="small" className="popUpButton"
                                    onClick={event =>
                                        this.state.create
                                            ? this.cancelCreate()
                                            : this.state.create_circle
                                                ? this.cancelCreateCirculo()
                                                : this.cancelItem()}//fix
                                >
                                    {res.CANCELAR}
                                </Button>
                            </div>
                        </div>
                        {this.state.merge &&
                            <div className="divContent floatW divIA">
                                <div>
                                    <FormControl className="notTooBig notTooClose">
                                        <InputLabel htmlFor="age-simple">{this.state.split ? '' : res.AGRUPAR}</InputLabel>
                                        <Select
                                            value={this.state.type}
                                            onChange={event => this.openMerge(event.target.value)}
                                            inputProps={{
                                                id: 'type',
                                            }}
                                        >
                                            {!this.state.split && <MenuItem key="2" value="2">{res.LIGAR_AREA}</MenuItem>}
                                            {!this.state.split && <MenuItem key="5" value="5">{res.ANEXAR_AREA}</MenuItem>}
                                            {this.state.split && <MenuItem key="6" value="6">Split Área</MenuItem>}
                                        </Select>
                                    </FormControl>
                                </div>
                                {(this.state.type === '3' || this.state.type === '5' || this.state.type === '6') &&
                                    <div className="">
                                        <TextField
                                            id="name"
                                            type="number"
                                            label={res.TAMANHO}
                                            margin="normal"
                                            className="textI"
                                            inputProps={{ min: 0, step: 0.01, style: { textAlign: 'right' } }}
                                            onChange={this.handleChange('gap_size')}
                                            value={this.state.gap_size}
                                            onKeyDown={e => {
                                                if (e.keyCode === 13) { this.junta(); }
                                            }}
                                        />
                                        <span style={{ position: 'relative', bottom: '-1.3rem' }}>  {res.METROS}</span>
                                    </div>}
                                <div style={{ padding: '1rem' }}></div>
                                {!this.state.split
                                    ? <Button size="small" className="popUpButton" disabled={this.getMergeAreas().length < 2} onClick={event => { this.junta() }}>
                                        {res.SALVAR}
                                    </Button>
                                    : <Button size="small" className="popUpButton" onClick={event => { this.split() }}>
                                        {'SPLIT'}
                                    </Button>
                                }
                                <Button size="small" className="popUpButton" onClick={event => { this.state.split ? this.cancelSplit() : this.setState({ merge: false }) }}>
                                    {res.CANCELAR}
                                </Button>
                            </div>}
                        {this.state.goto &&
                            <div className="divContent floatW divS" style={{ width: '15rem' }}>
                                <div>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <span>{res.IRPARA}</span>

                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Button size="small" className="popUpButton blButton" disabled={this.state.sel_poly.length <= 0} onClick={event => this.goto("sel_poly")} title={res.SELECIONADO}>
                                                <SvgIcon viewBox="79 18 21 26" className="iconMapP" style={this.state.sel_poly.length <= 0 ? disabledButton : {}} >
                                                    <path id="polygon" d="M 100 23.4 L 97 36.9 L 88 40 L 88 27 L 76 27 L 86 18 z M 76 29 L 86 29 L 86 40 L 83 40 Z" />
                                                </SvgIcon>
                                            </Button>

                                            <Button size="small" className="popUpButton blButton" disabled={(this.state.polygons.length === 0 && this.state.areas_client.length === 0)} onClick={event => this.goto("poly")} title={res.POLIGONO}>
                                                <SvgIcon viewBox="79 18 21 26" className="iconMapP" style={(this.state.polygons.length === 0 && this.state.areas_client.length === 0) ? disabledButton : {}} >
                                                    <path id="polygon" d="M 100 23.4 L 97 36.9 L 83 39.6 L 76 27 L 86 18 Z" />
                                                </SvgIcon>
                                            </Button>

                                            <Button size="small" className="popUpButton blButton" disabled={this.state.home === Config.place} onClick={event => this.goto("home")} title={res.REFERENCIA}>
                                                <MaterialIcon icon="home" className="iconMap" />
                                            </Button>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                        <Button
                                            size="small"
                                            className="popUpButton blButton"
                                            onClick={this.toggleCoordMode}
                                            title={(this.state.coordMode === 'dms') ? res.COORDENADA_DD : res.COORDENADA_DMS}
                                        >
                                            <MaterialIcon icon="swap_horiz" className="iconMap" />
                                        </Button>

                                        <Button
                                            size="small"
                                            className="popUpButton blButton"
                                            disabled={!this.waypointMarker}
                                            onClick={this.gotoWaypoint}
                                            title="Ir para o Pin"
                                        >
                                            <RoomIcon className="iconMap" />
                                        </Button>
                                    </div>
                                </div>

                                <TextField
                                    id="lat"
                                    label="LAT"
                                    margin="normal"
                                    size='small'
                                    error={this.state.lat.error}
                                    onChange={this.handleChangeCoordinates('lat')}
                                    value={this.state.lat.input}
                                    placeholder={this.formatCoordText(this.state.lat.value, 'latitude')}
                                    onKeyDown={e => {
                                        if (e.keyCode === 13) { this.goto() }
                                    }}
                                />
                                <TextField
                                    id="lng"
                                    label="LNG"
                                    margin="normal"
                                    size='small'
                                    error={this.state.lng.error}
                                    onChange={this.handleChangeCoordinates('lng')}
                                    value={this.state.lng.input}
                                    placeholder={this.formatCoordText(this.state.lng.value, 'longitude')}
                                    onKeyDown={e => {
                                        if (e.keyCode === 13) { this.goto() }
                                    }}
                                />
                                <div className="divForm">
                                    <Button size="small" className="popUpButton" onClick={event => this.goto()}>
                                        {res.IR}
                                    </Button>
                                    <Button size="small" className="popUpButton" onClick={event => this.setState({ goto: false })}>
                                        {res.CANCELAR}
                                    </Button>
                                </div>
                            </div>}
                        {this.state.label &&
                            <div className='tool-tip-H'
                                style={{
                                    right: '1rem',
                                    position: 'absolute',
                                    bottom: '0.3rem',
                                    zIndex: 1099,
                                    textAlign: 'right',
                                    color: '#edb83b'
                                }}>
                                {this.state.label_text}
                            </div>}
                        {this.state.manualAbOpen &&
                            <div style={{ width: '16rem' }} className="divContent floatW divI">
                                <form onSubmit={event => { event.preventDefault(); this.saveManualAbAngle(); }}>
                                    <div>
                                        <TextField
                                            id="angulo"
                                            label={res.ANGULO}
                                            value={this.state.manualAbAngle}
                                            onChange={event => this.setState({ manualAbAngle: event.target.value })}
                                            type="number"
                                            style={{ width: '8rem' }}
                                            inputProps={{ step: 'any' }}
                                            InputLabelProps={{ shrink: true }}
                                            margin="normal"
                                        />
                                        <Button
                                            style={{ marginTop: '1.8rem', marginLeft: '.4rem' }}
                                            className={this.state.ruler_a && this.ruler_p.type === 'ab' ? "buttonS buttonMenuHL" : "buttonS buttonMenu"}
                                            onClick={() => this.regua(null, 'ab')}
                                            title={res.RUMO_MANUAL}
                                        >
                                            <MaterialIcon icon="edit" className="iconMap" />
                                        </Button>
                                    </div>
                                    <div style={{ padding: '1rem' }}></div>
                                    <Button size="small" className="popUpButton" type="button" onClick={() => this.saveManualAbAngle()}>{res.SALVAR}</Button>
                                    <Button size="small" className="popUpButton" type="button" onClick={() => this.deleteManualAb()}
                                        disabled={!this.parseAreaAb(this.getManualAbPolygon()?.ab, 'N')}>{res.EXCLUIR}</Button>
                                    <Button size="small" className="popUpButton" onClick={() => this.cancelManualAb()}>{res.CANCELAR}</Button>
                                </form>
                            </div>}
                        {this.state.showTrim &&
                            <div style={{ width: '16rem' }} className="divContent floatW divI">
                                <form onSubmit={(e) => e.preventDefault()}>
                                    <div style={{ padding: '.2rem 1.5rem' }}>
                                        <FormControl fullWidth>
                                            <InputLabel id="refresh-interval-label" style={{ fontSize: '0.875rem' }}>
                                                {res.TRIM_OPERATION_TYPE}
                                            </InputLabel>
                                            <Select
                                                value={this.state.sel_oper}
                                                fullWidth
                                                onChange={this.handleChangeTrim('sel_oper')}
                                                inputProps={{
                                                    id: 'sel_oper',
                                                }}
                                            >
                                                <MenuItem key={0} value={'new'}>{res.TRIM_NEW_AREA}</MenuItem>
                                                <MenuItem key={1} value={'merge'}>{res.TRIM_MERGE_AREA}</MenuItem>
                                                <MenuItem key={2} value={'reduce'}>{res.TRIM_REDUCE_AREA}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{ padding: '.2rem 1.5rem' }}>
                                        <FormControl fullWidth>
                                            <InputLabel id="refresh-interval-label" style={{ fontSize: '0.875rem' }}>
                                                {res.TIPO_SELECAO}
                                            </InputLabel>
                                            <Select
                                                value={this.state.sel_trim}
                                                fullWidth
                                                onChange={this.handleChangeTrim('sel_trim')}
                                                inputProps={{
                                                    id: 'sel_trim',
                                                }}
                                            >
                                                <MenuItem key={0} value={'poly'}>{res.POLY}</MenuItem>
                                                <MenuItem key={1} value={'point'}>{res.POINTS}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div style={{ padding: '.2rem 1.5rem' }}>
                                        <FormControl fullWidth>
                                            <InputLabel id="refresh-interval-label" style={{ fontSize: '0.875rem' }}>
                                                {res.TIPO_GERACAO}
                                            </InputLabel>
                                            <Select
                                                value={this.state.type_trim}
                                                fullWidth
                                                onChange={this.handleChangeTrim('type_trim')}
                                                disabled={this.state.sel_oper !== 'new'}
                                                inputProps={{
                                                    id: 'type_trim',
                                                }}
                                            >
                                                <MenuItem key={0} value={'all'}>{res.TRIM_ALL}</MenuItem>
                                                <MenuItem key={1} value={'in'}>{res.TRIM_IN}</MenuItem>
                                                <MenuItem key={2} value={'out'}>{res.TRIM_OUT}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div>
                                        <TextField
                                            id="trim_size"
                                            label={tools.replaceString(res._DISTANCIA_BORDA_, Units.getLengthUnit(res))}
                                            value={Units.convertLength(this.state.trim_size, 'm', res)}
                                            onChange={event => {
                                                if (!isNaN(this.state.trim_size) && Number(this.state.trim_size) > 1)
                                                    this.handleChangeTrim('trim_size')(event);
                                            }}
                                            type="number"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            error={Number(this.state.trim_size) === 0}
                                            margin="normal"
                                            onKeyDown={e => {
                                                if (e.keyCode === 13 && Number(e.target.value) > 0) { this.saveTrim() } else return;
                                            }}
                                            onInput={(e) => {
                                                e.target.value = Number(e.target.value) > 0 ? Number(e.target.value) : 0;
                                            }}

                                        />
                                    </div>
                                    <div style={{ padding: '1rem' }}></div>
                                    <Button size="small" className="popUpButton" disabled={this.state.trim_size === 0 || (!this.trim_poly && this.state.sel_trim === 'point')} onClick={event => this.saveTrim()}>
                                        {res.SALVAR}
                                    </Button>
                                    <Button size="small" className="popUpButton" onClick={event => this.cancelTrim()}>
                                        {res.CANCELAR}
                                    </Button>
                                </form>
                            </div>
                        }
                    </div>
                </div>
                {this.mountColorPickerDialog()}
            </div >
        );
    };
}

const TextFields1 = EditDraw;

const Box = (props) => {
    const { link, res } = props;
    let { local } = useParams();
    return (
        <div className="rowPMap maxHMap">
            <TextFields1 link={link} local={local} res={res} />
        </div>)
}

export default Box;
